function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7949"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7949"] = parcelRequire;
}
var $adc7cb3c45508c7c$var$hi = Object.defineProperty;
var $adc7cb3c45508c7c$var$o = (r, t)=>$adc7cb3c45508c7c$var$hi(r, "name", {
        value: t,
        configurable: !0
    });
var $adc7cb3c45508c7c$var$cr = (()=>{
    for(var r = new Uint8Array(128), t = 0; t < 64; t++)r[t < 26 ? t + 65 : t < 52 ? t + 71 : t < 62 ? t - 4 : t * 4 - 205] = t;
    return (u)=>{
        for(var w = u.length, S = new Uint8Array((w - (u[w - 1] == "=") - (u[w - 2] == "=")) * 3 / 4 | 0), B = 0, $ = 0; B < w;){
            var j = r[u.charCodeAt(B++)], H = r[u.charCodeAt(B++)], ee = r[u.charCodeAt(B++)], ae = r[u.charCodeAt(B++)];
            S[$++] = j << 2 | H >> 4, S[$++] = H << 4 | ee >> 2, S[$++] = ee << 6 | ae;
        }
        return S;
    };
})();
function $adc7cb3c45508c7c$var$Ee(r) {
    return r * Math.PI / 180;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Ee, "deg2rad");
function $adc7cb3c45508c7c$var$Ze(r) {
    return r * 180 / Math.PI;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Ze, "rad2deg");
function $adc7cb3c45508c7c$var$Pe(r, t, u) {
    return t > u ? $adc7cb3c45508c7c$var$Pe(r, u, t) : Math.min(Math.max(r, t), u);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Pe, "clamp");
function $adc7cb3c45508c7c$var$Se(r, t, u) {
    if (typeof r == "number" && typeof t == "number") return r + (t - r) * u;
    if (r instanceof $adc7cb3c45508c7c$var$y && t instanceof $adc7cb3c45508c7c$var$y) return r.lerp(t, u);
    if (r instanceof $adc7cb3c45508c7c$var$q && t instanceof $adc7cb3c45508c7c$var$q) return r.lerp(t, u);
    throw new Error(`Bad value for lerp(): ${r}, ${t}. Only number, Vec2 and Color is supported.`);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Se, "lerp");
function $adc7cb3c45508c7c$var$Nt(r, t, u, w, S) {
    return w + (r - t) / (u - t) * (S - w);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Nt, "map");
function $adc7cb3c45508c7c$var$hr(r, t, u, w, S) {
    return $adc7cb3c45508c7c$var$Pe($adc7cb3c45508c7c$var$Nt(r, t, u, w, S), w, S);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$hr, "mapc");
var $adc7cb3c45508c7c$var$y = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Vec2");
    })();
    x = 0;
    y = 0;
    constructor(t = 0, u = t){
        this.x = t, this.y = u;
    }
    static fromAngle(t) {
        let u = $adc7cb3c45508c7c$var$Ee(t);
        return new r(Math.cos(u), Math.sin(u));
    }
    static LEFT = new r(-1, 0);
    static RIGHT = new r(1, 0);
    static UP = new r(0, -1);
    static DOWN = new r(0, 1);
    clone() {
        return new r(this.x, this.y);
    }
    add(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return new r(this.x + u.x, this.y + u.y);
    }
    sub(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return new r(this.x - u.x, this.y - u.y);
    }
    scale(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return new r(this.x * u.x, this.y * u.y);
    }
    dist(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return this.sub(u).len();
    }
    sdist(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return this.sub(u).slen();
    }
    len() {
        return Math.sqrt(this.dot(this));
    }
    slen() {
        return this.dot(this);
    }
    unit() {
        let t = this.len();
        return t === 0 ? new r(0) : this.scale(1 / t);
    }
    normal() {
        return new r(this.y, -this.x);
    }
    reflect(t) {
        return this.sub(t.scale(2 * this.dot(t)));
    }
    project(t) {
        return t.scale(t.dot(this) / t.len());
    }
    reject(t) {
        return this.sub(this.project(t));
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    angle(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return $adc7cb3c45508c7c$var$Ze(Math.atan2(this.y - u.y, this.x - u.x));
    }
    angleBetween(...t) {
        let u = $adc7cb3c45508c7c$var$T(...t);
        return $adc7cb3c45508c7c$var$Ze(Math.atan2(this.cross(u), this.dot(u)));
    }
    lerp(t, u) {
        return new r($adc7cb3c45508c7c$var$Se(this.x, t.x, u), $adc7cb3c45508c7c$var$Se(this.y, t.y, u));
    }
    slerp(t, u) {
        let w = this.dot(t), S = this.cross(t), B = Math.atan2(S, w);
        return this.scale(Math.sin((1 - u) * B)).add(t.scale(Math.sin(u * B))).scale(1 / S);
    }
    isZero() {
        return this.x === 0 && this.y === 0;
    }
    toFixed(t) {
        return new r(Number(this.x.toFixed(t)), Number(this.y.toFixed(t)));
    }
    transform(t) {
        return t.multVec2(this);
    }
    eq(t) {
        return this.x === t.x && this.y === t.y;
    }
    bbox() {
        return new $adc7cb3c45508c7c$var$le(this, 0, 0);
    }
    toString() {
        return `vec2(${this.x.toFixed(2)}, ${this.y.toFixed(2)})`;
    }
};
function $adc7cb3c45508c7c$var$T(...r) {
    if (r.length === 1) {
        if (r[0] instanceof $adc7cb3c45508c7c$var$y) return new $adc7cb3c45508c7c$var$y(r[0].x, r[0].y);
        if (Array.isArray(r[0]) && r[0].length === 2) return new $adc7cb3c45508c7c$var$y(...r[0]);
    }
    return new $adc7cb3c45508c7c$var$y(...r);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$T, "vec2");
var $adc7cb3c45508c7c$var$q = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Color");
    })();
    r = 255;
    g = 255;
    b = 255;
    constructor(t, u, w){
        this.r = $adc7cb3c45508c7c$var$Pe(t, 0, 255), this.g = $adc7cb3c45508c7c$var$Pe(u, 0, 255), this.b = $adc7cb3c45508c7c$var$Pe(w, 0, 255);
    }
    static fromArray(t) {
        return new r(t[0], t[1], t[2]);
    }
    static fromHex(t) {
        if (typeof t == "number") return new r(t >> 16 & 255, t >> 8 & 255, t >> 0 & 255);
        if (typeof t == "string") {
            let u = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
            return new r(parseInt(u[1], 16), parseInt(u[2], 16), parseInt(u[3], 16));
        } else throw new Error("Invalid hex color format");
    }
    static fromHSL(t, u, w) {
        if (u == 0) return new r(255 * w, 255 * w, 255 * w);
        let S = $adc7cb3c45508c7c$var$o((ae, U, X)=>(X < 0 && (X += 1), X > 1 && (X -= 1), X < 1 / 6 ? ae + (U - ae) * 6 * X : X < 0.5 ? U : X < 2 / 3 ? ae + (U - ae) * (2 / 3 - X) * 6 : ae), "hue2rgb"), B = w < .5 ? w * (1 + u) : w + u - w * u, $ = 2 * w - B, j = S($, B, t + 1 / 3), H = S($, B, t), ee = S($, B, t - 1 / 3);
        return new r(Math.round(j * 255), Math.round(H * 255), Math.round(ee * 255));
    }
    static RED = new r(255, 0, 0);
    static GREEN = new r(0, 255, 0);
    static BLUE = new r(0, 0, 255);
    static YELLOW = new r(255, 255, 0);
    static MAGENTA = new r(255, 0, 255);
    static CYAN = new r(0, 255, 255);
    static WHITE = new r(255, 255, 255);
    static BLACK = new r(0, 0, 0);
    clone() {
        return new r(this.r, this.g, this.b);
    }
    lighten(t) {
        return new r(this.r + t, this.g + t, this.b + t);
    }
    darken(t) {
        return this.lighten(-t);
    }
    invert() {
        return new r(255 - this.r, 255 - this.g, 255 - this.b);
    }
    mult(t) {
        return new r(this.r * t.r / 255, this.g * t.g / 255, this.b * t.b / 255);
    }
    lerp(t, u) {
        return new r($adc7cb3c45508c7c$var$Se(this.r, t.r, u), $adc7cb3c45508c7c$var$Se(this.g, t.g, u), $adc7cb3c45508c7c$var$Se(this.b, t.b, u));
    }
    eq(t) {
        return this.r === t.r && this.g === t.g && this.b === t.b;
    }
    toString() {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }
    toHex() {
        return "#" + (16777216 + (this.r << 16) + (this.g << 8) + this.b).toString(16).slice(1);
    }
};
function $adc7cb3c45508c7c$var$J(...r) {
    if (r.length === 0) return new $adc7cb3c45508c7c$var$q(255, 255, 255);
    if (r.length === 1) {
        if (r[0] instanceof $adc7cb3c45508c7c$var$q) return r[0].clone();
        if (typeof r[0] == "string") return $adc7cb3c45508c7c$var$q.fromHex(r[0]);
        if (Array.isArray(r[0]) && r[0].length === 3) return $adc7cb3c45508c7c$var$q.fromArray(r[0]);
    }
    return new $adc7cb3c45508c7c$var$q(...r);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$J, "rgb");
var $adc7cb3c45508c7c$var$dr = $adc7cb3c45508c7c$var$o((r, t, u)=>$adc7cb3c45508c7c$var$q.fromHSL(r, t, u), "hsl2rgb"), $adc7cb3c45508c7c$var$ie = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Quad");
    })();
    x = 0;
    y = 0;
    w = 1;
    h = 1;
    constructor(t, u, w, S){
        this.x = t, this.y = u, this.w = w, this.h = S;
    }
    scale(t) {
        return new r(this.x + this.w * t.x, this.y + this.h * t.y, this.w * t.w, this.h * t.h);
    }
    pos() {
        return new $adc7cb3c45508c7c$var$y(this.x, this.y);
    }
    clone() {
        return new r(this.x, this.y, this.w, this.h);
    }
    eq(t) {
        return this.x === t.x && this.y === t.y && this.w === t.w && this.h === t.h;
    }
    toString() {
        return `quad(${this.x}, ${this.y}, ${this.w}, ${this.h})`;
    }
};
function $adc7cb3c45508c7c$var$oe(r, t, u, w) {
    return new $adc7cb3c45508c7c$var$ie(r, t, u, w);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$oe, "quad");
var $adc7cb3c45508c7c$var$be = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Mat4");
    })();
    m = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    constructor(t){
        t && (this.m = t);
    }
    static translate(t) {
        return new r([
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            t.x,
            t.y,
            0,
            1
        ]);
    }
    static scale(t) {
        return new r([
            t.x,
            0,
            0,
            0,
            0,
            t.y,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateX(t) {
        t = $adc7cb3c45508c7c$var$Ee(-t);
        let u = Math.cos(t), w = Math.sin(t);
        return new r([
            1,
            0,
            0,
            0,
            0,
            u,
            -w,
            0,
            0,
            w,
            u,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateY(t) {
        t = $adc7cb3c45508c7c$var$Ee(-t);
        let u = Math.cos(t), w = Math.sin(t);
        return new r([
            u,
            0,
            w,
            0,
            0,
            1,
            0,
            0,
            -w,
            0,
            u,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateZ(t) {
        t = $adc7cb3c45508c7c$var$Ee(-t);
        let u = Math.cos(t), w = Math.sin(t);
        return new r([
            u,
            -w,
            0,
            0,
            w,
            u,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    translate(t) {
        return this.m[12] += this.m[0] * t.x + this.m[4] * t.y, this.m[13] += this.m[1] * t.x + this.m[5] * t.y, this.m[14] += this.m[2] * t.x + this.m[6] * t.y, this.m[15] += this.m[3] * t.x + this.m[7] * t.y, this;
    }
    scale(t) {
        return this.m[0] *= t.x, this.m[4] *= t.y, this.m[1] *= t.x, this.m[5] *= t.y, this.m[2] *= t.x, this.m[6] *= t.y, this.m[3] *= t.x, this.m[7] *= t.y, this;
    }
    rotate(t) {
        t = $adc7cb3c45508c7c$var$Ee(-t);
        let u = Math.cos(t), w = Math.sin(t), S = this.m[0], B = this.m[1], $ = this.m[4], j = this.m[5];
        return this.m[0] = S * u + B * w, this.m[1] = -S * w + B * u, this.m[4] = $ * u + j * w, this.m[5] = -$ * w + j * u, this;
    }
    mult(t) {
        let u = [];
        for(let w = 0; w < 4; w++)for(let S = 0; S < 4; S++)u[w * 4 + S] = this.m[0 + S] * t.m[w * 4 + 0] + this.m[4 + S] * t.m[w * 4 + 1] + this.m[8 + S] * t.m[w * 4 + 2] + this.m[12 + S] * t.m[w * 4 + 3];
        return new r(u);
    }
    multVec2(t) {
        return new $adc7cb3c45508c7c$var$y(t.x * this.m[0] + t.y * this.m[4] + this.m[12], t.x * this.m[1] + t.y * this.m[5] + this.m[13]);
    }
    getTranslation() {
        return new $adc7cb3c45508c7c$var$y(this.m[12], this.m[13]);
    }
    getScale() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let t = this.m[0] * this.m[5] - this.m[1] * this.m[4], u = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return new $adc7cb3c45508c7c$var$y(u, t / u);
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let t = this.m[0] * this.m[5] - this.m[1] * this.m[4], u = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return new $adc7cb3c45508c7c$var$y(t / u, u);
        } else return new $adc7cb3c45508c7c$var$y(0, 0);
    }
    getRotation() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let t = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return $adc7cb3c45508c7c$var$Ze(this.m[1] > 0 ? Math.acos(this.m[0] / t) : -Math.acos(this.m[0] / t));
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let t = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return $adc7cb3c45508c7c$var$Ze(Math.PI / 2 - (this.m[5] > 0 ? Math.acos(-this.m[4] / t) : -Math.acos(this.m[4] / t)));
        } else return 0;
    }
    getSkew() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let t = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return new $adc7cb3c45508c7c$var$y(Math.atan(this.m[0] * this.m[4] + this.m[1] * this.m[5]) / (t * t), 0);
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let t = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return new $adc7cb3c45508c7c$var$y(0, Math.atan(this.m[0] * this.m[4] + this.m[1] * this.m[5]) / (t * t));
        } else return new $adc7cb3c45508c7c$var$y(0, 0);
    }
    invert() {
        let t = [], u = this.m[10] * this.m[15] - this.m[14] * this.m[11], w = this.m[9] * this.m[15] - this.m[13] * this.m[11], S = this.m[9] * this.m[14] - this.m[13] * this.m[10], B = this.m[8] * this.m[15] - this.m[12] * this.m[11], $ = this.m[8] * this.m[14] - this.m[12] * this.m[10], j = this.m[8] * this.m[13] - this.m[12] * this.m[9], H = this.m[6] * this.m[15] - this.m[14] * this.m[7], ee = this.m[5] * this.m[15] - this.m[13] * this.m[7], ae = this.m[5] * this.m[14] - this.m[13] * this.m[6], U = this.m[4] * this.m[15] - this.m[12] * this.m[7], X = this.m[4] * this.m[14] - this.m[12] * this.m[6], d = this.m[5] * this.m[15] - this.m[13] * this.m[7], W = this.m[4] * this.m[13] - this.m[12] * this.m[5], fe = this.m[6] * this.m[11] - this.m[10] * this.m[7], De = this.m[5] * this.m[11] - this.m[9] * this.m[7], v = this.m[5] * this.m[10] - this.m[9] * this.m[6], ce = this.m[4] * this.m[11] - this.m[8] * this.m[7], ge = this.m[4] * this.m[10] - this.m[8] * this.m[6], re = this.m[4] * this.m[9] - this.m[8] * this.m[5];
        t[0] = this.m[5] * u - this.m[6] * w + this.m[7] * S, t[4] = -(this.m[4] * u - this.m[6] * B + this.m[7] * $), t[8] = this.m[4] * w - this.m[5] * B + this.m[7] * j, t[12] = -(this.m[4] * S - this.m[5] * $ + this.m[6] * j), t[1] = -(this.m[1] * u - this.m[2] * w + this.m[3] * S), t[5] = this.m[0] * u - this.m[2] * B + this.m[3] * $, t[9] = -(this.m[0] * w - this.m[1] * B + this.m[3] * j), t[13] = this.m[0] * S - this.m[1] * $ + this.m[2] * j, t[2] = this.m[1] * H - this.m[2] * ee + this.m[3] * ae, t[6] = -(this.m[0] * H - this.m[2] * U + this.m[3] * X), t[10] = this.m[0] * d - this.m[1] * U + this.m[3] * W, t[14] = -(this.m[0] * ae - this.m[1] * X + this.m[2] * W), t[3] = -(this.m[1] * fe - this.m[2] * De + this.m[3] * v), t[7] = this.m[0] * fe - this.m[2] * ce + this.m[3] * ge, t[11] = -(this.m[0] * De - this.m[1] * ce + this.m[3] * re), t[15] = this.m[0] * v - this.m[1] * ge + this.m[2] * re;
        let ue = this.m[0] * t[0] + this.m[1] * t[4] + this.m[2] * t[8] + this.m[3] * t[12];
        for(let ye = 0; ye < 4; ye++)for(let V = 0; V < 4; V++)t[ye * 4 + V] *= 1 / ue;
        return new r(t);
    }
    clone() {
        return new r([
            ...this.m
        ]);
    }
    toString() {
        return this.m.toString();
    }
};
function $adc7cb3c45508c7c$var$On(r, t, u, w = Math.sin) {
    return r + (w(u) + 1) / 2 * (t - r);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$On, "wave");
var $adc7cb3c45508c7c$var$di = 1103515245, $adc7cb3c45508c7c$var$fi = 12345, $adc7cb3c45508c7c$var$lr = 2147483648, $adc7cb3c45508c7c$var$ft = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "RNG");
    })();
    seed;
    constructor(t){
        this.seed = t;
    }
    gen() {
        return this.seed = ($adc7cb3c45508c7c$var$di * this.seed + $adc7cb3c45508c7c$var$fi) % $adc7cb3c45508c7c$var$lr, this.seed / $adc7cb3c45508c7c$var$lr;
    }
    genNumber(t, u) {
        return t + this.gen() * (u - t);
    }
    genVec2(t, u) {
        return new $adc7cb3c45508c7c$var$y(this.genNumber(t.x, u.x), this.genNumber(t.y, u.y));
    }
    genColor(t, u) {
        return new $adc7cb3c45508c7c$var$q(this.genNumber(t.r, u.r), this.genNumber(t.g, u.g), this.genNumber(t.b, u.b));
    }
    genAny(...t) {
        if (t.length === 0) return this.gen();
        if (t.length === 1) {
            if (typeof t[0] == "number") return this.genNumber(0, t[0]);
            if (t[0] instanceof $adc7cb3c45508c7c$var$y) return this.genVec2($adc7cb3c45508c7c$var$T(0, 0), t[0]);
            if (t[0] instanceof $adc7cb3c45508c7c$var$q) return this.genColor($adc7cb3c45508c7c$var$J(0, 0, 0), t[0]);
        } else if (t.length === 2) {
            if (typeof t[0] == "number" && typeof t[1] == "number") return this.genNumber(t[0], t[1]);
            if (t[0] instanceof $adc7cb3c45508c7c$var$y && t[1] instanceof $adc7cb3c45508c7c$var$y) return this.genVec2(t[0], t[1]);
            if (t[0] instanceof $adc7cb3c45508c7c$var$q && t[1] instanceof $adc7cb3c45508c7c$var$q) return this.genColor(t[0], t[1]);
        }
    }
}, $adc7cb3c45508c7c$var$Tn = new $adc7cb3c45508c7c$var$ft(Date.now());
function $adc7cb3c45508c7c$var$fr(r) {
    return r != null && ($adc7cb3c45508c7c$var$Tn.seed = r), $adc7cb3c45508c7c$var$Tn.seed;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$fr, "randSeed");
function $adc7cb3c45508c7c$var$gt(...r) {
    return $adc7cb3c45508c7c$var$Tn.genAny(...r);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$gt, "rand");
function $adc7cb3c45508c7c$var$Pn(...r) {
    return Math.floor($adc7cb3c45508c7c$var$gt(...r));
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Pn, "randi");
function $adc7cb3c45508c7c$var$mr(r) {
    return $adc7cb3c45508c7c$var$gt() <= r;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$mr, "chance");
function $adc7cb3c45508c7c$var$pr(r) {
    return r[$adc7cb3c45508c7c$var$Pn(r.length)];
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$pr, "choose");
function $adc7cb3c45508c7c$var$gr(r, t) {
    return r.pos.x + r.width > t.pos.x && r.pos.x < t.pos.x + t.width && r.pos.y + r.height > t.pos.y && r.pos.y < t.pos.y + t.height;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$gr, "testRectRect");
function $adc7cb3c45508c7c$var$mi(r, t) {
    if (r.p1.x === r.p2.x && r.p1.y === r.p2.y || t.p1.x === t.p2.x && t.p1.y === t.p2.y) return null;
    let u = (t.p2.y - t.p1.y) * (r.p2.x - r.p1.x) - (t.p2.x - t.p1.x) * (r.p2.y - r.p1.y);
    if (u === 0) return null;
    let w = ((t.p2.x - t.p1.x) * (r.p1.y - t.p1.y) - (t.p2.y - t.p1.y) * (r.p1.x - t.p1.x)) / u, S = ((r.p2.x - r.p1.x) * (r.p1.y - t.p1.y) - (r.p2.y - r.p1.y) * (r.p1.x - t.p1.x)) / u;
    return w < 0 || w > 1 || S < 0 || S > 1 ? null : w;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$mi, "testLineLineT");
function $adc7cb3c45508c7c$var$Qe(r, t) {
    let u = $adc7cb3c45508c7c$var$mi(r, t);
    return u ? $adc7cb3c45508c7c$var$T(r.p1.x + u * (r.p2.x - r.p1.x), r.p1.y + u * (r.p2.y - r.p1.y)) : null;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Qe, "testLineLine");
function $adc7cb3c45508c7c$var$wr(r, t) {
    if ($adc7cb3c45508c7c$var$mt(r, t.p1) || $adc7cb3c45508c7c$var$mt(r, t.p2)) return !0;
    let u = r.points();
    return !!$adc7cb3c45508c7c$var$Qe(t, new $adc7cb3c45508c7c$var$Oe(u[0], u[1])) || !!$adc7cb3c45508c7c$var$Qe(t, new $adc7cb3c45508c7c$var$Oe(u[1], u[2])) || !!$adc7cb3c45508c7c$var$Qe(t, new $adc7cb3c45508c7c$var$Oe(u[2], u[3])) || !!$adc7cb3c45508c7c$var$Qe(t, new $adc7cb3c45508c7c$var$Oe(u[3], u[0]));
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$wr, "testRectLine");
function $adc7cb3c45508c7c$var$mt(r, t) {
    return t.x > r.pos.x && t.x < r.pos.x + r.width && t.y > r.pos.y && t.y < r.pos.y + r.height;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$mt, "testRectPoint");
function $adc7cb3c45508c7c$var$vr(r, t) {
    let u = t.sub(r.p1), w = r.p2.sub(r.p1);
    if (Math.abs(u.cross(w)) > Number.EPSILON) return !1;
    let S = u.dot(w) / w.dot(w);
    return S >= 0 && S <= 1;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$vr, "testLinePoint");
function $adc7cb3c45508c7c$var$Mn(r, t) {
    let u = r.p2.sub(r.p1), w = u.dot(u), S = r.p1.sub(t.center), B = 2 * u.dot(S), $ = S.dot(S) - t.radius * t.radius, j = B * B - 4 * w * $;
    if (w <= Number.EPSILON || j < 0) return !1;
    if (j == 0) {
        let H = -B / (2 * w);
        if (H >= 0 && H <= 1) return !0;
    } else {
        let H = (-B + Math.sqrt(j)) / (2 * w), ee = (-B - Math.sqrt(j)) / (2 * w);
        if (H >= 0 && H <= 1 || ee >= 0 && ee <= 1) return !0;
    }
    return $adc7cb3c45508c7c$var$br(t, r.p1);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Mn, "testLineCircle");
function $adc7cb3c45508c7c$var$br(r, t) {
    return r.center.sdist(t) < r.radius * r.radius;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$br, "testCirclePoint");
function $adc7cb3c45508c7c$var$yr(r, t) {
    let u = t.pts[t.pts.length - 1];
    for (let w of t.pts){
        if ($adc7cb3c45508c7c$var$Mn(new $adc7cb3c45508c7c$var$Oe(u, w), r)) return !0;
        u = w;
    }
    return $adc7cb3c45508c7c$var$br(r, t.pts[0]) ? !0 : $adc7cb3c45508c7c$var$Rn(t, r.center);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$yr, "testCirclePolygon");
function $adc7cb3c45508c7c$var$Rn(r, t) {
    let u = !1, w = r.pts;
    for(let S = 0, B = w.length - 1; S < w.length; B = S++)w[S].y > t.y != w[B].y > t.y && t.x < (w[B].x - w[S].x) * (t.y - w[S].y) / (w[B].y - w[S].y) + w[S].x && (u = !u);
    return u;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Rn, "testPolygonPoint");
var $adc7cb3c45508c7c$var$Oe = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Line");
    })();
    p1;
    p2;
    constructor(t, u){
        this.p1 = t.clone(), this.p2 = u.clone();
    }
    transform(t) {
        return new r(t.multVec2(this.p1), t.multVec2(this.p2));
    }
    bbox() {
        return $adc7cb3c45508c7c$var$le.fromPoints(this.p1, this.p2);
    }
    area() {
        return this.p1.dist(this.p2);
    }
    clone() {
        return new r(this.p1, this.p2);
    }
}, $adc7cb3c45508c7c$var$le = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Rect");
    })();
    pos;
    width;
    height;
    constructor(t, u, w){
        this.pos = t.clone(), this.width = u, this.height = w;
    }
    static fromPoints(t, u) {
        return new r(t.clone(), u.x - t.x, u.y - t.y);
    }
    center() {
        return new $adc7cb3c45508c7c$var$y(this.pos.x + this.width / 2, this.pos.y + this.height / 2);
    }
    points() {
        return [
            this.pos,
            this.pos.add(this.width, 0),
            this.pos.add(this.width, this.height),
            this.pos.add(0, this.height)
        ];
    }
    transform(t) {
        return new $adc7cb3c45508c7c$var$He(this.points().map((u)=>t.multVec2(u)));
    }
    bbox() {
        return this.clone();
    }
    area() {
        return this.width * this.height;
    }
    clone() {
        return new r(this.pos.clone(), this.width, this.height);
    }
    distToPoint(t) {
        return Math.sqrt(this.sdistToPoint(t));
    }
    sdistToPoint(t) {
        let u = this.pos, w = this.pos.add(this.width, this.height), S = Math.max(u.x - t.x, 0, t.x - w.x), B = Math.max(u.y - t.y, 0, t.y - w.y);
        return S * S + B * B;
    }
}, $adc7cb3c45508c7c$var$pt = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Circle");
    })();
    center;
    radius;
    constructor(t, u){
        this.center = t.clone(), this.radius = u;
    }
    transform(t) {
        return new $adc7cb3c45508c7c$var$An(this.center, this.radius, this.radius).transform(t);
    }
    bbox() {
        return $adc7cb3c45508c7c$var$le.fromPoints(this.center.sub($adc7cb3c45508c7c$var$T(this.radius)), this.center.add($adc7cb3c45508c7c$var$T(this.radius)));
    }
    area() {
        return this.radius * this.radius * Math.PI;
    }
    clone() {
        return new r(this.center, this.radius);
    }
}, $adc7cb3c45508c7c$var$An = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Ellipse");
    })();
    center;
    radiusX;
    radiusY;
    constructor(t, u, w){
        this.center = t.clone(), this.radiusX = u, this.radiusY = w;
    }
    transform(t) {
        return new r(t.multVec2(this.center), t.m[0] * this.radiusX, t.m[5] * this.radiusY);
    }
    bbox() {
        return $adc7cb3c45508c7c$var$le.fromPoints(this.center.sub($adc7cb3c45508c7c$var$T(this.radiusX, this.radiusY)), this.center.add($adc7cb3c45508c7c$var$T(this.radiusX, this.radiusY)));
    }
    area() {
        return this.radiusX * this.radiusY * Math.PI;
    }
    clone() {
        return new r(this.center, this.radiusX, this.radiusY);
    }
}, $adc7cb3c45508c7c$var$He = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Polygon");
    })();
    pts;
    constructor(t){
        if (t.length < 3) throw new Error("Polygons should have at least 3 vertices");
        this.pts = t;
    }
    transform(t) {
        return new r(this.pts.map((u)=>t.multVec2(u)));
    }
    bbox() {
        let t = $adc7cb3c45508c7c$var$T(Number.MAX_VALUE), u = $adc7cb3c45508c7c$var$T(-Number.MAX_VALUE);
        for (let w of this.pts)t.x = Math.min(t.x, w.x), u.x = Math.max(u.x, w.x), t.y = Math.min(t.y, w.y), u.y = Math.max(u.y, w.y);
        return $adc7cb3c45508c7c$var$le.fromPoints(t, u);
    }
    area() {
        let t = 0, u = this.pts.length;
        for(let w = 0; w < u; w++){
            let S = this.pts[w], B = this.pts[(w + 1) % u];
            t += S.x * B.y * .5, t -= B.x * S.y * .5;
        }
        return Math.abs(t);
    }
    clone() {
        return new r(this.pts.map((t)=>t.clone()));
    }
};
function $adc7cb3c45508c7c$var$xr(r, t) {
    let u = Number.MAX_VALUE, w = $adc7cb3c45508c7c$var$T(0);
    for (let S of [
        r,
        t
    ])for(let B = 0; B < S.pts.length; B++){
        let $ = S.pts[B], H = S.pts[(B + 1) % S.pts.length].sub($).normal().unit(), ee = Number.MAX_VALUE, ae = -Number.MAX_VALUE;
        for(let W = 0; W < r.pts.length; W++){
            let fe = r.pts[W].dot(H);
            ee = Math.min(ee, fe), ae = Math.max(ae, fe);
        }
        let U = Number.MAX_VALUE, X = -Number.MAX_VALUE;
        for(let W = 0; W < t.pts.length; W++){
            let fe = t.pts[W].dot(H);
            U = Math.min(U, fe), X = Math.max(X, fe);
        }
        let d = Math.min(ae, X) - Math.max(ee, U);
        if (d < 0) return null;
        if (d < Math.abs(u)) {
            let W = X - ee, fe = U - ae;
            u = Math.abs(W) < Math.abs(fe) ? W : fe, w = H.scale(u);
        }
    }
    return w;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$xr, "sat");
var $adc7cb3c45508c7c$var$wt = class extends Map {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "IDList");
    })();
    lastID;
    constructor(...t){
        super(...t), this.lastID = 0;
    }
    push(t) {
        let u = this.lastID;
        return this.set(u, t), this.lastID++, u;
    }
    pushd(t) {
        let u = this.push(t);
        return ()=>this.delete(u);
    }
}, $adc7cb3c45508c7c$var$Me = class r {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "EventController");
    })();
    paused = !1;
    cancel;
    constructor(t){
        this.cancel = t;
    }
    static join(t) {
        let u = new r(()=>t.forEach((w)=>w.cancel()));
        return Object.defineProperty(u, "paused", {
            get: ()=>t[0].paused,
            set: (w)=>t.forEach((S)=>S.paused = w)
        }), u.paused = !1, u;
    }
}, $adc7cb3c45508c7c$var$ve = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Event");
    })();
    handlers = new $adc7cb3c45508c7c$var$wt;
    add(t) {
        let u = this.handlers.pushd((...S)=>{
            w.paused || t(...S);
        }), w = new $adc7cb3c45508c7c$var$Me(u);
        return w;
    }
    addOnce(t) {
        let u = this.add((...w)=>{
            u.cancel(), t(...w);
        });
        return u;
    }
    next() {
        return new Promise((t)=>this.addOnce(t));
    }
    trigger(...t) {
        this.handlers.forEach((u)=>u(...t));
    }
    numListeners() {
        return this.handlers.size;
    }
    clear() {
        this.handlers.clear();
    }
}, $adc7cb3c45508c7c$var$Re = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "EventHandler");
    })();
    handlers = {};
    on(t, u) {
        return this.handlers[t] || (this.handlers[t] = new $adc7cb3c45508c7c$var$ve), this.handlers[t].add(u);
    }
    onOnce(t, u) {
        let w = this.on(t, (...S)=>{
            w.cancel(), u(...S);
        });
        return w;
    }
    next(t) {
        return new Promise((u)=>{
            this.onOnce(t, (...w)=>u(w[0]));
        });
    }
    trigger(t, ...u) {
        this.handlers[t] && this.handlers[t].trigger(...u);
    }
    remove(t) {
        delete this.handlers[t];
    }
    clear() {
        this.handlers = {};
    }
    numListeners(t) {
        return this.handlers[t]?.numListeners() ?? 0;
    }
};
function $adc7cb3c45508c7c$var$Dn(r, t) {
    let u = typeof r, w = typeof t;
    if (u !== w) return !1;
    if (u === "object" && w === "object" && r !== null && t !== null) {
        let S = Object.keys(r), B = Object.keys(t);
        if (S.length !== B.length) return !1;
        for (let $ of S){
            let j = r[$], H = t[$];
            if (!(typeof j == "function" && typeof H == "function") && !$adc7cb3c45508c7c$var$Dn(j, H)) return !1;
        }
        return !0;
    }
    return r === t;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Dn, "deepEq");
function $adc7cb3c45508c7c$var$pi(r) {
    let t = window.atob(r), u = t.length, w = new Uint8Array(u);
    for(let S = 0; S < u; S++)w[S] = t.charCodeAt(S);
    return w.buffer;
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$pi, "base64ToArrayBuffer");
function $adc7cb3c45508c7c$var$Ur(r) {
    return $adc7cb3c45508c7c$var$pi(r.split(",")[1]);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Ur, "dataURLToArrayBuffer");
function $adc7cb3c45508c7c$var$_t(r, t) {
    let u = document.createElement("a");
    u.href = t, u.download = r, u.click();
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$_t, "download");
function $adc7cb3c45508c7c$var$Gn(r, t) {
    $adc7cb3c45508c7c$var$_t(r, "data:text/plain;charset=utf-8," + t);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Gn, "downloadText");
function $adc7cb3c45508c7c$var$Er(r, t) {
    $adc7cb3c45508c7c$var$Gn(r, JSON.stringify(t));
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Er, "downloadJSON");
function $adc7cb3c45508c7c$var$Fn(r, t) {
    let u = URL.createObjectURL(t);
    $adc7cb3c45508c7c$var$_t(r, u), URL.revokeObjectURL(u);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Fn, "downloadBlob");
var $adc7cb3c45508c7c$var$Bn = $adc7cb3c45508c7c$var$o((r)=>r.match(/^data:\w+\/\w+;base64,.+/), "isDataURL"), $adc7cb3c45508c7c$var$Sr = $adc7cb3c45508c7c$var$o((r)=>r.split(".").pop(), "getExt"), $adc7cb3c45508c7c$var$Cr = (()=>{
    let r = 0;
    return ()=>r++;
})();
var $adc7cb3c45508c7c$var$kt = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "BinaryHeap");
    })();
    _items;
    _compareFn;
    constructor(t = (u, w)=>u < w){
        this._compareFn = t, this._items = [];
    }
    insert(t) {
        this._items.push(t), this.moveUp(this._items.length - 1);
    }
    remove() {
        if (this._items.length === 0) return null;
        let t = this._items[0], u = this._items.pop();
        return this._items.length !== 0 && (this._items[0] = u, this.moveDown(0)), t;
    }
    clear() {
        this._items.splice(0, this._items.length);
    }
    moveUp(t) {
        for(; t > 0;){
            let u = Math.floor((t - 1) / 2);
            if (!this._compareFn(this._items[t], this._items[u]) && this._items[t] >= this._items[u]) break;
            this.swap(t, u), t = u;
        }
    }
    moveDown(t) {
        for(; t < Math.floor(this._items.length / 2);){
            let u = 2 * t + 1;
            if (u < this._items.length - 1 && !this._compareFn(this._items[u], this._items[u + 1]) && ++u, this._compareFn(this._items[t], this._items[u])) break;
            this.swap(t, u), t = u;
        }
    }
    swap(t, u) {
        [this._items[t], this._items[u]] = [
            this._items[u],
            this._items[t]
        ];
    }
    get length() {
        return this._items.length;
    }
};
var $adc7cb3c45508c7c$var$Ln = {
    "Joy-Con L+R (STANDARD GAMEPAD Vendor: 057e Product: 200e)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home",
            "17": "capture"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    },
    "Joy-Con (L) (STANDARD GAMEPAD Vendor: 057e Product: 2006)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "9": "select",
            "10": "lstick",
            "16": "start"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            }
        }
    },
    "Joy-Con (R) (STANDARD GAMEPAD Vendor: 057e Product: 2007)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "9": "start",
            "10": "lstick",
            "16": "select"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            }
        }
    },
    "Pro Controller (STANDARD GAMEPAD Vendor: 057e Product: 2009)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home",
            "17": "capture"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    },
    default: {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    }
};
var $adc7cb3c45508c7c$var$et = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "ButtonState");
    })();
    pressed = new Set([]);
    pressedRepeat = new Set([]);
    released = new Set([]);
    down = new Set([]);
    update() {
        this.pressed.clear(), this.released.clear(), this.pressedRepeat.clear();
    }
    press(t) {
        this.pressed.add(t), this.pressedRepeat.add(t), this.down.add(t);
    }
    pressRepeat(t) {
        this.pressedRepeat.add(t);
    }
    release(t) {
        this.down.delete(t), this.pressed.delete(t), this.released.add(t);
    }
}, $adc7cb3c45508c7c$var$In = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "GamepadState");
    })();
    buttonState = new $adc7cb3c45508c7c$var$et;
    stickState = new Map;
}, $adc7cb3c45508c7c$var$Vn = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "FPSCounter");
    })();
    dts = [];
    timer = 0;
    fps = 0;
    tick(t) {
        this.dts.push(t), this.timer += t, this.timer >= 1 && (this.timer = 0, this.fps = Math.round(1 / (this.dts.reduce((u, w)=>u + w) / this.dts.length)), this.dts = []);
    }
}, $adc7cb3c45508c7c$var$Tr = $adc7cb3c45508c7c$var$o((r)=>{
    if (!r.canvas) throw new Error("Please provide a canvas");
    let t = {
        canvas: r.canvas,
        loopID: null,
        stopped: !1,
        dt: 0,
        time: 0,
        realTime: 0,
        fpsCounter: new $adc7cb3c45508c7c$var$Vn,
        timeScale: 1,
        skipTime: !1,
        numFrames: 0,
        mousePos: new $adc7cb3c45508c7c$var$y(0),
        mouseDeltaPos: new $adc7cb3c45508c7c$var$y(0),
        keyState: new $adc7cb3c45508c7c$var$et,
        mouseState: new $adc7cb3c45508c7c$var$et,
        mergedGamepadState: new $adc7cb3c45508c7c$var$In,
        gamepadStates: new Map,
        gamepads: [],
        charInputted: [],
        isMouseMoved: !1,
        lastWidth: r.canvas.offsetWidth,
        lastHeight: r.canvas.offsetHeight,
        events: new $adc7cb3c45508c7c$var$Re
    };
    function u() {
        return t.canvas;
    }
    $adc7cb3c45508c7c$var$o(u, "canvas");
    function w() {
        return t.dt * t.timeScale;
    }
    $adc7cb3c45508c7c$var$o(w, "dt");
    function S() {
        return t.time;
    }
    $adc7cb3c45508c7c$var$o(S, "time");
    function B() {
        return t.fpsCounter.fps;
    }
    $adc7cb3c45508c7c$var$o(B, "fps");
    function $() {
        return t.numFrames;
    }
    $adc7cb3c45508c7c$var$o($, "numFrames");
    function j() {
        return t.canvas.toDataURL();
    }
    $adc7cb3c45508c7c$var$o(j, "screenshot");
    function H(h) {
        t.canvas.style.cursor = h;
    }
    $adc7cb3c45508c7c$var$o(H, "setCursor");
    function ee() {
        return t.canvas.style.cursor;
    }
    $adc7cb3c45508c7c$var$o(ee, "getCursor");
    function ae(h) {
        if (h) try {
            let x = t.canvas.requestPointerLock();
            x.catch && x.catch((E)=>console.error(E));
        } catch (x) {
            console.error(x);
        }
        else document.exitPointerLock();
    }
    $adc7cb3c45508c7c$var$o(ae, "setCursorLocked");
    function U() {
        return !!document.pointerLockElement;
    }
    $adc7cb3c45508c7c$var$o(U, "isCursorLocked");
    function X(h) {
        h.requestFullscreen ? h.requestFullscreen() : h.webkitRequestFullscreen && h.webkitRequestFullscreen();
    }
    $adc7cb3c45508c7c$var$o(X, "enterFullscreen");
    function d() {
        document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullScreen && document.webkitExitFullScreen();
    }
    $adc7cb3c45508c7c$var$o(d, "exitFullscreen");
    function W() {
        return document.fullscreenElement || document.webkitFullscreenElement;
    }
    $adc7cb3c45508c7c$var$o(W, "getFullscreenElement");
    function fe(h = !0) {
        h ? X(t.canvas) : d();
    }
    $adc7cb3c45508c7c$var$o(fe, "setFullscreen");
    function De() {
        return !!W();
    }
    $adc7cb3c45508c7c$var$o(De, "isFullscreen");
    function v() {
        t.stopped = !0;
        for(let h in z)t.canvas.removeEventListener(h, z[h]);
        for(let h in Ge)document.removeEventListener(h, Ge[h]);
        for(let h in Fe)window.removeEventListener(h, Fe[h]);
        Q.disconnect();
    }
    $adc7cb3c45508c7c$var$o(v, "quit");
    function ce(h) {
        t.loopID !== null && cancelAnimationFrame(t.loopID);
        let x = 0, E = $adc7cb3c45508c7c$var$o((L)=>{
            if (t.stopped) return;
            if (document.visibilityState !== "visible") {
                t.loopID = requestAnimationFrame(E);
                return;
            }
            let me = L / 1e3, Z = me - t.realTime, Ye = r.maxFPS ? 1 / r.maxFPS : 0;
            t.realTime = me, x += Z, x > Ye && (t.skipTime || (t.dt = x, t.time += w(), t.fpsCounter.tick(t.dt)), x = 0, t.skipTime = !1, t.numFrames++, Pt(), h(), Mt()), t.loopID = requestAnimationFrame(E);
        }, "frame");
        E(0);
    }
    $adc7cb3c45508c7c$var$o(ce, "run");
    function ge() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    $adc7cb3c45508c7c$var$o(ge, "isTouchscreen");
    function re() {
        return t.mousePos.clone();
    }
    $adc7cb3c45508c7c$var$o(re, "mousePos");
    function ue() {
        return t.mouseDeltaPos.clone();
    }
    $adc7cb3c45508c7c$var$o(ue, "mouseDeltaPos");
    function ye(h = "left") {
        return t.mouseState.pressed.has(h);
    }
    $adc7cb3c45508c7c$var$o(ye, "isMousePressed");
    function V(h = "left") {
        return t.mouseState.down.has(h);
    }
    $adc7cb3c45508c7c$var$o(V, "isMouseDown");
    function A(h = "left") {
        return t.mouseState.released.has(h);
    }
    $adc7cb3c45508c7c$var$o(A, "isMouseReleased");
    function rt() {
        return t.isMouseMoved;
    }
    $adc7cb3c45508c7c$var$o(rt, "isMouseMoved");
    function Ce(h) {
        return h === void 0 ? t.keyState.pressed.size > 0 : t.keyState.pressed.has(h);
    }
    $adc7cb3c45508c7c$var$o(Ce, "isKeyPressed");
    function Yt(h) {
        return h === void 0 ? t.keyState.pressedRepeat.size > 0 : t.keyState.pressedRepeat.has(h);
    }
    $adc7cb3c45508c7c$var$o(Yt, "isKeyPressedRepeat");
    function st(h) {
        return h === void 0 ? t.keyState.down.size > 0 : t.keyState.down.has(h);
    }
    $adc7cb3c45508c7c$var$o(st, "isKeyDown");
    function qe(h) {
        return h === void 0 ? t.keyState.released.size > 0 : t.keyState.released.has(h);
    }
    $adc7cb3c45508c7c$var$o(qe, "isKeyReleased");
    function Xt(h) {
        return h === void 0 ? t.mergedGamepadState.buttonState.pressed.size > 0 : t.mergedGamepadState.buttonState.pressed.has(h);
    }
    $adc7cb3c45508c7c$var$o(Xt, "isGamepadButtonPressed");
    function Wt(h) {
        return h === void 0 ? t.mergedGamepadState.buttonState.down.size > 0 : t.mergedGamepadState.buttonState.down.has(h);
    }
    $adc7cb3c45508c7c$var$o(Wt, "isGamepadButtonDown");
    function $e(h) {
        return h === void 0 ? t.mergedGamepadState.buttonState.released.size > 0 : t.mergedGamepadState.buttonState.released.has(h);
    }
    $adc7cb3c45508c7c$var$o($e, "isGamepadButtonReleased");
    function Jt(h) {
        return t.events.on("resize", h);
    }
    $adc7cb3c45508c7c$var$o(Jt, "onResize");
    let ze = $adc7cb3c45508c7c$var$o((h, x)=>{
        if (typeof h == "function") return t.events.on("keyDown", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("keyDown", (E)=>E === h && x(h));
    }, "onKeyDown"), Qt = $adc7cb3c45508c7c$var$o((h, x)=>{
        if (typeof h == "function") return t.events.on("keyPress", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("keyPress", (E)=>E === h && x(h));
    }, "onKeyPress"), Zt = $adc7cb3c45508c7c$var$o((h, x)=>{
        if (typeof h == "function") return t.events.on("keyPressRepeat", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("keyPressRepeat", (E)=>E === h && x(h));
    }, "onKeyPressRepeat"), bt = $adc7cb3c45508c7c$var$o((h, x)=>{
        if (typeof h == "function") return t.events.on("keyRelease", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("keyRelease", (E)=>E === h && x(h));
    }, "onKeyRelease");
    function yt(h, x) {
        return typeof h == "function" ? t.events.on("mouseDown", (E)=>h(E)) : t.events.on("mouseDown", (E)=>E === h && x(E));
    }
    $adc7cb3c45508c7c$var$o(yt, "onMouseDown");
    function xt(h, x) {
        return typeof h == "function" ? t.events.on("mousePress", (E)=>h(E)) : t.events.on("mousePress", (E)=>E === h && x(E));
    }
    $adc7cb3c45508c7c$var$o(xt, "onMousePress");
    function Ie(h, x) {
        return typeof h == "function" ? t.events.on("mouseRelease", (E)=>h(E)) : t.events.on("mouseRelease", (E)=>E === h && x(E));
    }
    $adc7cb3c45508c7c$var$o(Ie, "onMouseRelease");
    function en(h) {
        return t.events.on("mouseMove", ()=>h(re(), ue()));
    }
    $adc7cb3c45508c7c$var$o(en, "onMouseMove");
    function tn(h) {
        return t.events.on("charInput", h);
    }
    $adc7cb3c45508c7c$var$o(tn, "onCharInput");
    function nn(h) {
        return t.events.on("touchStart", h);
    }
    $adc7cb3c45508c7c$var$o(nn, "onTouchStart");
    function rn(h) {
        return t.events.on("touchMove", h);
    }
    $adc7cb3c45508c7c$var$o(rn, "onTouchMove");
    function sn(h) {
        return t.events.on("touchEnd", h);
    }
    $adc7cb3c45508c7c$var$o(sn, "onTouchEnd");
    function on(h) {
        return t.events.on("scroll", h);
    }
    $adc7cb3c45508c7c$var$o(on, "onScroll");
    function Ut(h) {
        return t.events.on("hide", h);
    }
    $adc7cb3c45508c7c$var$o(Ut, "onHide");
    function Et(h) {
        return t.events.on("show", h);
    }
    $adc7cb3c45508c7c$var$o(Et, "onShow");
    function St(h, x) {
        if (typeof h == "function") return t.events.on("gamepadButtonDown", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("gamepadButtonDown", (E)=>E === h && x(h));
    }
    $adc7cb3c45508c7c$var$o(St, "onGamepadButtonDown");
    function Ct(h, x) {
        if (typeof h == "function") return t.events.on("gamepadButtonPress", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("gamepadButtonPress", (E)=>E === h && x(h));
    }
    $adc7cb3c45508c7c$var$o(Ct, "onGamepadButtonPress");
    function Tt(h, x) {
        if (typeof h == "function") return t.events.on("gamepadButtonRelease", h);
        if (typeof h == "string" && typeof x == "function") return t.events.on("gamepadButtonRelease", (E)=>E === h && x(h));
    }
    $adc7cb3c45508c7c$var$o(Tt, "onGamepadButtonRelease");
    function an(h, x) {
        return t.events.on("gamepadStick", (E, L)=>E === h && x(L));
    }
    $adc7cb3c45508c7c$var$o(an, "onGamepadStick");
    function it(h) {
        t.events.on("gamepadConnect", h);
    }
    $adc7cb3c45508c7c$var$o(it, "onGamepadConnect");
    function un(h) {
        t.events.on("gamepadDisconnect", h);
    }
    $adc7cb3c45508c7c$var$o(un, "onGamepadDisconnect");
    function cn(h) {
        return t.mergedGamepadState.stickState.get(h) || new $adc7cb3c45508c7c$var$y(0);
    }
    $adc7cb3c45508c7c$var$o(cn, "getGamepadStick");
    function At() {
        return [
            ...t.charInputted
        ];
    }
    $adc7cb3c45508c7c$var$o(At, "charInputted");
    function Ot() {
        return [
            ...t.gamepads
        ];
    }
    $adc7cb3c45508c7c$var$o(Ot, "getGamepads");
    function Pt() {
        t.events.trigger("input"), t.keyState.down.forEach((h)=>t.events.trigger("keyDown", h)), t.mouseState.down.forEach((h)=>t.events.trigger("mouseDown", h)), ot();
    }
    $adc7cb3c45508c7c$var$o(Pt, "processInput");
    function Mt() {
        t.keyState.update(), t.mouseState.update(), t.mergedGamepadState.buttonState.update(), t.mergedGamepadState.stickState.forEach((h, x)=>{
            t.mergedGamepadState.stickState.set(x, new $adc7cb3c45508c7c$var$y(0));
        }), t.charInputted = [], t.isMouseMoved = !1, t.gamepadStates.forEach((h)=>{
            h.buttonState.update(), h.stickState.forEach((x, E)=>{
                h.stickState.set(E, new $adc7cb3c45508c7c$var$y(0));
            });
        });
    }
    $adc7cb3c45508c7c$var$o(Mt, "resetInput");
    function Ke(h) {
        let x = {
            index: h.index,
            isPressed: (E)=>t.gamepadStates.get(h.index).buttonState.pressed.has(E),
            isDown: (E)=>t.gamepadStates.get(h.index).buttonState.down.has(E),
            isReleased: (E)=>t.gamepadStates.get(h.index).buttonState.released.has(E),
            getStick: (E)=>t.gamepadStates.get(h.index).stickState.get(E)
        };
        return t.gamepads.push(x), t.gamepadStates.set(h.index, {
            buttonState: new $adc7cb3c45508c7c$var$et,
            stickState: new Map([
                [
                    "left",
                    new $adc7cb3c45508c7c$var$y(0)
                ],
                [
                    "right",
                    new $adc7cb3c45508c7c$var$y(0)
                ]
            ])
        }), x;
    }
    $adc7cb3c45508c7c$var$o(Ke, "registerGamepad");
    function ln(h) {
        t.gamepads = t.gamepads.filter((x)=>x.index !== h.index), t.gamepadStates.delete(h.index);
    }
    $adc7cb3c45508c7c$var$o(ln, "removeGamepad");
    function ot() {
        for (let h of navigator.getGamepads())h && !t.gamepadStates.has(h.index) && Ke(h);
        for (let h of t.gamepads){
            let x = navigator.getGamepads()[h.index], L = (r.gamepads ?? {})[x.id] ?? $adc7cb3c45508c7c$var$Ln[x.id] ?? $adc7cb3c45508c7c$var$Ln.default, me = t.gamepadStates.get(h.index);
            for(let Z = 0; Z < x.buttons.length; Z++)x.buttons[Z].pressed ? (me.buttonState.down.has(L.buttons[Z]) || (t.mergedGamepadState.buttonState.press(L.buttons[Z]), me.buttonState.press(L.buttons[Z]), t.events.trigger("gamepadButtonPress", L.buttons[Z])), t.events.trigger("gamepadButtonDown", L.buttons[Z])) : me.buttonState.down.has(L.buttons[Z]) && (t.mergedGamepadState.buttonState.release(L.buttons[Z]), me.buttonState.release(L.buttons[Z]), t.events.trigger("gamepadButtonRelease", L.buttons[Z]));
            for(let Z in L.sticks){
                let Ye = L.sticks[Z], Te = new $adc7cb3c45508c7c$var$y(x.axes[Ye.x], x.axes[Ye.y]);
                me.stickState.set(Z, Te), t.mergedGamepadState.stickState.set(Z, Te), t.events.trigger("gamepadStick", Z, Te);
            }
        }
    }
    $adc7cb3c45508c7c$var$o(ot, "processGamepad");
    let z = {}, Ge = {}, Fe = {};
    z.mousemove = (h)=>{
        let x = new $adc7cb3c45508c7c$var$y(h.offsetX, h.offsetY), E = new $adc7cb3c45508c7c$var$y(h.movementX, h.movementY);
        t.events.onOnce("input", ()=>{
            t.isMouseMoved = !0, t.mousePos = x, t.mouseDeltaPos = E, t.events.trigger("mouseMove");
        });
    };
    let at = [
        "left",
        "middle",
        "right",
        "back",
        "forward"
    ];
    z.mousedown = (h)=>{
        t.events.onOnce("input", ()=>{
            let x = at[h.button];
            x && (t.mouseState.press(x), t.events.trigger("mousePress", x));
        });
    }, z.mouseup = (h)=>{
        t.events.onOnce("input", ()=>{
            let x = at[h.button];
            x && (t.mouseState.release(x), t.events.trigger("mouseRelease", x));
        });
    };
    let hn = new Set([
        " ",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab"
    ]), Rt = {
        ArrowLeft: "left",
        ArrowRight: "right",
        ArrowUp: "up",
        ArrowDown: "down",
        " ": "space"
    };
    z.keydown = (h)=>{
        hn.has(h.key) && h.preventDefault(), t.events.onOnce("input", ()=>{
            let x = Rt[h.key] || h.key.toLowerCase();
            x.length === 1 ? (t.events.trigger("charInput", x), t.charInputted.push(x)) : x === "space" && (t.events.trigger("charInput", " "), t.charInputted.push(" ")), h.repeat ? (t.keyState.pressRepeat(x), t.events.trigger("keyPressRepeat", x)) : (t.keyState.press(x), t.events.trigger("keyPressRepeat", x), t.events.trigger("keyPress", x));
        });
    }, z.keyup = (h)=>{
        t.events.onOnce("input", ()=>{
            let x = Rt[h.key] || h.key.toLowerCase();
            t.keyState.release(x), t.events.trigger("keyRelease", x);
        });
    }, z.touchstart = (h)=>{
        h.preventDefault(), t.events.onOnce("input", ()=>{
            let x = [
                ...h.changedTouches
            ], E = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $adc7cb3c45508c7c$var$y(x[0].clientX - E.x, x[0].clientY - E.y), t.mouseState.press("left"), t.events.trigger("mousePress", "left")), x.forEach((L)=>{
                t.events.trigger("touchStart", new $adc7cb3c45508c7c$var$y(L.clientX - E.x, L.clientY - E.y), L);
            });
        });
    }, z.touchmove = (h)=>{
        h.preventDefault(), t.events.onOnce("input", ()=>{
            let x = [
                ...h.changedTouches
            ], E = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $adc7cb3c45508c7c$var$y(x[0].clientX - E.x, x[0].clientY - E.y), t.events.trigger("mouseMove")), x.forEach((L)=>{
                t.events.trigger("touchMove", new $adc7cb3c45508c7c$var$y(L.clientX - E.x, L.clientY - E.y), L);
            });
        });
    }, z.touchend = (h)=>{
        t.events.onOnce("input", ()=>{
            let x = [
                ...h.changedTouches
            ], E = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $adc7cb3c45508c7c$var$y(x[0].clientX - E.x, x[0].clientY - E.y), t.mouseState.release("left"), t.events.trigger("mouseRelease", "left")), x.forEach((L)=>{
                t.events.trigger("touchEnd", new $adc7cb3c45508c7c$var$y(L.clientX - E.x, L.clientY - E.y), L);
            });
        });
    }, z.touchcancel = (h)=>{
        t.events.onOnce("input", ()=>{
            let x = [
                ...h.changedTouches
            ], E = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $adc7cb3c45508c7c$var$y(x[0].clientX - E.x, x[0].clientY - E.y), t.mouseState.release("left"), t.events.trigger("mouseRelease", "left")), x.forEach((L)=>{
                t.events.trigger("touchEnd", new $adc7cb3c45508c7c$var$y(L.clientX - E.x, L.clientY - E.y), L);
            });
        });
    }, z.wheel = (h)=>{
        h.preventDefault(), t.events.onOnce("input", ()=>{
            t.events.trigger("scroll", new $adc7cb3c45508c7c$var$y(h.deltaX, h.deltaY));
        });
    }, z.contextmenu = (h)=>h.preventDefault(), Ge.visibilitychange = ()=>{
        document.visibilityState === "visible" ? (t.skipTime = !0, t.events.trigger("show")) : t.events.trigger("hide");
    }, Fe.gamepadconnected = (h)=>{
        let x = Ke(h.gamepad);
        t.events.onOnce("input", ()=>{
            t.events.trigger("gamepadConnect", x);
        });
    }, Fe.gamepaddisconnected = (h)=>{
        let x = Ot().filter((E)=>E.index === h.gamepad.index)[0];
        ln(h.gamepad), t.events.onOnce("input", ()=>{
            t.events.trigger("gamepadDisconnect", x);
        });
    };
    for(let h in z)t.canvas.addEventListener(h, z[h]);
    for(let h in Ge)document.addEventListener(h, Ge[h]);
    for(let h in Fe)window.addEventListener(h, Fe[h]);
    let Q = new ResizeObserver((h)=>{
        for (let x of h)if (x.target === t.canvas) {
            if (t.lastWidth === t.canvas.offsetWidth && t.lastHeight === t.canvas.offsetHeight) return;
            t.lastWidth = t.canvas.offsetWidth, t.lastHeight = t.canvas.offsetHeight, t.events.onOnce("input", ()=>{
                t.events.trigger("resize");
            });
        }
    });
    return Q.observe(t.canvas), {
        dt: w,
        time: S,
        run: ce,
        canvas: u,
        fps: B,
        numFrames: $,
        quit: v,
        setFullscreen: fe,
        isFullscreen: De,
        setCursor: H,
        screenshot: j,
        getGamepads: Ot,
        getCursor: ee,
        setCursorLocked: ae,
        isCursorLocked: U,
        isTouchscreen: ge,
        mousePos: re,
        mouseDeltaPos: ue,
        isKeyDown: st,
        isKeyPressed: Ce,
        isKeyPressedRepeat: Yt,
        isKeyReleased: qe,
        isMouseDown: V,
        isMousePressed: ye,
        isMouseReleased: A,
        isMouseMoved: rt,
        isGamepadButtonPressed: Xt,
        isGamepadButtonDown: Wt,
        isGamepadButtonReleased: $e,
        getGamepadStick: cn,
        charInputted: At,
        onResize: Jt,
        onKeyDown: ze,
        onKeyPress: Qt,
        onKeyPressRepeat: Zt,
        onKeyRelease: bt,
        onMouseDown: yt,
        onMousePress: xt,
        onMouseRelease: Ie,
        onMouseMove: en,
        onCharInput: tn,
        onTouchStart: nn,
        onTouchMove: rn,
        onTouchEnd: sn,
        onScroll: on,
        onHide: Ut,
        onShow: Et,
        onGamepadButtonDown: St,
        onGamepadButtonPress: Ct,
        onGamepadButtonRelease: Tt,
        onGamepadStick: an,
        onGamepadConnect: it,
        onGamepadDisconnect: un,
        events: t.events
    };
}, "default");
var $adc7cb3c45508c7c$var$Ht = 2.5949095, $adc7cb3c45508c7c$var$Ar = 2.70158, $adc7cb3c45508c7c$var$Or = 2 * Math.PI / 3, $adc7cb3c45508c7c$var$Pr = 2 * Math.PI / 4.5, $adc7cb3c45508c7c$var$qt = {
    linear: (r)=>r,
    easeInSine: (r)=>1 - Math.cos(r * Math.PI / 2),
    easeOutSine: (r)=>Math.sin(r * Math.PI / 2),
    easeInOutSine: (r)=>-(Math.cos(Math.PI * r) - 1) / 2,
    easeInQuad: (r)=>r * r,
    easeOutQuad: (r)=>1 - (1 - r) * (1 - r),
    easeInOutQuad: (r)=>r < .5 ? 2 * r * r : 1 - Math.pow(-2 * r + 2, 2) / 2,
    easeInCubic: (r)=>r * r * r,
    easeOutCubic: (r)=>1 - Math.pow(1 - r, 3),
    easeInOutCubic: (r)=>r < .5 ? 4 * r * r * r : 1 - Math.pow(-2 * r + 2, 3) / 2,
    easeInQuart: (r)=>r * r * r * r,
    easeOutQuart: (r)=>1 - Math.pow(1 - r, 4),
    easeInOutQuart: (r)=>r < .5 ? 8 * r * r * r * r : 1 - Math.pow(-2 * r + 2, 4) / 2,
    easeInQuint: (r)=>r * r * r * r * r,
    easeOutQuint: (r)=>1 - Math.pow(1 - r, 5),
    easeInOutQuint: (r)=>r < .5 ? 16 * r * r * r * r * r : 1 - Math.pow(-2 * r + 2, 5) / 2,
    easeInExpo: (r)=>r === 0 ? 0 : Math.pow(2, 10 * r - 10),
    easeOutExpo: (r)=>r === 1 ? 1 : 1 - Math.pow(2, -10 * r),
    easeInOutExpo: (r)=>r === 0 ? 0 : r === 1 ? 1 : r < .5 ? Math.pow(2, 20 * r - 10) / 2 : (2 - Math.pow(2, -20 * r + 10)) / 2,
    easeInCirc: (r)=>1 - Math.sqrt(1 - Math.pow(r, 2)),
    easeOutCirc: (r)=>Math.sqrt(1 - Math.pow(r - 1, 2)),
    easeInOutCirc: (r)=>r < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * r, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * r + 2, 2)) + 1) / 2,
    easeInBack: (r)=>$adc7cb3c45508c7c$var$Ar * r * r * r - 1.70158 * r * r,
    easeOutBack: (r)=>1 + $adc7cb3c45508c7c$var$Ar * Math.pow(r - 1, 3) + 1.70158 * Math.pow(r - 1, 2),
    easeInOutBack: (r)=>r < .5 ? Math.pow(2 * r, 2) * (($adc7cb3c45508c7c$var$Ht + 1) * 2 * r - $adc7cb3c45508c7c$var$Ht) / 2 : (Math.pow(2 * r - 2, 2) * (($adc7cb3c45508c7c$var$Ht + 1) * (r * 2 - 2) + $adc7cb3c45508c7c$var$Ht) + 2) / 2,
    easeInElastic: (r)=>r === 0 ? 0 : r === 1 ? 1 : -Math.pow(2, 10 * r - 10) * Math.sin((r * 10 - 10.75) * $adc7cb3c45508c7c$var$Or),
    easeOutElastic: (r)=>r === 0 ? 0 : r === 1 ? 1 : Math.pow(2, -10 * r) * Math.sin((r * 10 - .75) * $adc7cb3c45508c7c$var$Or) + 1,
    easeInOutElastic: (r)=>r === 0 ? 0 : r === 1 ? 1 : r < .5 ? -(Math.pow(2, 20 * r - 10) * Math.sin((20 * r - 11.125) * $adc7cb3c45508c7c$var$Pr)) / 2 : Math.pow(2, -20 * r + 10) * Math.sin((20 * r - 11.125) * $adc7cb3c45508c7c$var$Pr) / 2 + 1,
    easeInBounce: (r)=>1 - $adc7cb3c45508c7c$var$qt.easeOutBounce(1 - r),
    easeOutBounce: (r)=>r < 1 / 2.75 ? 7.5625 * r * r : r < 2 / 2.75 ? 7.5625 * (r -= 1.5 / 2.75) * r + .75 : r < 2.5 / 2.75 ? 7.5625 * (r -= 2.25 / 2.75) * r + .9375 : 7.5625 * (r -= 2.625 / 2.75) * r + .984375,
    easeInOutBounce: (r)=>r < .5 ? (1 - $adc7cb3c45508c7c$var$qt.easeOutBounce(1 - 2 * r)) / 2 : (1 + $adc7cb3c45508c7c$var$qt.easeOutBounce(2 * r - 1)) / 2
}, $adc7cb3c45508c7c$var$tt = $adc7cb3c45508c7c$var$qt;
var $adc7cb3c45508c7c$var$vt = class {
    static #_ = (()=>{
        $adc7cb3c45508c7c$var$o(this, "Timer");
    })();
    time;
    action;
    finished = !1;
    paused = !1;
    constructor(t, u){
        this.time = t, this.action = u;
    }
    tick(t) {
        return this.finished || this.paused ? !1 : (this.time -= t, this.time <= 0 ? (this.action(), this.finished = !0, this.time = 0, !0) : !1);
    }
    reset(t) {
        this.time = t, this.finished = !1;
    }
};
var $adc7cb3c45508c7c$var$Mr = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA1CAYAAADyMeOEAAAAAXNSR0IArs4c6QAAAoVJREFUaIHdm7txwkAQhheGAqACiCHzOKQDQrqgILpwSAeEDBnEUAF0gCMxZ7G72qce/mec2Lpf9+3unaS78wgSNZ8uX5729+d1FNWXUuGmXlBOUUEIMckEpeQJgBu6C+BSFngztBR2vd+ovY+7g+p6LbgaWgJrAeUkDYIUXgXdBBwNi6kpABJwMTQH3AZsXRR8GHTfgEth8E3gjdAUcNewpbTgY85sCMCUuOokozE0YM0YRzM9NGAAXd8+omAF5h4lnmBRvpSnZHyLoLEbaN+aKB9KWv/KWw0tAbbANnlG+UvB2dm77NxxdwgBpjrF/d7rW9cbmpvio2A5z8iAYpVU8pGZlo6/2+MSco2lHfd3rv9jAP038e1xef9o2mjvYb2OqpqKE81028/jeietlSEVO5FRWsxWsJit1G3aFpW8iWe5RwpiCZAk25QvV6nz6fIlynRGuTd5WqpJ4guAlDfVKBK87hXljflgv1ON6fV+4+5gVlA17SfeG0heKqQd4l4jI/wrmaA9N9R4ar+wpHJDZyrrfcH0nB66PqAzPi76pn+faSyJk/vzOorYhGurQrzj/P68jtBMawHaHBIR9xoD5O34dy0qQOSYHvqExq2TpT2nf76+w7y251OYF0CRaU+J920TwLUa6inx6OxE6g80lu2ux7Y2eJLF/rCXE6zEPdnenk9o+4ih9AEdnW2q81HXl5LuU6OTl2fXUhqganbXAGq3g6jJOWV/OnoesO6YqqEB/GdNsjf7uHtwj2DzmRNpp7iOZfm6D9oAxB6Yi1gC4oIYeo4MIPdopEQRB+cAko5J1tW386HpB2Kz1eop4Epdwls/kgZ1sh8gZsEjdcWkr//D8Qu3Z3l5Nl1NtAAAAABJRU5ErkJggg==";
var $adc7cb3c45508c7c$var$Rr = $adc7cb3c45508c7c$var$cr("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");
var $adc7cb3c45508c7c$var$Dr = "data:image/png;base64,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";
var $adc7cb3c45508c7c$var$Gr = "data:image/png;base64,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";
var $adc7cb3c45508c7c$var$xi = "3000.1.6", $adc7cb3c45508c7c$var$Fr = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~", $adc7cb3c45508c7c$var$$t = "topleft", $adc7cb3c45508c7c$var$Br = 64, $adc7cb3c45508c7c$var$Ui = "monospace", $adc7cb3c45508c7c$var$zt = "monospace", $adc7cb3c45508c7c$var$Ei = 36, $adc7cb3c45508c7c$var$Lr = 64, $adc7cb3c45508c7c$var$Ir = 256, $adc7cb3c45508c7c$var$Vr = 2048, $adc7cb3c45508c7c$var$jr = 2048, $adc7cb3c45508c7c$var$Nr = 2048, $adc7cb3c45508c7c$var$kr = 2048, $adc7cb3c45508c7c$var$_r = .1, $adc7cb3c45508c7c$var$Si = 64, $adc7cb3c45508c7c$var$Hr = "nearest", $adc7cb3c45508c7c$var$Ci = 8, $adc7cb3c45508c7c$var$Ti = 4, $adc7cb3c45508c7c$var$zr = [
    {
        name: "a_pos",
        size: 2
    },
    {
        name: "a_uv",
        size: 2
    },
    {
        name: "a_color",
        size: 4
    }
], $adc7cb3c45508c7c$var$Kt = $adc7cb3c45508c7c$var$zr.reduce((r, t)=>r + t.size, 0), $adc7cb3c45508c7c$var$Kr = 2048, $adc7cb3c45508c7c$var$qr = $adc7cb3c45508c7c$var$Kr * 4 * $adc7cb3c45508c7c$var$Kt, $adc7cb3c45508c7c$var$$r = $adc7cb3c45508c7c$var$Kr * 6, $adc7cb3c45508c7c$var$Ai = `
attribute vec2 a_pos;
attribute vec2 a_uv;
attribute vec4 a_color;

varying vec2 v_pos;
varying vec2 v_uv;
varying vec4 v_color;

vec4 def_vert() {
	return vec4(a_pos, 0.0, 1.0);
}

{{user}}

void main() {
	vec4 pos = vert(a_pos, a_uv, a_color);
	v_pos = a_pos;
	v_uv = a_uv;
	v_color = a_color;
	gl_Position = pos;
}
`, $adc7cb3c45508c7c$var$Oi = `
precision mediump float;

varying vec2 v_pos;
varying vec2 v_uv;
varying vec4 v_color;

uniform sampler2D u_tex;

vec4 def_frag() {
	return v_color * texture2D(u_tex, v_uv);
}

{{user}}

void main() {
	gl_FragColor = frag(v_pos, v_uv, v_color, u_tex);
	if (gl_FragColor.a == 0.0) {
		discard;
	}
}
`, $adc7cb3c45508c7c$var$jn = `
vec4 vert(vec2 pos, vec2 uv, vec4 color) {
	return def_vert();
}
`, $adc7cb3c45508c7c$var$Nn = `
vec4 frag(vec2 pos, vec2 uv, vec4 color, sampler2D tex) {
	return def_frag();
}
`, $adc7cb3c45508c7c$var$Pi = new Set([
    "id",
    "require"
]), $adc7cb3c45508c7c$var$Mi = new Set([
    "add",
    "update",
    "draw",
    "destroy",
    "inspect",
    "drawInspect"
]);
function $adc7cb3c45508c7c$var$nt(r) {
    switch(r){
        case "topleft":
            return new $adc7cb3c45508c7c$var$y(-1, -1);
        case "top":
            return new $adc7cb3c45508c7c$var$y(0, -1);
        case "topright":
            return new $adc7cb3c45508c7c$var$y(1, -1);
        case "left":
            return new $adc7cb3c45508c7c$var$y(-1, 0);
        case "center":
            return new $adc7cb3c45508c7c$var$y(0, 0);
        case "right":
            return new $adc7cb3c45508c7c$var$y(1, 0);
        case "botleft":
            return new $adc7cb3c45508c7c$var$y(-1, 1);
        case "bot":
            return new $adc7cb3c45508c7c$var$y(0, 1);
        case "botright":
            return new $adc7cb3c45508c7c$var$y(1, 1);
        default:
            return r;
    }
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$nt, "anchorPt");
function $adc7cb3c45508c7c$var$Ri(r) {
    switch(r){
        case "left":
            return 0;
        case "center":
            return .5;
        case "right":
            return 1;
        default:
            return 0;
    }
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Ri, "alignPt");
function $adc7cb3c45508c7c$var$Di(r) {
    return r.createBuffer(1, 1, 44100);
}
$adc7cb3c45508c7c$var$o($adc7cb3c45508c7c$var$Di, "createEmptyAudioBuffer");
var $adc7cb3c45508c7c$export$2e2bcd8739ae039 = $adc7cb3c45508c7c$var$o((r = {})=>{
    let t = r.root ?? document.body;
    t === document.body && (document.body.style.width = "100%", document.body.style.height = "100%", document.body.style.margin = "0px", document.documentElement.style.width = "100%", document.documentElement.style.height = "100%");
    let u = r.canvas ?? (()=>{
        let e = document.createElement("canvas");
        return t.appendChild(e), e;
    })(), w = r.scale ?? 1, S = r.width && r.height && !r.stretch && !r.letterbox;
    S ? (u.width = r.width * w, u.height = r.height * w) : (u.width = u.parentElement.offsetWidth, u.height = u.parentElement.offsetHeight);
    let B = u.width, $ = u.height, j = r.pixelDensity || window.devicePixelRatio;
    u.width *= j, u.height *= j;
    let H = [
        "outline: none",
        "cursor: default"
    ];
    S ? (H.push(`width: ${B}px`), H.push(`height: ${$}px`)) : (H.push("width: 100%"), H.push("height: 100%")), r.crisp && (H.push("image-rendering: pixelated"), H.push("image-rendering: crisp-edges")), u.style.cssText = H.join(";"), u.tabIndex = 0;
    let ee = document.createElement("canvas");
    ee.width = $adc7cb3c45508c7c$var$Ir, ee.height = $adc7cb3c45508c7c$var$Ir;
    let ae = ee.getContext("2d", {
        willReadFrequently: !0
    }), U = $adc7cb3c45508c7c$var$Tr({
        canvas: u,
        touchToMouse: r.touchToMouse,
        gamepads: r.gamepads,
        pixelDensity: r.pixelDensity,
        maxFPS: r.maxFPS
    }), X = [], d = U.canvas().getContext("webgl", {
        antialias: !0,
        depth: !0,
        stencil: !0,
        alpha: !0,
        preserveDrawingBuffer: !0
    });
    class W {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "Texture");
        })();
        src = null;
        glTex;
        width;
        height;
        constructor(n, s, i1 = {}){
            this.glTex = d.createTexture(), X.push(()=>this.free()), this.bind(), n && s && d.texImage2D(d.TEXTURE_2D, 0, d.RGBA, n, s, 0, d.RGBA, d.UNSIGNED_BYTE, null), this.width = n, this.height = s;
            let a1 = (()=>{
                switch(i1.filter ?? r.texFilter){
                    case "linear":
                        return d.LINEAR;
                    case "nearest":
                        return d.NEAREST;
                    default:
                        return d.NEAREST;
                }
            })(), c1 = (()=>{
                switch(i1.wrap){
                    case "repeat":
                        return d.REPEAT;
                    case "clampToEdge":
                        return d.CLAMP_TO_EDGE;
                    default:
                        return d.CLAMP_TO_EDGE;
                }
            })();
            d.texParameteri(d.TEXTURE_2D, d.TEXTURE_MIN_FILTER, a1), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_MAG_FILTER, a1), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_WRAP_S, c1), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_WRAP_T, c1), this.unbind();
        }
        static fromImage(n, s = {}) {
            let i1 = new W(0, 0, s);
            return i1.bind(), d.texImage2D(d.TEXTURE_2D, 0, d.RGBA, d.RGBA, d.UNSIGNED_BYTE, n), i1.width = n.width, i1.height = n.height, i1.unbind(), i1.src = n, i1;
        }
        update(n, s = 0, i1 = 0) {
            this.bind(), d.texSubImage2D(d.TEXTURE_2D, 0, s, i1, d.RGBA, d.UNSIGNED_BYTE, n), this.unbind();
        }
        bind() {
            d.bindTexture(d.TEXTURE_2D, this.glTex);
        }
        unbind() {
            d.bindTexture(d.TEXTURE_2D, null);
        }
        free() {
            d.deleteTexture(this.glTex);
        }
    }
    class fe {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "TexPacker");
        })();
        tex;
        canvas;
        ctx;
        x = 0;
        y = 0;
        curHeight = 0;
        constructor(n, s){
            this.canvas = document.createElement("canvas"), this.canvas.width = n, this.canvas.height = s, this.tex = W.fromImage(this.canvas), this.ctx = this.canvas.getContext("2d");
        }
        add(n) {
            if (n.width > this.canvas.width || n.height > this.canvas.height) throw new Error(`Texture size (${n.width} x ${n.height}) exceeds limit (${this.canvas.width} x ${this.canvas.height})`);
            this.x + n.width > this.canvas.width && (this.x = 0, this.y += this.curHeight, this.curHeight = 0), this.y + n.height > this.canvas.height && (this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this.tex = W.fromImage(this.canvas), this.x = 0, this.y = 0, this.curHeight = 0);
            let s = new $adc7cb3c45508c7c$var$y(this.x, this.y);
            return this.x += n.width, n.height > this.curHeight && (this.curHeight = n.height), n instanceof ImageData ? this.ctx.putImageData(n, s.x, s.y) : this.ctx.drawImage(n, s.x, s.y), this.tex.update(this.canvas), [
                this.tex,
                new $adc7cb3c45508c7c$var$ie(s.x / this.canvas.width, s.y / this.canvas.height, n.width / this.canvas.width, n.height / this.canvas.height)
            ];
        }
    }
    class De {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "FrameBuffer");
        })();
        tex;
        glFrameBuffer;
        glRenderBuffer;
        constructor(n, s, i1 = {}){
            this.tex = new W(n, s, i1), this.glFrameBuffer = d.createFramebuffer(), this.glRenderBuffer = d.createRenderbuffer(), X.push(()=>this.free()), this.bind(), d.renderbufferStorage(d.RENDERBUFFER, d.DEPTH_STENCIL, n, s), d.framebufferTexture2D(d.FRAMEBUFFER, d.COLOR_ATTACHMENT0, d.TEXTURE_2D, this.tex.glTex, 0), d.framebufferRenderbuffer(d.FRAMEBUFFER, d.DEPTH_STENCIL_ATTACHMENT, d.RENDERBUFFER, this.glRenderBuffer), this.unbind();
        }
        get width() {
            return this.tex.width;
        }
        get height() {
            return this.tex.height;
        }
        bind() {
            d.bindFramebuffer(d.FRAMEBUFFER, this.glFrameBuffer), d.bindRenderbuffer(d.RENDERBUFFER, this.glRenderBuffer);
        }
        unbind() {
            d.bindFramebuffer(d.FRAMEBUFFER, null), d.bindRenderbuffer(d.RENDERBUFFER, null);
        }
        free() {
            d.deleteFramebuffer(this.glFrameBuffer), d.deleteRenderbuffer(this.glRenderBuffer), this.tex.free();
        }
    }
    let v = (()=>{
        let e = Ke($adc7cb3c45508c7c$var$jn, $adc7cb3c45508c7c$var$Nn), n = W.fromImage(new ImageData(new Uint8ClampedArray([
            255,
            255,
            255,
            255
        ]), 1, 1)), s = r.width && r.height ? new De(r.width * j, r.height * j) : new De(d.drawingBufferWidth, d.drawingBufferHeight), i1 = null, a1 = 1;
        r.background && (i1 = $adc7cb3c45508c7c$var$q.fromArray(r.background), a1 = r.background[3] ?? 1, d.clearColor(i1.r / 255, i1.g / 255, i1.b / 255, a1)), d.enable(d.BLEND), d.enable(d.SCISSOR_TEST), d.blendFuncSeparate(d.SRC_ALPHA, d.ONE_MINUS_SRC_ALPHA, d.ONE, d.ONE_MINUS_SRC_ALPHA);
        let c1 = d.createBuffer();
        d.bindBuffer(d.ARRAY_BUFFER, c1), d.bufferData(d.ARRAY_BUFFER, $adc7cb3c45508c7c$var$qr * 4, d.DYNAMIC_DRAW), $adc7cb3c45508c7c$var$zr.reduce((m1, l1, p)=>(d.vertexAttribPointer(p, l1.size, d.FLOAT, !1, $adc7cb3c45508c7c$var$Kt * 4, m1), d.enableVertexAttribArray(p), m1 + l1.size * 4), 0), d.bindBuffer(d.ARRAY_BUFFER, null);
        let f = d.createBuffer();
        d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, f), d.bufferData(d.ELEMENT_ARRAY_BUFFER, $adc7cb3c45508c7c$var$$r * 4, d.DYNAMIC_DRAW), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null);
        let g1 = W.fromImage(new ImageData(new Uint8ClampedArray([
            128,
            128,
            128,
            255,
            190,
            190,
            190,
            255,
            190,
            190,
            190,
            255,
            128,
            128,
            128,
            255
        ]), 2, 2), {
            wrap: "repeat",
            filter: "nearest"
        });
        return {
            drawCalls: 0,
            lastDrawCalls: 0,
            defShader: e,
            curShader: e,
            frameBuffer: s,
            postShader: null,
            postShaderUniform: null,
            defTex: n,
            curTex: n,
            curUniform: {},
            vbuf: c1,
            ibuf: f,
            vqueue: [],
            iqueue: [],
            transform: new $adc7cb3c45508c7c$var$be,
            transformStack: [],
            bgTex: g1,
            bgColor: i1,
            bgAlpha: a1,
            width: r.width ?? d.drawingBufferWidth / j / w,
            height: r.height ?? d.drawingBufferHeight / j / w,
            viewport: {
                x: 0,
                y: 0,
                width: d.drawingBufferWidth,
                height: d.drawingBufferHeight
            },
            fixed: !1
        };
    })();
    class ce {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "SpriteData");
        })();
        tex;
        frames = [
            new $adc7cb3c45508c7c$var$ie(0, 0, 1, 1)
        ];
        anims = {};
        slice9 = null;
        constructor(n, s, i1 = {}, a1 = null){
            this.tex = n, s && (this.frames = s), this.anims = i1, this.slice9 = a1;
        }
        get width() {
            return this.tex.width * this.frames[0].w;
        }
        get height() {
            return this.tex.height * this.frames[0].h;
        }
        static from(n, s = {}) {
            return typeof n == "string" ? ce.fromURL(n, s) : Promise.resolve(ce.fromImage(n, s));
        }
        static fromImage(n, s = {}) {
            let [i1, a1] = V.packer.add(n), c1 = s.frames ? s.frames.map((f)=>new $adc7cb3c45508c7c$var$ie(a1.x + f.x * a1.w, a1.y + f.y * a1.h, f.w * a1.w, f.h * a1.h)) : bt(s.sliceX || 1, s.sliceY || 1, a1.x, a1.y, a1.w, a1.h);
            return new ce(i1, c1, s.anims, s.slice9);
        }
        static fromURL(n, s = {}) {
            return $e(n).then((i1)=>ce.fromImage(i1, s));
        }
    }
    class ge {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "SoundData");
        })();
        buf;
        constructor(n){
            this.buf = n;
        }
        static fromArrayBuffer(n) {
            return new Promise((s, i1)=>re.ctx.decodeAudioData(n, s, i1)).then((s)=>new ge(s));
        }
        static fromURL(n) {
            return $adc7cb3c45508c7c$var$Bn(n) ? ge.fromArrayBuffer($adc7cb3c45508c7c$var$Ur(n)) : Wt(n).then((s)=>ge.fromArrayBuffer(s));
        }
    }
    let re = (()=>{
        let e = new (window.AudioContext || window.webkitAudioContext), n = e.createGain();
        n.connect(e.destination);
        let s = new ge($adc7cb3c45508c7c$var$Di(e));
        return e.decodeAudioData($adc7cb3c45508c7c$var$Rr.buffer.slice(0)).then((i1)=>{
            s.buf = i1;
        }).catch((i1)=>{
            console.error("Failed to load burp: ", i1);
        }), {
            ctx: e,
            masterNode: n,
            burpSnd: s
        };
    })();
    class ue {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "Asset");
        })();
        loaded = !1;
        data = null;
        error = null;
        onLoadEvents = new $adc7cb3c45508c7c$var$ve;
        onErrorEvents = new $adc7cb3c45508c7c$var$ve;
        onFinishEvents = new $adc7cb3c45508c7c$var$ve;
        constructor(n){
            n.then((s)=>{
                this.data = s, this.onLoadEvents.trigger(s);
            }).catch((s)=>{
                if (this.error = s, this.onErrorEvents.numListeners() > 0) this.onErrorEvents.trigger(s);
                else throw s;
            }).finally(()=>{
                this.onFinishEvents.trigger(), this.loaded = !0;
            });
        }
        static loaded(n) {
            let s = new ue(Promise.resolve(n));
            return s.data = n, s.loaded = !0, s;
        }
        onLoad(n) {
            return this.loaded && this.data ? n(this.data) : this.onLoadEvents.add(n), this;
        }
        onError(n) {
            return this.loaded && this.error ? n(this.error) : this.onErrorEvents.add(n), this;
        }
        onFinish(n) {
            return this.loaded ? n() : this.onFinishEvents.add(n), this;
        }
        then(n) {
            return this.onLoad(n);
        }
        catch(n) {
            return this.onError(n);
        }
        finally(n) {
            return this.onFinish(n);
        }
    }
    class ye {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "AssetBucket");
        })();
        assets = new Map;
        lastUID = 0;
        add(n, s) {
            let i1 = n ?? this.lastUID++ + "", a1 = new ue(s);
            return this.assets.set(i1, a1), a1;
        }
        addLoaded(n, s) {
            let i1 = n ?? this.lastUID++ + "", a1 = ue.loaded(s);
            return this.assets.set(i1, a1), a1;
        }
        get(n) {
            return this.assets.get(n);
        }
        progress() {
            if (this.assets.size === 0) return 1;
            let n = 0;
            return this.assets.forEach((s)=>{
                s.loaded && n++;
            }), n / this.assets.size;
        }
    }
    let V = {
        urlPrefix: "",
        sprites: new ye,
        fonts: new ye,
        bitmapFonts: new ye,
        sounds: new ye,
        shaders: new ye,
        custom: new ye,
        packer: new fe($adc7cb3c45508c7c$var$Nr, $adc7cb3c45508c7c$var$kr),
        loaded: !1
    }, A = {
        events: new $adc7cb3c45508c7c$var$Re,
        objEvents: new $adc7cb3c45508c7c$var$Re,
        root: fn([]),
        gravity: 0,
        scenes: {},
        logs: [],
        cam: {
            pos: null,
            scale: new $adc7cb3c45508c7c$var$y(1),
            angle: 0,
            shake: 0,
            transform: new $adc7cb3c45508c7c$var$be
        }
    };
    function rt(e) {
        return V.custom.add(null, e);
    }
    $adc7cb3c45508c7c$var$o(rt, "load");
    function Ce() {
        let e = [
            V.sprites,
            V.sounds,
            V.shaders,
            V.fonts,
            V.bitmapFonts,
            V.custom
        ];
        return e.reduce((n, s)=>n + s.progress(), 0) / e.length;
    }
    $adc7cb3c45508c7c$var$o(Ce, "loadProgress");
    function Yt(e) {
        return e !== void 0 && (V.urlPrefix = e), V.urlPrefix;
    }
    $adc7cb3c45508c7c$var$o(Yt, "loadRoot");
    function st(e) {
        let n = V.urlPrefix + e;
        return fetch(n).then((s)=>{
            if (!s.ok) throw new Error(`Failed to fetch "${n}"`);
            return s;
        });
    }
    $adc7cb3c45508c7c$var$o(st, "fetchURL");
    function qe(e) {
        return st(e).then((n)=>n.json());
    }
    $adc7cb3c45508c7c$var$o(qe, "fetchJSON");
    function Xt(e) {
        return st(e).then((n)=>n.text());
    }
    $adc7cb3c45508c7c$var$o(Xt, "fetchText");
    function Wt(e) {
        return st(e).then((n)=>n.arrayBuffer());
    }
    $adc7cb3c45508c7c$var$o(Wt, "fetchArrayBuffer");
    function $e(e) {
        let n = new Image;
        return n.crossOrigin = "anonymous", n.src = $adc7cb3c45508c7c$var$Bn(e) ? e : V.urlPrefix + e, new Promise((s, i1)=>{
            n.onload = ()=>s(n), n.onerror = ()=>i1(new Error(`Failed to load image from "${e}"`));
        });
    }
    $adc7cb3c45508c7c$var$o($e, "loadImg");
    function Jt(e, n) {
        return V.custom.add(e, qe(n));
    }
    $adc7cb3c45508c7c$var$o(Jt, "loadJSON");
    class ze {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "FontData");
        })();
        fontface;
        outline;
        filter;
        constructor(n, s = {}){
            this.fontface = n, this.outline = s.outline ?? 0, this.filter = s.filter ?? $adc7cb3c45508c7c$var$Hr;
        }
    }
    function Qt(e, n, s = {}) {
        let i1 = new FontFace(e, typeof n == "string" ? `url(${n})` : n);
        return document.fonts.add(i1), V.fonts.add(e, i1.load().catch((a1)=>{
            throw new Error(`Failed to load font from "${n}": ${a1}`);
        }).then((a1)=>new ze(a1, s)));
    }
    $adc7cb3c45508c7c$var$o(Qt, "loadFont");
    function Zt(e, n, s, i1, a1 = {}) {
        return V.bitmapFonts.add(e, $e(n).then((c1)=>ln(W.fromImage(c1, a1), s, i1, a1.chars ?? $adc7cb3c45508c7c$var$Fr)));
    }
    $adc7cb3c45508c7c$var$o(Zt, "loadBitmapFont");
    function bt(e = 1, n = 1, s = 0, i1 = 0, a1 = 1, c1 = 1) {
        let f = [], g1 = a1 / e, m1 = c1 / n;
        for(let l1 = 0; l1 < n; l1++)for(let p = 0; p < e; p++)f.push(new $adc7cb3c45508c7c$var$ie(s + p * g1, i1 + l1 * m1, g1, m1));
        return f;
    }
    $adc7cb3c45508c7c$var$o(bt, "slice");
    function yt(e, n) {
        return rt(typeof n == "string" ? new Promise((s, i1)=>{
            qe(n).then((a1)=>{
                yt(e, a1).then(s).catch(i1);
            });
        }) : ce.from(e).then((s)=>{
            let i1 = {};
            for(let a1 in n){
                let c1 = n[a1], f = s.frames[0], g1 = $adc7cb3c45508c7c$var$Nr * f.w, m1 = $adc7cb3c45508c7c$var$kr * f.h, l1 = c1.frames ? c1.frames.map((C)=>new $adc7cb3c45508c7c$var$ie(f.x + (c1.x + C.x) / g1 * f.w, f.y + (c1.y + C.y) / m1 * f.h, C.w / g1 * f.w, C.h / m1 * f.h)) : bt(c1.sliceX || 1, c1.sliceY || 1, f.x + c1.x / g1 * f.w, f.y + c1.y / m1 * f.h, c1.width / g1 * f.w, c1.height / m1 * f.h), p = new ce(s.tex, l1, c1.anims);
                V.sprites.addLoaded(a1, p), i1[a1] = p;
            }
            return i1;
        }));
    }
    $adc7cb3c45508c7c$var$o(yt, "loadSpriteAtlas");
    function xt(e, n = {}) {
        let s = document.createElement("canvas"), i1 = e[0].width, a1 = e[0].height;
        s.width = i1 * e.length, s.height = a1;
        let c1 = s.getContext("2d");
        e.forEach((g1, m1)=>{
            g1 instanceof ImageData ? c1.putImageData(g1, m1 * i1, 0) : c1.drawImage(g1, m1 * i1, 0);
        });
        let f = c1.getImageData(0, 0, e.length * i1, a1);
        return ce.fromImage(f, {
            ...n,
            sliceX: e.length,
            sliceY: 1
        });
    }
    $adc7cb3c45508c7c$var$o(xt, "createSpriteSheet");
    function Ie(e, n, s = {
        sliceX: 1,
        sliceY: 1,
        anims: {}
    }) {
        return Array.isArray(n) ? n.some((i1)=>typeof i1 == "string") ? V.sprites.add(e, Promise.all(n.map((i1)=>typeof i1 == "string" ? $e(i1) : Promise.resolve(i1))).then((i1)=>xt(i1, s))) : V.sprites.addLoaded(e, xt(n, s)) : typeof n == "string" ? V.sprites.add(e, ce.from(n, s)) : V.sprites.addLoaded(e, ce.fromImage(n, s));
    }
    $adc7cb3c45508c7c$var$o(Ie, "loadSprite");
    function en(e, n) {
        return V.sprites.add(e, new Promise(async (s)=>{
            let i1 = typeof n == "string" ? await qe(n) : n, a1 = await Promise.all(i1.frames.map($e)), c1 = document.createElement("canvas");
            c1.width = i1.width, c1.height = i1.height * i1.frames.length;
            let f = c1.getContext("2d");
            a1.forEach((m1, l1)=>{
                f.drawImage(m1, 0, l1 * i1.height);
            });
            let g1 = await Ie(null, c1, {
                sliceY: i1.frames.length,
                anims: i1.anims
            });
            s(g1);
        }));
    }
    $adc7cb3c45508c7c$var$o(en, "loadPedit");
    function tn(e, n, s) {
        typeof n == "string" && !s && (s = n.replace(new RegExp(`${$adc7cb3c45508c7c$var$Sr(n)}$`), "json"));
        let i1 = typeof s == "string" ? qe(s) : Promise.resolve(s);
        return V.sprites.add(e, i1.then((a1)=>{
            let c1 = a1.meta.size, f = a1.frames.map((m1)=>new $adc7cb3c45508c7c$var$ie(m1.frame.x / c1.w, m1.frame.y / c1.h, m1.frame.w / c1.w, m1.frame.h / c1.h)), g1 = {};
            for (let m1 of a1.meta.frameTags)m1.from === m1.to ? g1[m1.name] = m1.from : g1[m1.name] = {
                from: m1.from,
                to: m1.to,
                speed: 10,
                loop: !0,
                pingpong: m1.direction === "pingpong"
            };
            return ce.from(n, {
                frames: f,
                anims: g1
            });
        }));
    }
    $adc7cb3c45508c7c$var$o(tn, "loadAseprite");
    function nn(e, n, s) {
        return V.shaders.addLoaded(e, Ke(n, s));
    }
    $adc7cb3c45508c7c$var$o(nn, "loadShader");
    function rn(e, n, s) {
        let i1 = $adc7cb3c45508c7c$var$o((c1)=>c1 ? Xt(c1) : Promise.resolve(null), "resolveUrl"), a1 = Promise.all([
            i1(n),
            i1(s)
        ]).then(([c1, f])=>Ke(c1, f));
        return V.shaders.add(e, a1);
    }
    $adc7cb3c45508c7c$var$o(rn, "loadShaderURL");
    function sn(e, n) {
        return V.sounds.add(e, typeof n == "string" ? ge.fromURL(n) : ge.fromArrayBuffer(n));
    }
    $adc7cb3c45508c7c$var$o(sn, "loadSound");
    function on(e = "bean") {
        return Ie(e, $adc7cb3c45508c7c$var$Mr);
    }
    $adc7cb3c45508c7c$var$o(on, "loadBean");
    function Ut(e) {
        return V.sprites.get(e);
    }
    $adc7cb3c45508c7c$var$o(Ut, "getSprite");
    function Et(e) {
        return V.sounds.get(e);
    }
    $adc7cb3c45508c7c$var$o(Et, "getSound");
    function St(e) {
        return V.fonts.get(e);
    }
    $adc7cb3c45508c7c$var$o(St, "getFont");
    function Ct(e) {
        return V.bitmapFonts.get(e);
    }
    $adc7cb3c45508c7c$var$o(Ct, "getBitmapFont");
    function Tt(e) {
        return V.shaders.get(e);
    }
    $adc7cb3c45508c7c$var$o(Tt, "getShader");
    function an(e) {
        return V.custom.get(e);
    }
    $adc7cb3c45508c7c$var$o(an, "getAsset");
    function it(e) {
        if (typeof e == "string") {
            let n = Ut(e);
            if (n) return n;
            if (Ce() < 1) return null;
            throw new Error(`Sprite not found: ${e}`);
        } else {
            if (e instanceof ce) return ue.loaded(e);
            if (e instanceof ue) return e;
            throw new Error(`Invalid sprite: ${e}`);
        }
    }
    $adc7cb3c45508c7c$var$o(it, "resolveSprite");
    function un(e) {
        if (typeof e == "string") {
            let n = Et(e);
            if (n) return n;
            if (Ce() < 1) return null;
            throw new Error(`Sound not found: ${e}`);
        } else {
            if (e instanceof ge) return ue.loaded(e);
            if (e instanceof ue) return e;
            throw new Error(`Invalid sound: ${e}`);
        }
    }
    $adc7cb3c45508c7c$var$o(un, "resolveSound");
    function cn(e) {
        if (!e) return v.defShader;
        if (typeof e == "string") {
            let n = Tt(e);
            if (n) return n.data ?? n;
            if (Ce() < 1) return null;
            throw new Error(`Shader not found: ${e}`);
        } else if (e instanceof ue) return e.data ? e.data : e;
        return e;
    }
    $adc7cb3c45508c7c$var$o(cn, "resolveShader");
    function At(e) {
        if (!e) return At(r.font ?? $adc7cb3c45508c7c$var$Ui);
        if (typeof e == "string") {
            let n = Ct(e), s = St(e);
            if (n) return n.data ?? n;
            if (s) return s.data ?? s;
            if (document.fonts.check(`${$adc7cb3c45508c7c$var$Lr}px ${e}`)) return e;
            if (Ce() < 1) return null;
            throw new Error(`Font not found: ${e}`);
        } else if (e instanceof ue) return e.data ? e.data : e;
        return e;
    }
    $adc7cb3c45508c7c$var$o(At, "resolveFont");
    function Ot(e) {
        return e !== void 0 && (re.masterNode.gain.value = e), re.masterNode.gain.value;
    }
    $adc7cb3c45508c7c$var$o(Ot, "volume");
    function Pt(e, n = {}) {
        let s = re.ctx, i1 = n.paused ?? !1, a1 = s.createBufferSource(), c1 = new $adc7cb3c45508c7c$var$ve, f = s.createGain(), g1 = n.seek ?? 0, m1 = 0, l1 = 0, p = !1;
        a1.loop = !!n.loop, a1.detune.value = n.detune ?? 0, a1.playbackRate.value = n.speed ?? 1, a1.connect(f), a1.onended = ()=>{
            G() >= a1.buffer?.duration && c1.trigger();
        }, f.connect(re.masterNode), f.gain.value = n.volume ?? 1;
        let C = $adc7cb3c45508c7c$var$o((M1)=>{
            a1.buffer = M1.buf, i1 || (m1 = s.currentTime, a1.start(0, g1), p = !0);
        }, "start"), R = un(e);
        R instanceof ue && R.onLoad(C);
        let G = $adc7cb3c45508c7c$var$o(()=>{
            if (!a1.buffer) return 0;
            let M1 = i1 ? l1 - m1 : s.currentTime - m1, O = a1.buffer.duration;
            return a1.loop ? M1 % O : Math.min(M1, O);
        }, "getTime"), k = $adc7cb3c45508c7c$var$o((M1)=>{
            let O = s.createBufferSource();
            return O.buffer = M1.buffer, O.loop = M1.loop, O.playbackRate.value = M1.playbackRate.value, O.detune.value = M1.detune.value, O.onended = M1.onended, O.connect(f), O;
        }, "cloneNode");
        return {
            stop () {
                this.paused = !0, this.seek(0);
            },
            set paused (M){
                if (i1 !== M) {
                    if (i1 = M, M) p && (a1.stop(), p = !1), l1 = s.currentTime;
                    else {
                        a1 = k(a1);
                        let O = l1 - m1;
                        a1.start(0, O), p = !0, m1 = s.currentTime - O, l1 = 0;
                    }
                }
            },
            get paused () {
                return i1;
            },
            play (M1 = 0) {
                this.seek(M1), this.paused = !1;
            },
            seek (M1) {
                a1.buffer?.duration && (M1 > a1.buffer.duration || (i1 ? (a1 = k(a1), m1 = l1 - M1) : (a1.stop(), a1 = k(a1), m1 = s.currentTime - M1, a1.start(0, M1), p = !0, l1 = 0)));
            },
            set speed (M){
                a1.playbackRate.value = M;
            },
            get speed () {
                return a1.playbackRate.value;
            },
            set detune (M){
                a1.detune.value = M;
            },
            get detune () {
                return a1.detune.value;
            },
            set volume (M){
                f.gain.value = Math.max(M, 0);
            },
            get volume () {
                return f.gain.value;
            },
            set loop (M){
                a1.loop = M;
            },
            get loop () {
                return a1.loop;
            },
            duration () {
                return a1.buffer?.duration ?? 0;
            },
            time () {
                return G() % this.duration();
            },
            onEnd (M1) {
                return c1.add(M1);
            },
            then (M1) {
                return this.onEnd(M1);
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Pt, "play");
    function Mt(e) {
        return Pt(re.burpSnd, e);
    }
    $adc7cb3c45508c7c$var$o(Mt, "burp");
    function Ke(e = $adc7cb3c45508c7c$var$jn, n = $adc7cb3c45508c7c$var$Nn) {
        let s = $adc7cb3c45508c7c$var$Ai.replace("{{user}}", e ?? $adc7cb3c45508c7c$var$jn), i1 = $adc7cb3c45508c7c$var$Oi.replace("{{user}}", n ?? $adc7cb3c45508c7c$var$Nn), a1 = d.createShader(d.VERTEX_SHADER), c1 = d.createShader(d.FRAGMENT_SHADER);
        d.shaderSource(a1, s), d.shaderSource(c1, i1), d.compileShader(a1), d.compileShader(c1);
        let f = d.createProgram();
        if (X.push(()=>d.deleteProgram(f)), d.attachShader(f, a1), d.attachShader(f, c1), d.bindAttribLocation(f, 0, "a_pos"), d.bindAttribLocation(f, 1, "a_uv"), d.bindAttribLocation(f, 2, "a_color"), d.linkProgram(f), !d.getProgramParameter(f, d.LINK_STATUS)) {
            let g1 = $adc7cb3c45508c7c$var$o((C)=>{
                let R = /^ERROR:\s0:(?<line>\d+):\s(?<msg>.+)/, G = C.match(R);
                return {
                    line: Number(G.groups.line),
                    msg: G.groups.msg.replace(/\n\0$/, "")
                };
            }, "formatShaderError"), m1 = d.getShaderInfoLog(a1), l1 = d.getShaderInfoLog(c1), p = "";
            if (m1) {
                let C = g1(m1);
                p += `Vertex shader line ${C.line - 14}: ${C.msg}`;
            }
            if (l1) {
                let C = g1(l1);
                p += `Fragment shader line ${C.line - 14}: ${C.msg}`;
            }
            throw new Error(p);
        }
        return d.deleteShader(a1), d.deleteShader(c1), {
            bind () {
                d.useProgram(f);
            },
            unbind () {
                d.useProgram(null);
            },
            free () {
                d.deleteProgram(f);
            },
            send (g1) {
                for(let m1 in g1){
                    let l1 = g1[m1], p = d.getUniformLocation(f, m1);
                    typeof l1 == "number" ? d.uniform1f(p, l1) : l1 instanceof $adc7cb3c45508c7c$var$be ? d.uniformMatrix4fv(p, !1, new Float32Array(l1.m)) : l1 instanceof $adc7cb3c45508c7c$var$q ? d.uniform3f(p, l1.r, l1.g, l1.b) : l1 instanceof $adc7cb3c45508c7c$var$y && d.uniform2f(p, l1.x, l1.y);
                }
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ke, "makeShader");
    function ln(e, n, s, i1) {
        let a1 = e.width / n, c1 = {}, f = i1.split("").entries();
        for (let [g1, m1] of f)c1[m1] = new $adc7cb3c45508c7c$var$ie(g1 % a1 * n, Math.floor(g1 / a1) * s, n, s);
        return {
            tex: e,
            map: c1,
            size: s
        };
    }
    $adc7cb3c45508c7c$var$o(ln, "makeFont");
    function ot(e, n, s, i1 = v.defTex, a1 = v.defShader, c1 = {}) {
        let f = cn(a1);
        if (!f || f instanceof ue) return;
        (i1 !== v.curTex || f !== v.curShader || !$adc7cb3c45508c7c$var$Dn(v.curUniform, c1) || v.vqueue.length + e.length * $adc7cb3c45508c7c$var$Kt > $adc7cb3c45508c7c$var$qr || v.iqueue.length + n.length > $adc7cb3c45508c7c$var$$r) && z();
        let g1 = v.fixed || s ? v.transform : A.cam.transform.mult(v.transform);
        for (let m1 of e){
            let l1 = hn(g1.multVec2(m1.pos));
            v.vqueue.push(l1.x, l1.y, m1.uv.x, m1.uv.y, m1.color.r / 255, m1.color.g / 255, m1.color.b / 255, m1.opacity);
        }
        for (let m1 of n)v.iqueue.push(m1 + v.vqueue.length / $adc7cb3c45508c7c$var$Kt - e.length);
        v.curTex = i1, v.curShader = f, v.curUniform = c1;
    }
    $adc7cb3c45508c7c$var$o(ot, "drawRaw");
    function z() {
        !v.curTex || !v.curShader || v.vqueue.length === 0 || v.iqueue.length === 0 || (d.bindBuffer(d.ARRAY_BUFFER, v.vbuf), d.bufferSubData(d.ARRAY_BUFFER, 0, new Float32Array(v.vqueue)), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, v.ibuf), d.bufferSubData(d.ELEMENT_ARRAY_BUFFER, 0, new Uint16Array(v.iqueue)), v.curShader.bind(), v.curShader.send(v.curUniform), v.curTex.bind(), d.drawElements(d.TRIANGLES, v.iqueue.length, d.UNSIGNED_SHORT, 0), v.curTex.unbind(), v.curShader.unbind(), d.bindBuffer(d.ARRAY_BUFFER, null), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null), v.vqueue.length = 0, v.iqueue.length = 0, v.drawCalls++);
    }
    $adc7cb3c45508c7c$var$o(z, "flush");
    function Ge() {
        d.clear(d.COLOR_BUFFER_BIT), v.frameBuffer.bind(), d.viewport(0, 0, v.frameBuffer.width, v.frameBuffer.height), d.clear(d.COLOR_BUFFER_BIT), v.bgColor || Be(()=>{
            me({
                width: pe(),
                height: we(),
                quad: new $adc7cb3c45508c7c$var$ie(0, 0, pe() / $adc7cb3c45508c7c$var$Br, we() / $adc7cb3c45508c7c$var$Br),
                tex: v.bgTex,
                fixed: !0
            });
        }), v.drawCalls = 0, v.fixed = !1, v.transformStack.length = 0, v.transform = new $adc7cb3c45508c7c$var$be;
    }
    $adc7cb3c45508c7c$var$o(Ge, "frameStart");
    function Fe(e, n) {
        v.postShader = e, v.postShaderUniform = n ?? null;
    }
    $adc7cb3c45508c7c$var$o(Fe, "usePostEffect");
    function at() {
        z(), v.frameBuffer.unbind(), d.viewport(0, 0, d.drawingBufferWidth, d.drawingBufferHeight), z();
        let e = v.width, n = v.height;
        v.width = d.drawingBufferWidth / j, v.height = d.drawingBufferHeight / j, Z({
            flipY: !0,
            tex: v.frameBuffer.tex,
            pos: new $adc7cb3c45508c7c$var$y(v.viewport.x, v.viewport.y),
            width: v.viewport.width,
            height: v.viewport.height,
            shader: v.postShader,
            uniform: typeof v.postShaderUniform == "function" ? v.postShaderUniform() : v.postShaderUniform,
            fixed: !0
        }), z(), v.width = e, v.height = n, v.lastDrawCalls = v.drawCalls;
    }
    $adc7cb3c45508c7c$var$o(at, "frameEnd");
    function hn(e) {
        return new $adc7cb3c45508c7c$var$y(e.x / pe() * 2 - 1, -e.y / we() * 2 + 1);
    }
    $adc7cb3c45508c7c$var$o(hn, "screen2ndc");
    function Rt(e) {
        v.transform = e.clone();
    }
    $adc7cb3c45508c7c$var$o(Rt, "pushMatrix");
    function Q(...e) {
        if (e[0] === void 0) return;
        let n = $adc7cb3c45508c7c$var$T(...e);
        n.x === 0 && n.y === 0 || v.transform.translate(n);
    }
    $adc7cb3c45508c7c$var$o(Q, "pushTranslate");
    function h(...e) {
        if (e[0] === void 0) return;
        let n = $adc7cb3c45508c7c$var$T(...e);
        n.x === 1 && n.y === 1 || v.transform.scale(n);
    }
    $adc7cb3c45508c7c$var$o(h, "pushScale");
    function x(e) {
        e && v.transform.rotate(e);
    }
    $adc7cb3c45508c7c$var$o(x, "pushRotate");
    function E() {
        v.transformStack.push(v.transform.clone());
    }
    $adc7cb3c45508c7c$var$o(E, "pushTransform");
    function L() {
        v.transformStack.length > 0 && (v.transform = v.transformStack.pop());
    }
    $adc7cb3c45508c7c$var$o(L, "popTransform");
    function me(e) {
        if (e.width === void 0 || e.height === void 0) throw new Error('drawUVQuad() requires property "width" and "height".');
        if (e.width <= 0 || e.height <= 0) return;
        let n = e.width, s = e.height, a1 = $adc7cb3c45508c7c$var$nt(e.anchor || $adc7cb3c45508c7c$var$$t).scale(new $adc7cb3c45508c7c$var$y(n, s).scale(-0.5)), c1 = e.quad || new $adc7cb3c45508c7c$var$ie(0, 0, 1, 1), f = e.color || $adc7cb3c45508c7c$var$J(255, 255, 255), g1 = e.opacity ?? 1, m1 = e.tex ? $adc7cb3c45508c7c$var$_r / e.tex.width : 0, l1 = e.tex ? $adc7cb3c45508c7c$var$_r / e.tex.height : 0, p = c1.x + m1, C = c1.y + l1, R = c1.w - m1 * 2, G = c1.h - l1 * 2;
        E(), Q(e.pos), x(e.angle), h(e.scale), Q(a1), ot([
            {
                pos: new $adc7cb3c45508c7c$var$y(-n / 2, s / 2),
                uv: new $adc7cb3c45508c7c$var$y(e.flipX ? p + R : p, e.flipY ? C : C + G),
                color: f,
                opacity: g1
            },
            {
                pos: new $adc7cb3c45508c7c$var$y(-n / 2, -s / 2),
                uv: new $adc7cb3c45508c7c$var$y(e.flipX ? p + R : p, e.flipY ? C + G : C),
                color: f,
                opacity: g1
            },
            {
                pos: new $adc7cb3c45508c7c$var$y(n / 2, -s / 2),
                uv: new $adc7cb3c45508c7c$var$y(e.flipX ? p : p + R, e.flipY ? C + G : C),
                color: f,
                opacity: g1
            },
            {
                pos: new $adc7cb3c45508c7c$var$y(n / 2, s / 2),
                uv: new $adc7cb3c45508c7c$var$y(e.flipX ? p : p + R, e.flipY ? C : C + G),
                color: f,
                opacity: g1
            }
        ], [
            0,
            1,
            3,
            1,
            2,
            3
        ], e.fixed, e.tex, e.shader, e.uniform), L();
    }
    $adc7cb3c45508c7c$var$o(me, "drawUVQuad");
    function Z(e) {
        if (!e.tex) throw new Error('drawTexture() requires property "tex".');
        let n = e.quad ?? new $adc7cb3c45508c7c$var$ie(0, 0, 1, 1), s = e.tex.width * n.w, i1 = e.tex.height * n.h, a1 = new $adc7cb3c45508c7c$var$y(1);
        if (e.tiled) {
            let c1 = Math.ceil((e.width || s) / s), f = Math.ceil((e.height || i1) / i1), m1 = $adc7cb3c45508c7c$var$nt(e.anchor || $adc7cb3c45508c7c$var$$t).add(new $adc7cb3c45508c7c$var$y(1, 1)).scale(.5).scale(c1 * s, f * i1);
            for(let l1 = 0; l1 < c1; l1++)for(let p = 0; p < f; p++)me(Object.assign({}, e, {
                pos: (e.pos || new $adc7cb3c45508c7c$var$y(0)).add(new $adc7cb3c45508c7c$var$y(s * l1, i1 * p)).sub(m1),
                scale: a1.scale(e.scale || new $adc7cb3c45508c7c$var$y(1)),
                tex: e.tex,
                quad: n,
                width: s,
                height: i1,
                anchor: "topleft"
            }));
        } else e.width && e.height ? (a1.x = e.width / s, a1.y = e.height / i1) : e.width ? (a1.x = e.width / s, a1.y = a1.x) : e.height && (a1.y = e.height / i1, a1.x = a1.y), me(Object.assign({}, e, {
            scale: a1.scale(e.scale || new $adc7cb3c45508c7c$var$y(1)),
            tex: e.tex,
            quad: n,
            width: s,
            height: i1
        }));
    }
    $adc7cb3c45508c7c$var$o(Z, "drawTexture");
    function Ye(e) {
        if (!e.sprite) throw new Error('drawSprite() requires property "sprite"');
        let n = it(e.sprite);
        if (!n || !n.data) return;
        let s = n.data.frames[e.frame ?? 0];
        if (!s) throw new Error(`Frame not found: ${e.frame ?? 0}`);
        Z(Object.assign({}, e, {
            tex: n.data.tex,
            quad: s.scale(e.quad ?? new $adc7cb3c45508c7c$var$ie(0, 0, 1, 1))
        }));
    }
    $adc7cb3c45508c7c$var$o(Ye, "drawSprite");
    function Te(e, n, s, i1, a1, c1 = 1) {
        i1 = $adc7cb3c45508c7c$var$Ee(i1 % 360), a1 = $adc7cb3c45508c7c$var$Ee(a1 % 360), a1 <= i1 && (a1 += Math.PI * 2);
        let f = [], g1 = Math.ceil((a1 - i1) / $adc7cb3c45508c7c$var$Ee(8) * c1), m1 = (a1 - i1) / g1;
        for(let l1 = i1; l1 < a1; l1 += m1)f.push(e.add(n * Math.cos(l1), s * Math.sin(l1)));
        return f.push(e.add(n * Math.cos(a1), s * Math.sin(a1))), f;
    }
    $adc7cb3c45508c7c$var$o(Te, "getArcPts");
    function xe(e) {
        if (e.width === void 0 || e.height === void 0) throw new Error('drawRect() requires property "width" and "height".');
        if (e.width <= 0 || e.height <= 0) return;
        let n = e.width, s = e.height, a1 = $adc7cb3c45508c7c$var$nt(e.anchor || $adc7cb3c45508c7c$var$$t).add(1, 1).scale(new $adc7cb3c45508c7c$var$y(n, s).scale(-0.5)), c1 = [
            new $adc7cb3c45508c7c$var$y(0, 0),
            new $adc7cb3c45508c7c$var$y(n, 0),
            new $adc7cb3c45508c7c$var$y(n, s),
            new $adc7cb3c45508c7c$var$y(0, s)
        ];
        if (e.radius) {
            let f = Math.min(Math.min(n, s) / 2, e.radius);
            c1 = [
                new $adc7cb3c45508c7c$var$y(f, 0),
                new $adc7cb3c45508c7c$var$y(n - f, 0),
                ...Te(new $adc7cb3c45508c7c$var$y(n - f, f), f, f, 270, 360),
                new $adc7cb3c45508c7c$var$y(n, f),
                new $adc7cb3c45508c7c$var$y(n, s - f),
                ...Te(new $adc7cb3c45508c7c$var$y(n - f, s - f), f, f, 0, 90),
                new $adc7cb3c45508c7c$var$y(n - f, s),
                new $adc7cb3c45508c7c$var$y(f, s),
                ...Te(new $adc7cb3c45508c7c$var$y(f, s - f), f, f, 90, 180),
                new $adc7cb3c45508c7c$var$y(0, s - f),
                new $adc7cb3c45508c7c$var$y(0, f),
                ...Te(new $adc7cb3c45508c7c$var$y(f, f), f, f, 180, 270)
            ];
        }
        Ve(Object.assign({}, e, {
            offset: a1,
            pts: c1,
            ...e.gradient ? {
                colors: e.horizontal ? [
                    e.gradient[0],
                    e.gradient[1],
                    e.gradient[1],
                    e.gradient[0]
                ] : [
                    e.gradient[0],
                    e.gradient[0],
                    e.gradient[1],
                    e.gradient[1]
                ]
            } : {}
        }));
    }
    $adc7cb3c45508c7c$var$o(xe, "drawRect");
    function ut(e) {
        let { p1: n, p2: s } = e;
        if (!n || !s) throw new Error('drawLine() requires properties "p1" and "p2".');
        let i1 = e.width || 1, a1 = s.sub(n).unit().normal().scale(i1 * .5), c1 = [
            n.sub(a1),
            n.add(a1),
            s.add(a1),
            s.sub(a1)
        ].map((f)=>({
                pos: new $adc7cb3c45508c7c$var$y(f.x, f.y),
                uv: new $adc7cb3c45508c7c$var$y(0),
                color: e.color ?? $adc7cb3c45508c7c$var$q.WHITE,
                opacity: e.opacity ?? 1
            }));
        ot(c1, [
            0,
            1,
            3,
            1,
            2,
            3
        ], e.fixed, v.defTex, e.shader, e.uniform);
    }
    $adc7cb3c45508c7c$var$o(ut, "drawLine");
    function kn(e) {
        let n = e.pts;
        if (!n) throw new Error('drawLines() requires property "pts".');
        if (!(n.length < 2)) {
            if (e.radius && n.length >= 3) {
                let s = n[0].sdist(n[1]);
                for(let a1 = 1; a1 < n.length - 1; a1++)s = Math.min(n[a1].sdist(n[a1 + 1]), s);
                let i1 = Math.min(e.radius, Math.sqrt(s) / 2);
                ut(Object.assign({}, e, {
                    p1: n[0],
                    p2: n[1]
                }));
                for(let a1 = 1; a1 < n.length - 2; a1++){
                    let c1 = n[a1], f = n[a1 + 1];
                    ut(Object.assign({}, e, {
                        p1: c1,
                        p2: f
                    }));
                }
                ut(Object.assign({}, e, {
                    p1: n[n.length - 2],
                    p2: n[n.length - 1]
                }));
            } else for(let s = 0; s < n.length - 1; s++)ut(Object.assign({}, e, {
                p1: n[s],
                p2: n[s + 1]
            })), e.join !== "none" && Xe(Object.assign({}, e, {
                pos: n[s],
                radius: e.width / 2
            }));
        }
    }
    $adc7cb3c45508c7c$var$o(kn, "drawLines");
    function _n(e) {
        if (!e.p1 || !e.p2 || !e.p3) throw new Error('drawPolygon() requires properties "p1", "p2" and "p3".');
        return Ve(Object.assign({}, e, {
            pts: [
                e.p1,
                e.p2,
                e.p3
            ]
        }));
    }
    $adc7cb3c45508c7c$var$o(_n, "drawTriangle");
    function Xe(e) {
        if (typeof e.radius != "number") throw new Error('drawCircle() requires property "radius".');
        e.radius !== 0 && Hn(Object.assign({}, e, {
            radiusX: e.radius,
            radiusY: e.radius,
            angle: 0
        }));
    }
    $adc7cb3c45508c7c$var$o(Xe, "drawCircle");
    function Hn(e) {
        if (e.radiusX === void 0 || e.radiusY === void 0) throw new Error('drawEllipse() requires properties "radiusX" and "radiusY".');
        if (e.radiusX === 0 || e.radiusY === 0) return;
        let n = e.start ?? 0, s = e.end ?? 360, i1 = $adc7cb3c45508c7c$var$nt(e.anchor ?? "center").scale(new $adc7cb3c45508c7c$var$y(-e.radiusX, -e.radiusY)), a1 = Te(i1, e.radiusX, e.radiusY, n, s, e.resolution);
        a1.unshift(i1);
        let c1 = Object.assign({}, e, {
            pts: a1,
            radius: 0,
            ...e.gradient ? {
                colors: [
                    e.gradient[0],
                    ...Array(a1.length - 1).fill(e.gradient[1])
                ]
            } : {}
        });
        if (s - n >= 360 && e.outline) {
            e.fill !== !1 && Ve(Object.assign(c1, {
                outline: null
            })), Ve(Object.assign(c1, {
                pts: a1.slice(1),
                fill: !1
            }));
            return;
        }
        Ve(c1);
    }
    $adc7cb3c45508c7c$var$o(Hn, "drawEllipse");
    function Ve(e) {
        if (!e.pts) throw new Error('drawPolygon() requires property "pts".');
        let n = e.pts.length;
        if (!(n < 3)) {
            if (E(), Q(e.pos), h(e.scale), x(e.angle), Q(e.offset), e.fill !== !1) {
                let s = e.color ?? $adc7cb3c45508c7c$var$q.WHITE, i1 = e.pts.map((c1, f)=>({
                        pos: new $adc7cb3c45508c7c$var$y(c1.x, c1.y),
                        uv: new $adc7cb3c45508c7c$var$y(0, 0),
                        color: e.colors ? e.colors[f] ?? s : s,
                        opacity: e.opacity ?? 1
                    })), a1 = [
                    ...Array(n - 2).keys()
                ].map((c1)=>[
                        0,
                        c1 + 1,
                        c1 + 2
                    ]).flat();
                ot(i1, e.indices ?? a1, e.fixed, v.defTex, e.shader, e.uniform);
            }
            e.outline && kn({
                pts: [
                    ...e.pts,
                    e.pts[0]
                ],
                radius: e.radius,
                width: e.outline.width,
                color: e.outline.color,
                join: e.outline.join,
                uniform: e.uniform,
                fixed: e.fixed,
                opacity: e.opacity
            }), L();
        }
    }
    $adc7cb3c45508c7c$var$o(Ve, "drawPolygon");
    function qn(e, n, s) {
        z(), d.clear(d.STENCIL_BUFFER_BIT), d.enable(d.STENCIL_TEST), d.stencilFunc(d.NEVER, 1, 255), d.stencilOp(d.REPLACE, d.REPLACE, d.REPLACE), n(), z(), d.stencilFunc(s, 1, 255), d.stencilOp(d.KEEP, d.KEEP, d.KEEP), e(), z(), d.disable(d.STENCIL_TEST);
    }
    $adc7cb3c45508c7c$var$o(qn, "drawStenciled");
    function Yr(e, n) {
        qn(e, n, d.EQUAL);
    }
    $adc7cb3c45508c7c$var$o(Yr, "drawMasked");
    function Xr(e, n) {
        qn(e, n, d.NOTEQUAL);
    }
    $adc7cb3c45508c7c$var$o(Xr, "drawSubtracted");
    function $n() {
        return (v.viewport.width + v.viewport.height) / (v.width + v.height);
    }
    $adc7cb3c45508c7c$var$o($n, "getViewportScale");
    function Be(e) {
        z();
        let n = v.width, s = v.height;
        v.width = v.viewport.width, v.height = v.viewport.height, e(), z(), v.width = n, v.height = s;
    }
    $adc7cb3c45508c7c$var$o(Be, "drawUnscaled");
    function zn(e, n) {
        n.pos && (e.pos = e.pos.add(n.pos)), n.scale && (e.scale = e.scale.scale($adc7cb3c45508c7c$var$T(n.scale))), n.angle && (e.angle += n.angle), n.color && (e.color = e.color.mult(n.color)), n.opacity && (e.opacity *= n.opacity);
    }
    $adc7cb3c45508c7c$var$o(zn, "applyCharTransform");
    let Kn = /\[(?<style>\w+)\](?<text>.*?)\[\/\k<style>\]/g;
    function Wr(e) {
        let n = {}, s = e.replace(Kn, "$2"), i1 = 0;
        for (let a1 of e.matchAll(Kn)){
            let c1 = a1.index - i1;
            for(let f = 0; f < a1.groups.text.length; f++)n[f + c1] = [
                a1.groups.style
            ];
            i1 += a1[0].length - a1.groups.text.length;
        }
        return {
            charStyleMap: n,
            text: s
        };
    }
    $adc7cb3c45508c7c$var$o(Wr, "compileStyledText");
    let dn = {};
    function je(e) {
        if (e.text === void 0) throw new Error('formatText() requires property "text".');
        let n = At(e.font);
        if (e.text === "" || n instanceof ue || !n) return {
            width: 0,
            height: 0,
            chars: [],
            opt: e
        };
        let { charStyleMap: s, text: i1 } = Wr(e.text + ""), a1 = i1.split("");
        if (n instanceof ze || typeof n == "string") {
            let K = n instanceof ze ? n.fontface.family : n, N = n instanceof ze ? {
                outline: n.outline,
                filter: n.filter
            } : {
                outline: 0,
                filter: $adc7cb3c45508c7c$var$Hr
            }, I = dn[K] ?? {
                font: {
                    tex: new W($adc7cb3c45508c7c$var$Vr, $adc7cb3c45508c7c$var$jr, {
                        filter: N.filter
                    }),
                    map: {},
                    size: $adc7cb3c45508c7c$var$Lr
                },
                cursor: new $adc7cb3c45508c7c$var$y(0),
                outline: N.outline
            };
            dn[K] || (dn[K] = I), n = I.font;
            for (let he of a1)if (!I.font.map[he]) {
                let b = ae;
                b.clearRect(0, 0, ee.width, ee.height), b.font = `${n.size}px ${K}`, b.textBaseline = "top", b.textAlign = "left", b.fillStyle = "#ffffff";
                let P = b.measureText(he), D = Math.ceil(P.width), F = n.size;
                I.outline && (b.lineJoin = "round", b.lineWidth = I.outline * 2, b.strokeStyle = "#000000", b.strokeText(he, I.outline, I.outline), D += I.outline * 2, F += I.outline * 3), b.fillText(he, I.outline, I.outline);
                let _ = b.getImageData(0, 0, D, F);
                if (I.cursor.x + D > $adc7cb3c45508c7c$var$Vr && (I.cursor.x = 0, I.cursor.y += F, I.cursor.y > $adc7cb3c45508c7c$var$jr)) throw new Error("Font atlas exceeds character limit");
                n.tex.update(_, I.cursor.x, I.cursor.y), n.map[he] = new $adc7cb3c45508c7c$var$ie(I.cursor.x, I.cursor.y, D, F), I.cursor.x += D;
            }
        }
        let c1 = e.size || n.size, f = $adc7cb3c45508c7c$var$T(e.scale ?? 1).scale(c1 / n.size), g1 = e.lineSpacing ?? 0, m1 = e.letterSpacing ?? 0, l1 = 0, p = 0, C = 0, R = [], G = [], k = 0, M1 = null, O = null;
        for(; k < a1.length;){
            let K = a1[k];
            if (K === `
`) C += c1 + g1, R.push({
                width: l1 - m1,
                chars: G
            }), M1 = null, O = null, l1 = 0, G = [];
            else {
                let N = n.map[K];
                if (N) {
                    let I = N.w * f.x;
                    e.width && l1 + I > e.width && (C += c1 + g1, M1 != null && (k -= G.length - M1, K = a1[k], N = n.map[K], I = N.w * f.x, G = G.slice(0, M1 - 1), l1 = O), M1 = null, O = null, R.push({
                        width: l1 - m1,
                        chars: G
                    }), l1 = 0, G = []), G.push({
                        tex: n.tex,
                        width: N.w,
                        height: N.h,
                        quad: new $adc7cb3c45508c7c$var$ie(N.x / n.tex.width, N.y / n.tex.height, N.w / n.tex.width, N.h / n.tex.height),
                        ch: K,
                        pos: new $adc7cb3c45508c7c$var$y(l1, C),
                        opacity: e.opacity ?? 1,
                        color: e.color ?? $adc7cb3c45508c7c$var$q.WHITE,
                        scale: $adc7cb3c45508c7c$var$T(f),
                        angle: 0
                    }), K === " " && (M1 = G.length, O = l1), l1 += I, p = Math.max(p, l1), l1 += m1;
                }
            }
            k++;
        }
        R.push({
            width: l1 - m1,
            chars: G
        }), C += c1, e.width && (p = e.width);
        let ne = [];
        for (let K of R){
            let N = (p - K.width) * $adc7cb3c45508c7c$var$Ri(e.align ?? "left");
            for (let I of K.chars){
                let he = n.map[I.ch], b = ne.length;
                if (I.pos = I.pos.add(N, 0).add(he.w * f.x * .5, he.h * f.y * .5), e.transform) {
                    let P = typeof e.transform == "function" ? e.transform(b, I.ch) : e.transform;
                    P && zn(I, P);
                }
                if (s[b]) {
                    let P = s[b];
                    for (let D of P){
                        let F = e.styles[D], _ = typeof F == "function" ? F(b, I.ch) : F;
                        _ && zn(I, _);
                    }
                }
                ne.push(I);
            }
        }
        return {
            width: p,
            height: C,
            chars: ne,
            opt: e
        };
    }
    $adc7cb3c45508c7c$var$o(je, "formatText");
    function Yn(e) {
        Ne(je(e));
    }
    $adc7cb3c45508c7c$var$o(Yn, "drawText");
    function Ne(e) {
        E(), Q(e.opt.pos), x(e.opt.angle), Q($adc7cb3c45508c7c$var$nt(e.opt.anchor ?? "topleft").add(1, 1).scale(e.width, e.height).scale(-0.5)), e.chars.forEach((n)=>{
            me({
                tex: n.tex,
                width: n.width,
                height: n.height,
                pos: n.pos,
                scale: n.scale,
                angle: n.angle,
                color: n.color,
                opacity: n.opacity,
                quad: n.quad,
                anchor: "center",
                uniform: e.opt.uniform,
                shader: e.opt.shader,
                fixed: e.opt.fixed
            });
        }), L();
    }
    $adc7cb3c45508c7c$var$o(Ne, "drawFormattedText");
    function pe() {
        return v.width;
    }
    $adc7cb3c45508c7c$var$o(pe, "width");
    function we() {
        return v.height;
    }
    $adc7cb3c45508c7c$var$o(we, "height");
    let We = {};
    function Jr(e) {
        return new $adc7cb3c45508c7c$var$y((e.x - v.viewport.x) * pe() / v.viewport.width, (e.y - v.viewport.y) * we() / v.viewport.height);
    }
    $adc7cb3c45508c7c$var$o(Jr, "windowToContent");
    function Qr(e) {
        return new $adc7cb3c45508c7c$var$y(e.x * v.viewport.width / v.width, e.y * v.viewport.height / v.height);
    }
    $adc7cb3c45508c7c$var$o(Qr, "contentToView");
    function Dt() {
        return Jr(U.mousePos());
    }
    $adc7cb3c45508c7c$var$o(Dt, "mousePos"), We.error = (e)=>{
        if (e.error) xn(e.error);
        else {
            if (e.message === "Script error.") return;
            xn(new Error(e.message));
        }
    }, We.unhandledrejection = (e)=>xn(e.reason);
    for(let e in We)window.addEventListener(e, We[e]);
    let te = {
        inspect: !1,
        timeScale: 1,
        showLog: !0,
        fps: ()=>U.fps(),
        numFrames: ()=>U.numFrames(),
        stepFrame: or,
        drawCalls: ()=>v.drawCalls,
        clearLog: ()=>A.logs = [],
        log: (e)=>{
            let n = r.logMax ?? $adc7cb3c45508c7c$var$Ci;
            A.logs.unshift({
                msg: e,
                time: U.time()
            }), A.logs.length > n && (A.logs = A.logs.slice(0, n));
        },
        error: (e)=>te.log(new Error(e.toString ? e.toString() : e)),
        curRecording: null,
        paused: !1,
        numObjects: ()=>bn("*", {
                recursive: !0
            }).length
    };
    function Ue() {
        return U.dt() * te.timeScale;
    }
    $adc7cb3c45508c7c$var$o(Ue, "dt");
    function Zr(...e) {
        return e.length > 0 && (A.cam.pos = $adc7cb3c45508c7c$var$T(...e)), A.cam.pos ? A.cam.pos.clone() : Vt();
    }
    $adc7cb3c45508c7c$var$o(Zr, "camPos");
    function es(...e) {
        return e.length > 0 && (A.cam.scale = $adc7cb3c45508c7c$var$T(...e)), A.cam.scale.clone();
    }
    $adc7cb3c45508c7c$var$o(es, "camScale");
    function ts(e) {
        return e !== void 0 && (A.cam.angle = e), A.cam.angle;
    }
    $adc7cb3c45508c7c$var$o(ts, "camRot");
    function ns(e = 12) {
        A.cam.shake += e;
    }
    $adc7cb3c45508c7c$var$o(ns, "shake");
    function Xn(e) {
        return A.cam.transform.multVec2(e);
    }
    $adc7cb3c45508c7c$var$o(Xn, "toScreen");
    function Wn(e) {
        return A.cam.transform.invert().multVec2(e);
    }
    $adc7cb3c45508c7c$var$o(Wn, "toWorld");
    function Gt(e) {
        let n = new $adc7cb3c45508c7c$var$be;
        return e.pos && n.translate(e.pos), e.scale && n.scale(e.scale), e.angle && n.rotate(e.angle), e.parent ? n.mult(e.parent.transform) : n;
    }
    $adc7cb3c45508c7c$var$o(Gt, "calcTransform");
    function fn(e = []) {
        let n = new Map, s = {}, i1 = new $adc7cb3c45508c7c$var$Re, a1 = [], c1 = null, f = !1, g1 = {
            id: $adc7cb3c45508c7c$var$Cr(),
            hidden: !1,
            transform: new $adc7cb3c45508c7c$var$be,
            children: [],
            parent: null,
            set paused (l){
                if (l !== f) {
                    f = l;
                    for (let p of a1)p.paused = l;
                }
            },
            get paused () {
                return f;
            },
            add (l1 = []) {
                let p = Array.isArray(l1) ? fn(l1) : l1;
                if (p.parent) throw new Error("Cannot add a game obj that already has a parent.");
                return p.parent = this, p.transform = Gt(p), this.children.push(p), p.trigger("add", p), A.events.trigger("add", p), p;
            },
            readd (l1) {
                let p = this.children.indexOf(l1);
                return p !== -1 && (this.children.splice(p, 1), this.children.push(l1)), l1;
            },
            remove (l1) {
                let p = this.children.indexOf(l1);
                if (p !== -1) {
                    l1.parent = null, this.children.splice(p, 1);
                    let C = $adc7cb3c45508c7c$var$o((R)=>{
                        R.trigger("destroy"), A.events.trigger("destroy", R), R.children.forEach((G)=>C(G));
                    }, "trigger");
                    C(l1);
                }
            },
            removeAll (l1) {
                if (l1) this.get(l1).forEach((p)=>this.remove(p));
                else for (let p of [
                    ...this.children
                ])this.remove(p);
            },
            update () {
                this.paused || (this.children.sort((l1, p)=>(l1.z ?? 0) - (p.z ?? 0)).forEach((l1)=>l1.update()), this.trigger("update"));
            },
            draw () {
                if (this.hidden) return;
                let l1 = v.fixed;
                this.fixed && (v.fixed = !0), E(), Q(this.pos), h(this.scale), x(this.angle), this.trigger("draw"), this.children.sort((p, C)=>(p.z ?? 0) - (C.z ?? 0)).forEach((p)=>p.draw()), L(), v.fixed = l1;
            },
            drawInspect () {
                this.hidden || (E(), Q(this.pos), h(this.scale), x(this.angle), this.children.sort((l1, p)=>(l1.z ?? 0) - (p.z ?? 0)).forEach((l1)=>l1.drawInspect()), this.trigger("drawInspect"), L());
            },
            use (l1) {
                if (!l1) return;
                if (typeof l1 == "string") return this.use({
                    id: l1
                });
                let p = [];
                l1.id && (this.unuse(l1.id), s[l1.id] = [], p = s[l1.id], n.set(l1.id, l1));
                for(let R in l1){
                    if ($adc7cb3c45508c7c$var$Pi.has(R)) continue;
                    let G = Object.getOwnPropertyDescriptor(l1, R);
                    if (typeof G.value == "function" && (l1[R] = l1[R].bind(this)), G.set && Object.defineProperty(l1, R, {
                        set: G.set.bind(this)
                    }), G.get && Object.defineProperty(l1, R, {
                        get: G.get.bind(this)
                    }), $adc7cb3c45508c7c$var$Mi.has(R)) {
                        let k = R === "add" ? ()=>{
                            c1 = $adc7cb3c45508c7c$var$o((M1)=>p.push(M1), "onCurCompCleanup"), l1[R](), c1 = null;
                        } : l1[R];
                        p.push(this.on(R, k).cancel);
                    } else if (this[R] === void 0) Object.defineProperty(this, R, {
                        get: ()=>l1[R],
                        set: (k)=>l1[R] = k,
                        configurable: !0,
                        enumerable: !0
                    }), p.push(()=>delete this[R]);
                    else throw new Error(`Duplicate component property: "${R}"`);
                }
                let C = $adc7cb3c45508c7c$var$o(()=>{
                    if (l1.require) {
                        for (let R of l1.require)if (!this.c(R)) throw new Error(`Component "${l1.id}" requires component "${R}"`);
                    }
                }, "checkDeps");
                l1.destroy && p.push(l1.destroy.bind(this)), this.exists() ? (C(), l1.add && (c1 = $adc7cb3c45508c7c$var$o((R)=>p.push(R), "onCurCompCleanup"), l1.add.call(this), c1 = null)) : l1.require && p.push(this.on("add", C).cancel);
            },
            unuse (l1) {
                s[l1] && (s[l1].forEach((p)=>p()), delete s[l1]), n.has(l1) && n.delete(l1);
            },
            c (l1) {
                return n.get(l1);
            },
            get (l1, p = {}) {
                let C = p.recursive ? this.children.flatMap($adc7cb3c45508c7c$var$o(function R(G) {
                    return [
                        G,
                        ...G.children.flatMap(R)
                    ];
                }, "recurse")) : this.children;
                if (C = C.filter((R)=>l1 ? R.is(l1) : !0), p.liveUpdate) {
                    let R = $adc7cb3c45508c7c$var$o((G)=>p.recursive ? this.isAncestorOf(G) : G.parent === this, "isChild");
                    pn((G)=>{
                        R(G) && G.is(l1) && C.push(G);
                    }), Jn((G)=>{
                        if (R(G) && G.is(l1)) {
                            let k = C.findIndex((M1)=>M1.id === G.id);
                            k !== -1 && C.splice(k, 1);
                        }
                    });
                }
                return C;
            },
            isAncestorOf (l1) {
                return l1.parent ? l1.parent === this || this.isAncestorOf(l1.parent) : !1;
            },
            exists () {
                return A.root.isAncestorOf(this);
            },
            is (l1) {
                if (l1 === "*") return !0;
                if (Array.isArray(l1)) {
                    for (let p of l1)if (!this.c(p)) return !1;
                    return !0;
                } else return this.c(l1) != null;
            },
            on (l1, p) {
                let C = i1.on(l1, p.bind(this));
                return c1 && c1(()=>C.cancel()), C;
            },
            trigger (l1, ...p) {
                i1.trigger(l1, ...p), A.objEvents.trigger(l1, this, ...p);
            },
            destroy () {
                this.parent && this.parent.remove(this);
            },
            inspect () {
                let l1 = {};
                for (let [p, C] of n)l1[p] = C.inspect ? C.inspect() : null;
                return l1;
            },
            onAdd (l1) {
                return this.on("add", l1);
            },
            onUpdate (l1) {
                return this.on("update", l1);
            },
            onDraw (l1) {
                return this.on("draw", l1);
            },
            onDestroy (l1) {
                return this.on("destroy", l1);
            },
            clearEvents () {
                i1.clear();
            }
        }, m1 = [
            "onKeyPress",
            "onKeyPressRepeat",
            "onKeyDown",
            "onKeyRelease",
            "onMousePress",
            "onMouseDown",
            "onMouseRelease",
            "onMouseMove",
            "onCharInput",
            "onMouseMove",
            "onTouchStart",
            "onTouchMove",
            "onTouchEnd",
            "onScroll",
            "onGamepadButtonPress",
            "onGamepadButtonDown",
            "onGamepadButtonRelease",
            "onGamepadStick"
        ];
        for (let l1 of m1)g1[l1] = (...p)=>{
            let C = U[l1](...p);
            return a1.push(C), g1.onDestroy(()=>C.cancel()), C;
        };
        for (let l1 of e)g1.use(l1);
        return g1;
    }
    $adc7cb3c45508c7c$var$o(fn, "make");
    function Le(e, n, s) {
        return A.objEvents[e] || (A.objEvents[e] = new $adc7cb3c45508c7c$var$wt), A.objEvents.on(e, (i1, ...a1)=>{
            i1.is(n) && s(i1, ...a1);
        });
    }
    $adc7cb3c45508c7c$var$o(Le, "on");
    let mn = $adc7cb3c45508c7c$var$o((e, n)=>{
        if (typeof e == "function" && n === void 0) {
            let s = ht([
                {
                    update: e
                }
            ]);
            return {
                get paused () {
                    return s.paused;
                },
                set paused (i){
                    s.paused = i;
                },
                cancel: ()=>s.destroy()
            };
        } else if (typeof e == "string") return Le("update", e, n);
    }, "onUpdate"), rs = $adc7cb3c45508c7c$var$o((e, n)=>{
        if (typeof e == "function" && n === void 0) {
            let s = ht([
                {
                    draw: e
                }
            ]);
            return {
                get paused () {
                    return s.hidden;
                },
                set paused (i){
                    s.hidden = i;
                },
                cancel: ()=>s.destroy()
            };
        } else if (typeof e == "string") return Le("draw", e, n);
    }, "onDraw");
    function pn(e, n) {
        if (typeof e == "function" && n === void 0) return A.events.on("add", e);
        if (typeof e == "string") return Le("add", e, n);
    }
    $adc7cb3c45508c7c$var$o(pn, "onAdd");
    function Jn(e, n) {
        if (typeof e == "function" && n === void 0) return A.events.on("destroy", e);
        if (typeof e == "string") return Le("destroy", e, n);
    }
    $adc7cb3c45508c7c$var$o(Jn, "onDestroy");
    function ss(e, n, s) {
        return Le("collide", e, (i1, a1, c1)=>a1.is(n) && s(i1, a1, c1));
    }
    $adc7cb3c45508c7c$var$o(ss, "onCollide");
    function is(e, n, s) {
        return Le("collideUpdate", e, (i1, a1, c1)=>a1.is(n) && s(i1, a1, c1));
    }
    $adc7cb3c45508c7c$var$o(is, "onCollideUpdate");
    function os(e, n, s) {
        return Le("collideEnd", e, (i1, a1, c1)=>a1.is(n) && s(i1, a1, c1));
    }
    $adc7cb3c45508c7c$var$o(os, "onCollideEnd");
    function Ft(e, n) {
        bn(e, {
            recursive: !0
        }).forEach(n), pn(e, n);
    }
    $adc7cb3c45508c7c$var$o(Ft, "forAllCurrentAndFuture");
    function as(e, n) {
        if (typeof e == "function") return U.onMousePress(e);
        {
            let s = [];
            return Ft(e, (i1)=>{
                if (!i1.area) throw new Error("onClick() requires the object to have area() component");
                s.push(i1.onClick(()=>n(i1)));
            }), $adc7cb3c45508c7c$var$Me.join(s);
        }
    }
    $adc7cb3c45508c7c$var$o(as, "onClick");
    function us(e, n) {
        let s = [];
        return Ft(e, (i1)=>{
            if (!i1.area) throw new Error("onHover() requires the object to have area() component");
            s.push(i1.onHover(()=>n(i1)));
        }), $adc7cb3c45508c7c$var$Me.join(s);
    }
    $adc7cb3c45508c7c$var$o(us, "onHover");
    function cs(e, n) {
        let s = [];
        return Ft(e, (i1)=>{
            if (!i1.area) throw new Error("onHoverUpdate() requires the object to have area() component");
            s.push(i1.onHoverUpdate(()=>n(i1)));
        }), $adc7cb3c45508c7c$var$Me.join(s);
    }
    $adc7cb3c45508c7c$var$o(cs, "onHoverUpdate");
    function ls(e, n) {
        let s = [];
        return Ft(e, (i1)=>{
            if (!i1.area) throw new Error("onHoverEnd() requires the object to have area() component");
            s.push(i1.onHoverEnd(()=>n(i1)));
        }), $adc7cb3c45508c7c$var$Me.join(s);
    }
    $adc7cb3c45508c7c$var$o(ls, "onHoverEnd");
    function Bt(e, n) {
        let s = 0, i1 = [];
        n && i1.push(n);
        let a1 = mn(()=>{
            s += Ue(), s >= e && (a1.cancel(), i1.forEach((c1)=>c1()));
        });
        return {
            paused: a1.paused,
            cancel: a1.cancel,
            onEnd (c1) {
                i1.push(c1);
            },
            then (c1) {
                return this.onEnd(c1), this;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Bt, "wait");
    function hs(e, n) {
        let s = null, i1 = $adc7cb3c45508c7c$var$o(()=>{
            s = Bt(e, i1), n();
        }, "newAction");
        return s = Bt(0, i1), {
            get paused () {
                return s.paused;
            },
            set paused (a){
                s.paused = a;
            },
            cancel: ()=>s.cancel()
        };
    }
    $adc7cb3c45508c7c$var$o(hs, "loop");
    function Qn() {
        U.onKeyPress("f1", ()=>{
            te.inspect = !te.inspect;
        }), U.onKeyPress("f2", ()=>{
            te.clearLog();
        }), U.onKeyPress("f8", ()=>{
            te.paused = !te.paused;
        }), U.onKeyPress("f7", ()=>{
            te.timeScale = ct($adc7cb3c45508c7c$var$Pe(te.timeScale - .2, 0, 2), 1);
        }), U.onKeyPress("f9", ()=>{
            te.timeScale = ct($adc7cb3c45508c7c$var$Pe(te.timeScale + .2, 0, 2), 1);
        }), U.onKeyPress("f10", ()=>{
            te.stepFrame();
        });
    }
    $adc7cb3c45508c7c$var$o(Qn, "enterDebugMode");
    function Zn() {
        U.onKeyPress("b", ()=>Mt());
    }
    $adc7cb3c45508c7c$var$o(Zn, "enterBurpMode");
    function ds(e) {
        A.gravity = e;
    }
    $adc7cb3c45508c7c$var$o(ds, "setGravity");
    function fs() {
        return A.gravity;
    }
    $adc7cb3c45508c7c$var$o(fs, "getGravity");
    function ms(...e) {
        e.length === 1 || e.length === 2 ? (v.bgColor = $adc7cb3c45508c7c$var$J(e[0]), e[1] && (v.bgAlpha = e[1])) : (e.length === 3 || e.length === 4) && (v.bgColor = $adc7cb3c45508c7c$var$J(e[0], e[1], e[2]), e[3] && (v.bgAlpha = e[3])), d.clearColor(v.bgColor.r / 255, v.bgColor.g / 255, v.bgColor.b / 255, v.bgAlpha);
    }
    $adc7cb3c45508c7c$var$o(ms, "setBackground");
    function ps() {
        return v.bgColor.clone();
    }
    $adc7cb3c45508c7c$var$o(ps, "getBackground");
    function Lt(...e) {
        return {
            id: "pos",
            pos: $adc7cb3c45508c7c$var$T(...e),
            moveBy (...n) {
                this.pos = this.pos.add($adc7cb3c45508c7c$var$T(...n));
            },
            move (...n) {
                this.moveBy($adc7cb3c45508c7c$var$T(...n).scale(Ue()));
            },
            moveTo (...n) {
                if (typeof n[0] == "number" && typeof n[1] == "number") return this.moveTo($adc7cb3c45508c7c$var$T(n[0], n[1]), n[2]);
                let s = n[0], i1 = n[1];
                if (i1 === void 0) {
                    this.pos = $adc7cb3c45508c7c$var$T(s);
                    return;
                }
                let a1 = s.sub(this.pos);
                if (a1.len() <= i1 * Ue()) {
                    this.pos = $adc7cb3c45508c7c$var$T(s);
                    return;
                }
                this.move(a1.unit().scale(i1));
            },
            worldPos () {
                return this.parent ? this.parent.transform.multVec2(this.pos) : this.pos;
            },
            screenPos () {
                let n = this.worldPos();
                return lt(this) ? n : Xn(n);
            },
            inspect () {
                return `(${Math.round(this.pos.x)}, ${Math.round(this.pos.y)})`;
            },
            drawInspect () {
                Xe({
                    color: $adc7cb3c45508c7c$var$J(255, 0, 0),
                    radius: 4 / $n()
                });
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Lt, "pos");
    function It(...e) {
        return e.length === 0 ? It(1) : {
            id: "scale",
            scale: $adc7cb3c45508c7c$var$T(...e),
            scaleTo (...n) {
                this.scale = $adc7cb3c45508c7c$var$T(...n);
            },
            scaleBy (...n) {
                this.scale.scale($adc7cb3c45508c7c$var$T(...n));
            },
            inspect () {
                return `(${ct(this.scale.x, 2)}, ${ct(this.scale.y, 2)})`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(It, "scale");
    function gs(e) {
        return {
            id: "rotate",
            angle: e ?? 0,
            rotateBy (n) {
                this.angle += n;
            },
            rotateTo (n) {
                this.angle = n;
            },
            inspect () {
                return `${Math.round(this.angle)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(gs, "rotate");
    function ws(...e) {
        return {
            id: "color",
            color: $adc7cb3c45508c7c$var$J(...e),
            inspect () {
                return this.color.toString();
            }
        };
    }
    $adc7cb3c45508c7c$var$o(ws, "color");
    function ct(e, n) {
        return Number(e.toFixed(n));
    }
    $adc7cb3c45508c7c$var$o(ct, "toFixed");
    function vs(e) {
        return {
            id: "opacity",
            opacity: e ?? 1,
            inspect () {
                return `${ct(this.opacity, 1)}`;
            },
            fadeOut (n = 1, s = $adc7cb3c45508c7c$var$tt.linear) {
                return Un(this.opacity, 0, n, (i1)=>this.opacity = i1, s);
            }
        };
    }
    $adc7cb3c45508c7c$var$o(vs, "opacity");
    function gn(e) {
        if (!e) throw new Error("Please define an anchor");
        return {
            id: "anchor",
            anchor: e,
            inspect () {
                return typeof this.anchor == "string" ? this.anchor : this.anchor.toString();
            }
        };
    }
    $adc7cb3c45508c7c$var$o(gn, "anchor");
    function bs(e) {
        return {
            id: "z",
            z: e,
            inspect () {
                return `${this.z}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(bs, "z");
    function ys(e, n) {
        return {
            id: "follow",
            require: [
                "pos"
            ],
            follow: {
                obj: e,
                offset: n ?? $adc7cb3c45508c7c$var$T(0)
            },
            add () {
                e.exists() && (this.pos = this.follow.obj.pos.add(this.follow.offset));
            },
            update () {
                e.exists() && (this.pos = this.follow.obj.pos.add(this.follow.offset));
            }
        };
    }
    $adc7cb3c45508c7c$var$o(ys, "follow");
    function xs(e, n) {
        let s = typeof e == "number" ? $adc7cb3c45508c7c$var$y.fromAngle(e) : e.unit();
        return {
            id: "move",
            require: [
                "pos"
            ],
            update () {
                this.move(s.scale(n));
            }
        };
    }
    $adc7cb3c45508c7c$var$o(xs, "move");
    let Us = 200;
    function Es(e = {}) {
        let n = e.distance ?? Us, s = !1;
        return {
            id: "offscreen",
            require: [
                "pos"
            ],
            isOffScreen () {
                let i1 = this.screenPos(), a1 = new $adc7cb3c45508c7c$var$le($adc7cb3c45508c7c$var$T(0), pe(), we());
                return !$adc7cb3c45508c7c$var$mt(a1, i1) && a1.sdistToPoint(i1) > n * n;
            },
            onExitScreen (i1) {
                return this.on("exitView", i1);
            },
            onEnterScreen (i1) {
                return this.on("enterView", i1);
            },
            update () {
                this.isOffScreen() ? (s || (this.trigger("exitView"), s = !0), e.hide && (this.hidden = !0), e.pause && (this.paused = !0), e.destroy && this.destroy()) : (s && (this.trigger("enterView"), s = !1), e.hide && (this.hidden = !1), e.pause && (this.paused = !1));
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Es, "offscreen");
    function lt(e) {
        return e.fixed ? !0 : e.parent ? lt(e.parent) : !1;
    }
    $adc7cb3c45508c7c$var$o(lt, "isFixed");
    function Ss(e = {}) {
        let n = {}, s = new Set;
        return {
            id: "area",
            collisionIgnore: e.collisionIgnore ?? [],
            add () {
                this.area.cursor && this.onHover(()=>U.setCursor(this.area.cursor)), this.onCollideUpdate((i1, a1)=>{
                    n[i1.id] || this.trigger("collide", i1, a1), n[i1.id] = a1, s.add(i1.id);
                });
            },
            update () {
                for(let i1 in n)s.has(Number(i1)) || (this.trigger("collideEnd", n[i1].target), delete n[i1]);
                s.clear();
            },
            drawInspect () {
                let i1 = this.localArea();
                E(), h(this.area.scale), Q(this.area.offset);
                let a1 = {
                    outline: {
                        width: 4 / $n(),
                        color: $adc7cb3c45508c7c$var$J(0, 0, 255)
                    },
                    anchor: this.anchor,
                    fill: !1,
                    fixed: lt(this)
                };
                i1 instanceof $adc7cb3c45508c7c$var$le ? xe({
                    ...a1,
                    pos: i1.pos,
                    width: i1.width,
                    height: i1.height
                }) : i1 instanceof $adc7cb3c45508c7c$var$He ? Ve({
                    ...a1,
                    pts: i1.pts
                }) : i1 instanceof $adc7cb3c45508c7c$var$pt && Xe({
                    ...a1,
                    pos: i1.center,
                    radius: i1.radius
                }), L();
            },
            area: {
                shape: e.shape ?? null,
                scale: e.scale ? $adc7cb3c45508c7c$var$T(e.scale) : $adc7cb3c45508c7c$var$T(1),
                offset: e.offset ?? $adc7cb3c45508c7c$var$T(0),
                cursor: e.cursor ?? null
            },
            isClicked () {
                return U.isMousePressed() && this.isHovering();
            },
            isHovering () {
                let i1 = lt(this) ? Dt() : Wn(Dt());
                return this.hasPoint(i1);
            },
            checkCollision (i1) {
                return n[i1.id] ?? null;
            },
            getCollisions () {
                return Object.values(n);
            },
            isColliding (i1) {
                return !!n[i1.id];
            },
            isOverlapping (i1) {
                let a1 = n[i1.id];
                return a1 && a1.hasOverlap();
            },
            onClick (i1) {
                let a1 = U.onMousePress("left", ()=>{
                    this.isHovering() && i1();
                });
                return this.onDestroy(()=>a1.cancel()), a1;
            },
            onHover (i1) {
                let a1 = !1;
                return this.onUpdate(()=>{
                    a1 ? a1 = this.isHovering() : this.isHovering() && (a1 = !0, i1());
                });
            },
            onHoverUpdate (i1) {
                return this.onUpdate(()=>{
                    this.isHovering() && i1();
                });
            },
            onHoverEnd (i1) {
                let a1 = !1;
                return this.onUpdate(()=>{
                    a1 ? this.isHovering() || (a1 = !1, i1()) : a1 = this.isHovering();
                });
            },
            onCollide (i1, a1) {
                if (typeof i1 == "function" && a1 === void 0) return this.on("collide", i1);
                if (typeof i1 == "string") return this.onCollide((c1, f)=>{
                    c1.is(i1) && a1(c1, f);
                });
            },
            onCollideUpdate (i1, a1) {
                if (typeof i1 == "function" && a1 === void 0) return this.on("collideUpdate", i1);
                if (typeof i1 == "string") return this.on("collideUpdate", (c1, f)=>c1.is(i1) && a1(c1, f));
            },
            onCollideEnd (i1, a1) {
                if (typeof i1 == "function" && a1 === void 0) return this.on("collideEnd", i1);
                if (typeof i1 == "string") return this.on("collideEnd", (c1)=>c1.is(i1) && a1(c1));
            },
            hasPoint (i1) {
                return $adc7cb3c45508c7c$var$Rn(this.worldArea(), i1);
            },
            resolveCollision (i1) {
                let a1 = this.checkCollision(i1);
                a1 && !a1.resolved && (this.pos = this.pos.add(a1.displacement), a1.resolved = !0);
            },
            localArea () {
                return this.area.shape ? this.area.shape : this.renderArea();
            },
            worldArea () {
                let i1 = this.localArea();
                if (!(i1 instanceof $adc7cb3c45508c7c$var$He || i1 instanceof $adc7cb3c45508c7c$var$le)) throw new Error("Only support polygon and rect shapes for now");
                let a1 = this.transform.clone().scale($adc7cb3c45508c7c$var$T(this.area.scale ?? 1)).translate(this.area.offset);
                if (i1 instanceof $adc7cb3c45508c7c$var$le) {
                    let c1 = $adc7cb3c45508c7c$var$nt(this.anchor || $adc7cb3c45508c7c$var$$t).add(1, 1).scale(-0.5).scale(i1.width, i1.height);
                    a1.translate(c1);
                }
                return i1.transform(a1);
            },
            screenArea () {
                let i1 = this.worldArea();
                return lt(this) ? i1 : i1.transform(A.cam.transform);
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ss, "area");
    function Je(e) {
        return {
            color: e.color,
            opacity: e.opacity,
            anchor: e.anchor,
            outline: e.outline,
            shader: e.shader,
            uniform: e.uniform
        };
    }
    $adc7cb3c45508c7c$var$o(Je, "getRenderProps");
    function wn(e, n = {}) {
        let s = null, i1 = null, a1 = null, c1 = new $adc7cb3c45508c7c$var$ve;
        if (!e) throw new Error("Please pass the resource name or data to sprite()");
        let f = $adc7cb3c45508c7c$var$o((g1, m1, l1, p)=>{
            let C = $adc7cb3c45508c7c$var$T(1, 1);
            return l1 && p ? (C.x = l1 / (g1.width * m1.w), C.y = p / (g1.height * m1.h)) : l1 ? (C.x = l1 / (g1.width * m1.w), C.y = C.x) : p && (C.y = p / (g1.height * m1.h), C.x = C.y), C;
        }, "calcTexScale");
        return {
            id: "sprite",
            width: 0,
            height: 0,
            frame: n.frame || 0,
            quad: n.quad || new $adc7cb3c45508c7c$var$ie(0, 0, 1, 1),
            animSpeed: n.animSpeed ?? 1,
            flipX: n.flipX ?? !1,
            flipY: n.flipY ?? !1,
            draw () {
                if (!s) return;
                let g1 = s.frames[this.frame ?? 0];
                if (!g1) throw new Error(`Frame not found: ${this.frame ?? 0}`);
                if (s.slice9) {
                    let { left: m1, right: l1, top: p, bottom: C } = s.slice9, R = s.tex.width * g1.w, G = s.tex.height * g1.h, k = this.width - m1 - l1, M1 = this.height - p - C, O = m1 / R, ne = l1 / R, K = 1 - O - ne, N = p / G, I = C / G, he = 1 - N - I, b = [
                        $adc7cb3c45508c7c$var$oe(0, 0, O, N),
                        $adc7cb3c45508c7c$var$oe(O, 0, K, N),
                        $adc7cb3c45508c7c$var$oe(O + K, 0, ne, N),
                        $adc7cb3c45508c7c$var$oe(0, N, O, he),
                        $adc7cb3c45508c7c$var$oe(O, N, K, he),
                        $adc7cb3c45508c7c$var$oe(O + K, N, ne, he),
                        $adc7cb3c45508c7c$var$oe(0, N + he, O, I),
                        $adc7cb3c45508c7c$var$oe(O, N + he, K, I),
                        $adc7cb3c45508c7c$var$oe(O + K, N + he, ne, I),
                        $adc7cb3c45508c7c$var$oe(0, 0, m1, p),
                        $adc7cb3c45508c7c$var$oe(m1, 0, k, p),
                        $adc7cb3c45508c7c$var$oe(m1 + k, 0, l1, p),
                        $adc7cb3c45508c7c$var$oe(0, p, m1, M1),
                        $adc7cb3c45508c7c$var$oe(m1, p, k, M1),
                        $adc7cb3c45508c7c$var$oe(m1 + k, p, l1, M1),
                        $adc7cb3c45508c7c$var$oe(0, p + M1, m1, C),
                        $adc7cb3c45508c7c$var$oe(m1, p + M1, k, C),
                        $adc7cb3c45508c7c$var$oe(m1 + k, p + M1, l1, C)
                    ];
                    for(let P = 0; P < 9; P++){
                        let D = b[P], F = b[P + 9];
                        Z(Object.assign(Je(this), {
                            pos: F.pos(),
                            tex: s.tex,
                            quad: g1.scale(D),
                            flipX: this.flipX,
                            flipY: this.flipY,
                            tiled: n.tiled,
                            width: F.w,
                            height: F.h
                        }));
                    }
                } else Z(Object.assign(Je(this), {
                    tex: s.tex,
                    quad: g1.scale(this.quad ?? new $adc7cb3c45508c7c$var$ie(0, 0, 1, 1)),
                    flipX: this.flipX,
                    flipY: this.flipY,
                    tiled: n.tiled,
                    width: this.width,
                    height: this.height
                }));
            },
            add () {
                let g1 = $adc7cb3c45508c7c$var$o((l1)=>{
                    let p = l1.frames[0].clone();
                    n.quad && (p = p.scale(n.quad));
                    let C = f(l1.tex, p, n.width, n.height);
                    this.width = l1.tex.width * p.w * C.x, this.height = l1.tex.height * p.h * C.y, n.anim && this.play(n.anim), s = l1, c1.trigger(s);
                }, "setSpriteData"), m1 = it(e);
                m1 ? m1.onLoad(g1) : vn(()=>g1(it(e).data));
            },
            update () {
                if (!i1) return;
                let g1 = s.anims[i1.name];
                if (typeof g1 == "number") {
                    this.frame = g1;
                    return;
                }
                if (g1.speed === 0) throw new Error("Sprite anim speed cannot be 0");
                i1.timer += Ue() * this.animSpeed, i1.timer >= 1 / i1.speed && (i1.timer = 0, this.frame += a1, (this.frame < Math.min(g1.from, g1.to) || this.frame > Math.max(g1.from, g1.to)) && (i1.loop ? i1.pingpong ? (this.frame -= a1, a1 *= -1, this.frame += a1) : this.frame = g1.from : (this.frame = g1.to, i1.onEnd(), this.stop())));
            },
            play (g1, m1 = {}) {
                if (!s) {
                    c1.add(()=>this.play(g1, m1));
                    return;
                }
                let l1 = s.anims[g1];
                if (l1 === void 0) throw new Error(`Anim not found: ${g1}`);
                i1 && this.stop(), i1 = typeof l1 == "number" ? {
                    name: g1,
                    timer: 0,
                    loop: !1,
                    pingpong: !1,
                    speed: 0,
                    onEnd: ()=>{}
                } : {
                    name: g1,
                    timer: 0,
                    loop: m1.loop ?? l1.loop ?? !1,
                    pingpong: m1.pingpong ?? l1.pingpong ?? !1,
                    speed: m1.speed ?? l1.speed ?? 10,
                    onEnd: m1.onEnd ?? (()=>{})
                }, a1 = typeof l1 == "number" ? null : l1.from < l1.to ? 1 : -1, this.frame = typeof l1 == "number" ? l1 : l1.from, this.trigger("animStart", g1);
            },
            stop () {
                if (!i1) return;
                let g1 = i1.name;
                i1 = null, this.trigger("animEnd", g1);
            },
            numFrames () {
                return s?.frames.length ?? 0;
            },
            curAnim () {
                return i1?.name;
            },
            onAnimEnd (g1) {
                return this.on("animEnd", g1);
            },
            onAnimStart (g1) {
                return this.on("animStart", g1);
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$le($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            },
            inspect () {
                if (typeof e == "string") return `"${e}"`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(wn, "sprite");
    function Cs(e, n = {}) {
        function s(i1) {
            let a1 = je(Object.assign(Je(i1), {
                text: i1.text + "",
                size: i1.textSize,
                font: i1.font,
                width: n.width && i1.width,
                align: i1.align,
                letterSpacing: i1.letterSpacing,
                lineSpacing: i1.lineSpacing,
                transform: i1.textTransform,
                styles: i1.textStyles
            }));
            return n.width || (i1.width = a1.width / (i1.scale?.x || 1)), i1.height = a1.height / (i1.scale?.y || 1), a1;
        }
        return $adc7cb3c45508c7c$var$o(s, "update"), {
            id: "text",
            text: e,
            textSize: n.size ?? $adc7cb3c45508c7c$var$Ei,
            font: n.font,
            width: n.width,
            height: 0,
            align: n.align,
            lineSpacing: n.lineSpacing,
            letterSpacing: n.letterSpacing,
            textTransform: n.transform,
            textStyles: n.styles,
            add () {
                vn(()=>s(this));
            },
            draw () {
                Ne(s(this));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$le($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Cs, "text");
    function Ts(e, n, s = {}) {
        return {
            id: "rect",
            width: e,
            height: n,
            radius: s.radius || 0,
            draw () {
                xe(Object.assign(Je(this), {
                    width: this.width,
                    height: this.height,
                    radius: this.radius
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$le($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            },
            inspect () {
                return `${Math.ceil(this.width)}, ${Math.ceil(this.height)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ts, "rect");
    function As(e, n) {
        return {
            id: "rect",
            width: e,
            height: n,
            draw () {
                me(Object.assign(Je(this), {
                    width: this.width,
                    height: this.height
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$le($adc7cb3c45508c7c$var$T(0), this.width, this.height);
            },
            inspect () {
                return `${Math.ceil(this.width)}, ${Math.ceil(this.height)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(As, "uvquad");
    function Os(e) {
        return {
            id: "circle",
            radius: e,
            draw () {
                Xe(Object.assign(Je(this), {
                    radius: this.radius
                }));
            },
            renderArea () {
                return new $adc7cb3c45508c7c$var$le(new $adc7cb3c45508c7c$var$y(this.anchor ? 0 : -this.radius), this.radius * 2, this.radius * 2);
            },
            inspect () {
                return `${Math.ceil(this.radius)}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Os, "circle");
    function Ps(e = 1, n = $adc7cb3c45508c7c$var$J(0, 0, 0)) {
        return {
            id: "outline",
            outline: {
                width: e,
                color: n
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ps, "outline");
    function er() {
        return {
            id: "timer",
            wait (e, n) {
                let s = [];
                n && s.push(n);
                let i1 = 0, a1 = this.onUpdate(()=>{
                    i1 += Ue(), i1 >= e && (s.forEach((c1)=>c1()), a1.cancel());
                });
                return {
                    get paused () {
                        return a1.paused;
                    },
                    set paused (c){
                        a1.paused = c;
                    },
                    cancel: a1.cancel,
                    onEnd (c1) {
                        s.push(c1);
                    },
                    then (c1) {
                        return this.onEnd(c1), this;
                    }
                };
            },
            loop (e, n) {
                let s = null, i1 = $adc7cb3c45508c7c$var$o(()=>{
                    s = this.wait(e, i1), n();
                }, "newAction");
                return s = this.wait(0, i1), {
                    get paused () {
                        return s.paused;
                    },
                    set paused (a){
                        s.paused = a;
                    },
                    cancel: ()=>s.cancel()
                };
            },
            tween (e, n, s, i1, a1 = $adc7cb3c45508c7c$var$tt.linear) {
                let c1 = 0, f = [], g1 = this.onUpdate(()=>{
                    c1 += Ue();
                    let m1 = Math.min(c1 / s, 1);
                    i1($adc7cb3c45508c7c$var$Se(e, n, a1(m1))), m1 === 1 && (g1.cancel(), i1(n), f.forEach((l1)=>l1()));
                });
                return {
                    get paused () {
                        return g1.paused;
                    },
                    set paused (m){
                        g1.paused = m;
                    },
                    onEnd (m1) {
                        f.push(m1);
                    },
                    then (m1) {
                        return this.onEnd(m1), this;
                    },
                    cancel () {
                        g1.cancel();
                    },
                    finish () {
                        g1.cancel(), i1(n), f.forEach((m1)=>m1());
                    }
                };
            }
        };
    }
    $adc7cb3c45508c7c$var$o(er, "timer");
    let Ms = 640, Rs = 65536;
    function Ds(e = {}) {
        let n = $adc7cb3c45508c7c$var$T(0), s = null, i1 = null, a1 = !1;
        return {
            id: "body",
            require: [
                "pos",
                "area"
            ],
            jumpForce: e.jumpForce ?? Ms,
            gravityScale: e.gravityScale ?? 1,
            isStatic: e.isStatic ?? !1,
            mass: e.mass ?? 1,
            add () {
                if (this.mass === 0) throw new Error("Can't set body mass to 0");
                this.onCollideUpdate((c1, f)=>{
                    if (c1.is("body") && !f.resolved && (this.trigger("beforePhysicsResolve", f), c1.trigger("beforePhysicsResolve", f.reverse()), !f.resolved && !(this.isStatic && c1.isStatic))) {
                        if (!this.isStatic && !c1.isStatic) {
                            let g1 = this.mass + c1.mass;
                            this.pos = this.pos.add(f.displacement.scale(c1.mass / g1)), c1.pos = c1.pos.add(f.displacement.scale(-this.mass / g1)), this.transform = Gt(this), c1.transform = Gt(c1);
                        } else {
                            let g1 = !this.isStatic && c1.isStatic ? f : f.reverse();
                            g1.source.pos = g1.source.pos.add(g1.displacement), g1.source.transform = Gt(g1.source);
                        }
                        f.resolved = !0, this.trigger("physicsResolve", f), c1.trigger("physicsResolve", f.reverse());
                    }
                }), this.onPhysicsResolve((c1)=>{
                    A.gravity && (c1.isBottom() && this.isFalling() ? (n.y = 0, s = c1.target, i1 = c1.target.pos, a1 ? a1 = !1 : this.trigger("ground", s)) : c1.isTop() && this.isJumping() && (n.y = 0, this.trigger("headbutt", c1.target)));
                });
            },
            update () {
                if (!A.gravity || this.isStatic) return;
                if (a1 && (s = null, i1 = null, this.trigger("fallOff"), a1 = !1), s) {
                    if (!this.isOverlapping(s) || !s.exists() || !s.is("body")) a1 = !0;
                    else {
                        !s.pos.eq(i1) && e.stickToPlatform !== !1 && this.moveBy(s.pos.sub(i1)), i1 = s.pos;
                        return;
                    }
                }
                let c1 = n.y;
                n.y += A.gravity * this.gravityScale * Ue(), n.y = Math.min(n.y, e.maxVelocity ?? Rs), c1 < 0 && n.y >= 0 && this.trigger("fall"), this.move(n);
            },
            onPhysicsResolve (c1) {
                return this.on("physicsResolve", c1);
            },
            onBeforePhysicsResolve (c1) {
                return this.on("beforePhysicsResolve", c1);
            },
            curPlatform () {
                return s;
            },
            isGrounded () {
                return s !== null;
            },
            isFalling () {
                return n.y > 0;
            },
            isJumping () {
                return n.y < 0;
            },
            jump (c1) {
                s = null, i1 = null, n.y = -c1 || -this.jumpForce;
            },
            onGround (c1) {
                return this.on("ground", c1);
            },
            onFall (c1) {
                return this.on("fall", c1);
            },
            onFallOff (c1) {
                return this.on("fallOff", c1);
            },
            onHeadbutt (c1) {
                return this.on("headbutt", c1);
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ds, "body");
    function Gs(e = 2) {
        let n = e;
        return {
            id: "doubleJump",
            require: [
                "body"
            ],
            numJumps: e,
            add () {
                this.onGround(()=>{
                    n = this.numJumps;
                });
            },
            doubleJump (s) {
                n <= 0 || (n < this.numJumps && this.trigger("doubleJump"), n--, this.jump(s));
            },
            onDoubleJump (s) {
                return this.on("doubleJump", s);
            },
            inspect () {
                return `${n}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Gs, "doubleJump");
    function Fs(e, n) {
        return {
            id: "shader",
            shader: e,
            ...typeof n == "function" ? {
                uniform: n(),
                update () {
                    this.uniform = n();
                }
            } : {
                uniform: n
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Fs, "shader");
    function Bs() {
        return {
            id: "fixed",
            fixed: !0
        };
    }
    $adc7cb3c45508c7c$var$o(Bs, "fixed");
    function tr(e) {
        return {
            id: "stay",
            stay: !0,
            scenesToStay: e
        };
    }
    $adc7cb3c45508c7c$var$o(tr, "stay");
    function Ls(e) {
        if (e == null) throw new Error("health() requires the initial amount of hp");
        let n = e;
        return {
            id: "health",
            hurt (s = 1) {
                this.setHP(e - s), this.trigger("hurt", s);
            },
            heal (s = 1) {
                this.setHP(e + s), this.trigger("heal", s);
            },
            hp () {
                return e;
            },
            maxHP () {
                return n;
            },
            setHP (s) {
                e = s, e <= 0 && this.trigger("death");
            },
            onHurt (s) {
                return this.on("hurt", s);
            },
            onHeal (s) {
                return this.on("heal", s);
            },
            onDeath (s) {
                return this.on("death", s);
            },
            inspect () {
                return `${e}`;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ls, "health");
    function Is(e, n = {}) {
        if (e == null) throw new Error("lifespan() requires time");
        let s = n.fade ?? 0;
        return {
            id: "lifespan",
            async add () {
                await Bt(e), s > 0 && this.opacity && await Un(this.opacity, 0, s, (i1)=>this.opacity = i1, $adc7cb3c45508c7c$var$tt.linear), this.destroy();
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Is, "lifespan");
    function Vs(e, n, s) {
        if (!e) throw new Error("state() requires an initial state");
        let i1 = {};
        function a1(m1) {
            i1[m1] || (i1[m1] = {
                enter: new $adc7cb3c45508c7c$var$ve,
                end: new $adc7cb3c45508c7c$var$ve,
                update: new $adc7cb3c45508c7c$var$ve,
                draw: new $adc7cb3c45508c7c$var$ve
            });
        }
        $adc7cb3c45508c7c$var$o(a1, "initStateEvents");
        function c1(m1, l1, p) {
            return a1(l1), i1[l1][m1].add(p);
        }
        $adc7cb3c45508c7c$var$o(c1, "on");
        function f(m1, l1, ...p) {
            a1(l1), i1[l1][m1].trigger(...p);
        }
        $adc7cb3c45508c7c$var$o(f, "trigger");
        let g1 = !1;
        return {
            id: "state",
            state: e,
            enterState (m1, ...l1) {
                if (g1 = !0, n && !n.includes(m1)) throw new Error(`State not found: ${m1}`);
                let p = this.state;
                if (s) {
                    if (!s?.[p]) return;
                    let C = typeof s[p] == "string" ? [
                        s[p]
                    ] : s[p];
                    if (!C.includes(m1)) throw new Error(`Cannot transition state from "${p}" to "${m1}". Available transitions: ${C.map((R)=>`"${R}"`).join(", ")}`);
                }
                f("end", p, ...l1), this.state = m1, f("enter", m1, ...l1), f("enter", `${p} -> ${m1}`, ...l1);
            },
            onStateTransition (m1, l1, p) {
                return c1("enter", `${m1} -> ${l1}`, p);
            },
            onStateEnter (m1, l1) {
                return c1("enter", m1, l1);
            },
            onStateUpdate (m1, l1) {
                return c1("update", m1, l1);
            },
            onStateDraw (m1, l1) {
                return c1("draw", m1, l1);
            },
            onStateEnd (m1, l1) {
                return c1("end", m1, l1);
            },
            update () {
                g1 || (f("enter", e), g1 = !0), f("update", this.state);
            },
            draw () {
                f("draw", this.state);
            },
            inspect () {
                return this.state;
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Vs, "state");
    function js(e = 1) {
        let n = 0, s = !1;
        return {
            require: [
                "opacity"
            ],
            add () {
                this.opacity = 0;
            },
            update () {
                s || (n += Ue(), this.opacity = $adc7cb3c45508c7c$var$Nt(n, 0, e, 0, 1), n >= e && (this.opacity = 1, s = !0));
            }
        };
    }
    $adc7cb3c45508c7c$var$o(js, "fadeIn");
    function vn(e) {
        V.loaded ? e() : A.events.on("load", e);
    }
    $adc7cb3c45508c7c$var$o(vn, "onLoad");
    function Ns(e, n) {
        A.scenes[e] = n;
    }
    $adc7cb3c45508c7c$var$o(Ns, "scene");
    function ks(e, ...n) {
        if (!A.scenes[e]) throw new Error(`Scene not found: ${e}`);
        A.events.onOnce("frameEnd", ()=>{
            A.events.trigger("sceneLeave", e), U.events.clear(), A.events.clear(), A.objEvents.clear(), [
                ...A.root.children
            ].forEach((s)=>{
                (!s.stay || s.scenesToStay && !s.scenesToStay.includes(e)) && A.root.remove(s);
            }), A.root.clearEvents(), A.cam = {
                pos: null,
                scale: $adc7cb3c45508c7c$var$T(1),
                angle: 0,
                shake: 0,
                transform: new $adc7cb3c45508c7c$var$be
            }, A.scenes[e](...n), r.debug !== !1 && Qn(), r.burp && Zn();
        });
    }
    $adc7cb3c45508c7c$var$o(ks, "go");
    function _s(e) {
        return A.events.on("sceneLeave", e);
    }
    $adc7cb3c45508c7c$var$o(_s, "onSceneLeave");
    function Hs(e, n) {
        try {
            return JSON.parse(window.localStorage[e]);
        } catch  {
            return n ? (nr(e, n), n) : null;
        }
    }
    $adc7cb3c45508c7c$var$o(Hs, "getData");
    function nr(e, n) {
        window.localStorage[e] = JSON.stringify(n);
    }
    $adc7cb3c45508c7c$var$o(nr, "setData");
    function rr(e, ...n) {
        let s = e(ke), i1;
        typeof s == "function" ? i1 = s(...n)(ke) : i1 = s;
        for(let a1 in i1)ke[a1] = i1[a1], r.global !== !1 && (window[a1] = i1[a1]);
        return ke;
    }
    $adc7cb3c45508c7c$var$o(rr, "plug");
    function Vt() {
        return $adc7cb3c45508c7c$var$T(pe() / 2, we() / 2);
    }
    $adc7cb3c45508c7c$var$o(Vt, "center");
    let qs;
    ((O)=>(O[O.None = 0] = "None", O[O.Left = 1] = "Left", O[O.Top = 2] = "Top", O[O.LeftTop = 3] = "LeftTop", O[O.Right = 4] = "Right", O[O.Horizontal = 5] = "Horizontal", O[O.RightTop = 6] = "RightTop", O[O.HorizontalTop = 7] = "HorizontalTop", O[O.Bottom = 8] = "Bottom", O[O.LeftBottom = 9] = "LeftBottom", O[O.Vertical = 10] = "Vertical", O[O.LeftVertical = 11] = "LeftVertical", O[O.RightBottom = 12] = "RightBottom", O[O.HorizontalBottom = 13] = "HorizontalBottom", O[O.RightVertical = 14] = "RightVertical", O[O.All = 15] = "All"))(qs ||= {});
    function sr(e = {}) {
        let n = $adc7cb3c45508c7c$var$T(0), s = e.isObstacle ?? !1, i1 = e.cost ?? 0, a1 = e.edges ?? [], c1 = $adc7cb3c45508c7c$var$o(()=>{
            let g1 = {
                left: 1,
                top: 2,
                right: 4,
                bottom: 8
            };
            return a1.map((m1)=>g1[m1] || 0).reduce((m1, l1)=>m1 | l1, 0);
        }, "getEdgeMask"), f = c1();
        return {
            id: "tile",
            tilePosOffset: e.offset ?? $adc7cb3c45508c7c$var$T(0),
            set tilePos (g){
                let m1 = this.getLevel();
                n = g.clone(), this.pos = $adc7cb3c45508c7c$var$T(this.tilePos.x * m1.tileWidth(), this.tilePos.y * m1.tileHeight()).add(this.tilePosOffset);
            },
            get tilePos () {
                return n;
            },
            set isObstacle (g){
                s !== g && (s = g, this.getLevel().invalidateNavigationMap());
            },
            get isObstacle () {
                return s;
            },
            set cost (g){
                i1 !== g && (i1 = g, this.getLevel().invalidateNavigationMap());
            },
            get cost () {
                return i1;
            },
            set edges (g){
                a1 = g, f = c1(), this.getLevel().invalidateNavigationMap();
            },
            get edges () {
                return a1;
            },
            get edgeMask () {
                return f;
            },
            getLevel () {
                return this.parent;
            },
            moveLeft () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(-1, 0));
            },
            moveRight () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(1, 0));
            },
            moveUp () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(0, -1));
            },
            moveDown () {
                this.tilePos = this.tilePos.add($adc7cb3c45508c7c$var$T(0, 1));
            }
        };
    }
    $adc7cb3c45508c7c$var$o(sr, "tile");
    function $s(e, n) {
        if (!n.tileWidth || !n.tileHeight) throw new Error("Must provide tileWidth and tileHeight.");
        let s = ht([
            Lt(n.pos ?? $adc7cb3c45508c7c$var$T(0))
        ]), i1 = e.length, a1 = 0, c1 = null, f = null, g1 = null, m1 = null, l1 = $adc7cb3c45508c7c$var$o((b)=>b.x + b.y * a1, "tile2Hash"), p = $adc7cb3c45508c7c$var$o((b)=>$adc7cb3c45508c7c$var$T(Math.floor(b % a1), Math.floor(b / a1)), "hash2Tile"), C = $adc7cb3c45508c7c$var$o(()=>{
            c1 = [];
            for (let b of s.children)R(b);
        }, "createSpatialMap"), R = $adc7cb3c45508c7c$var$o((b)=>{
            let P = l1(b.tilePos);
            c1[P] ? c1[P].push(b) : c1[P] = [
                b
            ];
        }, "insertIntoSpatialMap"), G = $adc7cb3c45508c7c$var$o((b)=>{
            let P = l1(b.tilePos);
            if (c1[P]) {
                let D = c1[P].indexOf(b);
                D >= 0 && c1[P].splice(D, 1);
            }
        }, "removeFromSpatialMap"), k = $adc7cb3c45508c7c$var$o(()=>{
            let b = !1;
            for (let P of s.children){
                let D = s.pos2Tile(P.pos);
                (P.tilePos.x != D.x || P.tilePos.y != D.y) && (b = !0, G(P), P.tilePos.x = D.x, P.tilePos.y = D.y, R(P));
            }
            b && s.trigger("spatial_map_changed");
        }, "updateSpatialMap"), M1 = $adc7cb3c45508c7c$var$o(()=>{
            let b = s.getSpatialMap(), P = s.numRows() * s.numColumns();
            f ? f.length = P : f = new Array(P), f.fill(1, 0, P);
            for(let D = 0; D < b.length; D++){
                let F = b[D];
                if (F) {
                    let _ = 0;
                    for (let Y of F)if (Y.isObstacle) {
                        _ = 1 / 0;
                        break;
                    } else _ += Y.cost;
                    f[D] = _ || 1;
                }
            }
        }, "createCostMap"), O = $adc7cb3c45508c7c$var$o(()=>{
            let b = s.getSpatialMap(), P = s.numRows() * s.numColumns();
            g1 ? g1.length = P : g1 = new Array(P), g1.fill(15, 0, P);
            for(let D = 0; D < b.length; D++){
                let F = b[D];
                if (F) {
                    let _ = F.length, Y = 15;
                    for(let se = 0; se < _; se++)Y |= F[se].edgeMask;
                    g1[D] = Y;
                }
            }
        }, "createEdgeMap"), ne = $adc7cb3c45508c7c$var$o(()=>{
            let b = s.numRows() * s.numColumns(), P = $adc7cb3c45508c7c$var$o((F, _)=>{
                let Y = [];
                for(Y.push(F); Y.length > 0;){
                    let se = Y.pop();
                    I(se).forEach((de)=>{
                        m1[de] < 0 && (m1[de] = _, Y.push(de));
                    });
                }
            }, "traverse");
            m1 ? m1.length = b : m1 = new Array(b), m1.fill(-1, 0, b);
            let D = 0;
            for(let F = 0; F < f.length; F++){
                if (m1[F] >= 0) {
                    D++;
                    continue;
                }
                P(F, D), D++;
            }
        }, "createConnectivityMap"), K = $adc7cb3c45508c7c$var$o((b, P)=>f[P], "getCost"), N = $adc7cb3c45508c7c$var$o((b, P)=>{
            let D = p(b), F = p(P);
            return D.dist(F);
        }, "getHeuristic"), I = $adc7cb3c45508c7c$var$o((b, P)=>{
            let D = [], F = Math.floor(b % a1), _ = F > 0 && g1[b] & 1 && f[b - 1] !== 1 / 0, Y = b >= a1 && g1[b] & 2 && f[b - a1] !== 1 / 0, se = F < a1 - 1 && g1[b] & 4 && f[b + 1] !== 1 / 0, de = b < a1 * i1 - a1 - 1 && g1[b] & 8 && f[b + a1] !== 1 / 0;
            return P ? (_ && (Y && D.push(b - a1 - 1), D.push(b - 1), de && D.push(b + a1 - 1)), Y && D.push(b - a1), se && (Y && D.push(b - a1 + 1), D.push(b + 1), de && D.push(b + a1 + 1)), de && D.push(b + a1)) : (_ && D.push(b - 1), Y && D.push(b - a1), se && D.push(b + 1), de && D.push(b + a1)), D;
        }, "getNeighbours"), he = {
            id: "level",
            tileWidth () {
                return n.tileWidth;
            },
            tileHeight () {
                return n.tileHeight;
            },
            spawn (b, ...P) {
                let D = $adc7cb3c45508c7c$var$T(...P), F = (()=>{
                    if (typeof b == "string") {
                        if (n.tiles[b]) {
                            if (typeof n.tiles[b] != "function") throw new Error("Level symbol def must be a function returning a component list");
                            return n.tiles[b](D);
                        } else if (n.wildcardTile) return n.wildcardTile(b, D);
                    } else {
                        if (Array.isArray(b)) return b;
                        throw new Error("Expected a symbol or a component list");
                    }
                })();
                if (!F) return null;
                let _ = !1, Y = !1;
                for (let de of F)de.id === "tile" && (Y = !0), de.id === "pos" && (_ = !0);
                _ || F.push(Lt()), Y || F.push(sr());
                let se = s.add(F);
                return _ && (se.tilePosOffset = se.pos.clone()), se.tilePos = D, c1 && (R(se), this.trigger("spatial_map_changed"), this.trigger("navigation_map_invalid")), se;
            },
            numColumns () {
                return a1;
            },
            numRows () {
                return i1;
            },
            levelWidth () {
                return a1 * this.tileWidth();
            },
            levelHeight () {
                return i1 * this.tileHeight();
            },
            tile2Pos (...b) {
                return $adc7cb3c45508c7c$var$T(...b).scale(this.tileWidth(), this.tileHeight());
            },
            pos2Tile (...b) {
                let P = $adc7cb3c45508c7c$var$T(...b);
                return $adc7cb3c45508c7c$var$T(Math.floor(P.x / this.tileWidth()), Math.floor(P.y / this.tileHeight()));
            },
            getSpatialMap () {
                return c1 || C(), c1;
            },
            onSpatialMapChanged (b) {
                return this.on("spatial_map_changed", b);
            },
            onNavigationMapInvalid (b) {
                return this.on("navigation_map_invalid", b);
            },
            getAt (b) {
                c1 || C();
                let P = l1(b);
                return c1[P] || [];
            },
            update () {
                c1 && k();
            },
            invalidateNavigationMap () {
                f = null, g1 = null, m1 = null;
            },
            onNavigationMapChanged (b) {
                return this.on("navigation_map_changed", b);
            },
            getTilePath (b, P, D = {}) {
                if (f || M1(), g1 || O(), m1 || ne(), b.x < 0 || b.x >= a1 || b.y < 0 || b.y >= i1 || P.x < 0 || P.x >= a1 || P.y < 0 || P.y >= i1) return null;
                let F = l1(b), _ = l1(P);
                if (f[_] === 1 / 0) return null;
                if (F === _) return [];
                if (m1[F] != -1 && m1[F] !== m1[_]) return null;
                let Y = new $adc7cb3c45508c7c$var$kt((Ae, Sn)=>Ae.cost < Sn.cost);
                Y.insert({
                    cost: 0,
                    node: F
                });
                let se = new Map;
                se.set(F, F);
                let de = new Map;
                for(de.set(F, 0); Y.length !== 0;){
                    let Ae = Y.remove()?.node;
                    if (Ae === _) break;
                    let Sn = I(Ae, D.allowDiagonals);
                    for (let _e of Sn){
                        let Cn = (de.get(Ae) || 0) + K(Ae, _e) + N(_e, _);
                        (!de.has(_e) || Cn < de.get(_e)) && (de.set(_e, Cn), Y.insert({
                            cost: Cn,
                            node: _e
                        }), se.set(_e, Ae));
                    }
                }
                let En = [], dt = _, li = p(dt);
                for(En.push(li); dt !== F;){
                    dt = se.get(dt);
                    let Ae = p(dt);
                    En.push(Ae);
                }
                return En.reverse();
            },
            getPath (b, P, D = {}) {
                let F = this.tileWidth(), _ = this.tileHeight(), Y = this.getTilePath(this.pos2Tile(b), this.pos2Tile(P), D);
                return Y ? [
                    b,
                    ...Y.slice(1, -1).map((se)=>se.scale(F, _).add(F / 2, _ / 2)),
                    P
                ] : null;
            }
        };
        return s.use(he), s.onNavigationMapInvalid(()=>{
            s.invalidateNavigationMap(), s.trigger("navigation_map_changed");
        }), e.forEach((b, P)=>{
            let D = b.split("");
            a1 = Math.max(D.length, a1), D.forEach((F, _)=>{
                s.spawn(F, $adc7cb3c45508c7c$var$T(_, P));
            });
        }), s;
    }
    $adc7cb3c45508c7c$var$o($s, "addLevel");
    function zs(e = {}) {
        let n = null, s = null, i1 = null, a1 = null;
        return {
            id: "agent",
            require: [
                "pos",
                "tile"
            ],
            agentSpeed: e.speed ?? 100,
            allowDiagonals: e.allowDiagonals ?? !0,
            getDistanceToTarget () {
                return n ? this.pos.dist(n) : 0;
            },
            getNextLocation () {
                return s && i1 ? s[i1] : null;
            },
            getPath () {
                return s ? s.slice() : null;
            },
            getTarget () {
                return n;
            },
            isNavigationFinished () {
                return s ? i1 === null : !0;
            },
            isTargetReachable () {
                return s !== null;
            },
            isTargetReached () {
                return n ? this.pos.eq(n) : !0;
            },
            setTarget (c1) {
                n = c1, s = this.getLevel().getPath(this.pos, n, {
                    allowDiagonals: this.allowDiagonals
                }), i1 = s ? 0 : null, s ? (a1 || (a1 = this.getLevel().onNavigationMapChanged(()=>{
                    s && i1 !== null && (s = this.getLevel().getPath(this.pos, n, {
                        allowDiagonals: this.allowDiagonals
                    }), i1 = s ? 0 : null, s ? this.trigger("navigation-next", this, s[i1]) : this.trigger("navigation-ended", this));
                }), this.onDestroy(()=>a1.cancel())), this.trigger("navigation-started", this), this.trigger("navigation-next", this, s[i1])) : this.trigger("navigation-ended", this);
            },
            update () {
                if (s && i1 !== null) {
                    if (this.pos.sdist(s[i1]) < 2) {
                        if (i1 === s.length - 1) {
                            this.pos = n.clone(), i1 = null, this.trigger("navigation-ended", this), this.trigger("target-reached", this);
                            return;
                        } else i1++, this.trigger("navigation-next", this, s[i1]);
                    }
                    this.moveTo(s[i1], this.agentSpeed);
                }
            },
            onNavigationStarted (c1) {
                return this.on("navigation-started", c1);
            },
            onNavigationNext (c1) {
                return this.on("navigation-next", c1);
            },
            onNavigationEnded (c1) {
                return this.on("navigation-ended", c1);
            },
            onTargetReached (c1) {
                return this.on("target-reached", c1);
            },
            inspect () {
                return JSON.stringify({
                    target: JSON.stringify(n),
                    path: JSON.stringify(s)
                });
            }
        };
    }
    $adc7cb3c45508c7c$var$o(zs, "agent");
    function Ks(e) {
        let n = U.canvas().captureStream(e), s = re.ctx.createMediaStreamDestination();
        re.masterNode.connect(s);
        let i1 = new MediaRecorder(n), a1 = [];
        return i1.ondataavailable = (c1)=>{
            c1.data.size > 0 && a1.push(c1.data);
        }, i1.onerror = ()=>{
            re.masterNode.disconnect(s), n.getTracks().forEach((c1)=>c1.stop());
        }, i1.start(), {
            resume () {
                i1.resume();
            },
            pause () {
                i1.pause();
            },
            stop () {
                return i1.stop(), re.masterNode.disconnect(s), n.getTracks().forEach((c1)=>c1.stop()), new Promise((c1)=>{
                    i1.onstop = ()=>{
                        c1(new Blob(a1, {
                            type: "video/mp4"
                        }));
                    };
                });
            },
            download (c1 = "kaboom.mp4") {
                this.stop().then((f)=>$adc7cb3c45508c7c$var$Fn(c1, f));
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Ks, "record");
    function Ys() {
        return document.activeElement === U.canvas();
    }
    $adc7cb3c45508c7c$var$o(Ys, "isFocused");
    function Xs(e) {
        e.destroy();
    }
    $adc7cb3c45508c7c$var$o(Xs, "destroy");
    let ht = A.root.add.bind(A.root), Ws = A.root.readd.bind(A.root), Js = A.root.removeAll.bind(A.root), bn = A.root.get.bind(A.root);
    function ir(e = 2, n = 1) {
        let s = 0;
        return {
            id: "boom",
            require: [
                "scale"
            ],
            update () {
                let i1 = Math.sin(s * e) * n;
                i1 < 0 && this.destroy(), this.scale = $adc7cb3c45508c7c$var$T(i1), s += Ue();
            }
        };
    }
    $adc7cb3c45508c7c$var$o(ir, "boom");
    let Qs = Ie(null, $adc7cb3c45508c7c$var$Dr), Zs = Ie(null, $adc7cb3c45508c7c$var$Gr);
    function ei(e, n = {}) {
        let s = ht([
            Lt(e),
            tr()
        ]), i1 = (n.speed || 1) * 5, a1 = n.scale || 1;
        s.add([
            wn(Zs),
            It(0),
            gn("center"),
            ir(i1, a1),
            ...n.comps ?? []
        ]);
        let c1 = s.add([
            wn(Qs),
            It(0),
            gn("center"),
            er(),
            ...n.comps ?? []
        ]);
        return c1.wait(.4 / i1, ()=>c1.use(ir(i1, a1))), c1.onDestroy(()=>s.destroy()), s;
    }
    $adc7cb3c45508c7c$var$o(ei, "addKaboom");
    function or() {
        A.root.update();
    }
    $adc7cb3c45508c7c$var$o(or, "updateFrame");
    class yn {
        static #_ = (()=>{
            $adc7cb3c45508c7c$var$o(this, "Collision");
        })();
        source;
        target;
        displacement;
        resolved = !1;
        constructor(n, s, i1, a1 = !1){
            this.source = n, this.target = s, this.displacement = i1, this.resolved = a1;
        }
        reverse() {
            return new yn(this.target, this.source, this.displacement.scale(-1), this.resolved);
        }
        hasOverlap() {
            return !this.displacement.isZero();
        }
        isLeft() {
            return this.displacement.x > 0;
        }
        isRight() {
            return this.displacement.x < 0;
        }
        isTop() {
            return this.displacement.y > 0;
        }
        isBottom() {
            return this.displacement.y < 0;
        }
        preventResolution() {
            this.resolved = !0;
        }
    }
    function ti() {
        let e = {}, n = r.hashGridSize || $adc7cb3c45508c7c$var$Si, s = new $adc7cb3c45508c7c$var$be, i1 = [];
        function a1(c1) {
            if (i1.push(s.clone()), c1.pos && s.translate(c1.pos), c1.scale && s.scale(c1.scale), c1.angle && s.rotate(c1.angle), c1.transform = s.clone(), c1.c("area") && !c1.paused) {
                let f = c1, m1 = f.worldArea().bbox(), l1 = Math.floor(m1.pos.x / n), p = Math.floor(m1.pos.y / n), C = Math.ceil((m1.pos.x + m1.width) / n), R = Math.ceil((m1.pos.y + m1.height) / n), G = new Set;
                for(let k = l1; k <= C; k++)for(let M1 = p; M1 <= R; M1++)if (!e[k]) e[k] = {}, e[k][M1] = [
                    f
                ];
                else if (!e[k][M1]) e[k][M1] = [
                    f
                ];
                else {
                    let O = e[k][M1];
                    e: for (let ne of O){
                        if (ne.paused || !ne.exists() || G.has(ne.id)) continue;
                        for (let N of f.collisionIgnore)if (ne.is(N)) continue e;
                        for (let N of ne.collisionIgnore)if (f.is(N)) continue e;
                        let K = $adc7cb3c45508c7c$var$xr(f.worldArea(), ne.worldArea());
                        if (K) {
                            let N = new yn(f, ne, K);
                            f.trigger("collideUpdate", ne, N);
                            let I = N.reverse();
                            I.resolved = N.resolved, ne.trigger("collideUpdate", f, I);
                        }
                        G.add(ne.id);
                    }
                    O.push(f);
                }
            }
            c1.children.forEach(a1), s = i1.pop();
        }
        $adc7cb3c45508c7c$var$o(a1, "checkObj"), a1(A.root);
    }
    $adc7cb3c45508c7c$var$o(ti, "checkFrame");
    function ni() {
        let e = A.cam, n = $adc7cb3c45508c7c$var$y.fromAngle($adc7cb3c45508c7c$var$gt(0, 360)).scale(e.shake);
        e.shake = $adc7cb3c45508c7c$var$Se(e.shake, 0, 5 * Ue()), e.transform = new $adc7cb3c45508c7c$var$be().translate(Vt()).scale(e.scale).rotate(e.angle).translate((e.pos ?? Vt()).scale(-1).add(n)), A.root.draw(), z();
    }
    $adc7cb3c45508c7c$var$o(ni, "drawFrame");
    function ri() {
        let e = Ce();
        A.events.numListeners("loading") > 0 ? A.events.trigger("loading", e) : Be(()=>{
            let n = pe() / 2, s = 24, i1 = $adc7cb3c45508c7c$var$T(pe() / 2, we() / 2).sub($adc7cb3c45508c7c$var$T(n / 2, s / 2));
            xe({
                pos: $adc7cb3c45508c7c$var$T(0),
                width: pe(),
                height: we(),
                color: $adc7cb3c45508c7c$var$J(0, 0, 0)
            }), xe({
                pos: i1,
                width: n,
                height: s,
                fill: !1,
                outline: {
                    width: 4
                }
            }), xe({
                pos: i1,
                width: n * e,
                height: s
            });
        });
    }
    $adc7cb3c45508c7c$var$o(ri, "drawLoadScreen");
    function ar(e, n) {
        Be(()=>{
            let s = $adc7cb3c45508c7c$var$T(8);
            E(), Q(e);
            let i1 = je({
                text: n,
                font: $adc7cb3c45508c7c$var$zt,
                size: 16,
                pos: s,
                color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                fixed: !0
            }), a1 = i1.width + s.x * 2, c1 = i1.height + s.x * 2;
            e.x + a1 >= pe() && Q($adc7cb3c45508c7c$var$T(-a1, 0)), e.y + c1 >= we() && Q($adc7cb3c45508c7c$var$T(0, -c1)), xe({
                width: a1,
                height: c1,
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                radius: 4,
                opacity: .8,
                fixed: !0
            }), Ne(i1), L();
        });
    }
    $adc7cb3c45508c7c$var$o(ar, "drawInspectText");
    function si() {
        if (te.inspect) {
            let e = null;
            for (let n of A.root.get("*", {
                recursive: !0
            }))if (n.c("area") && n.isHovering()) {
                e = n;
                break;
            }
            if (A.root.drawInspect(), e) {
                let n = [], s = e.inspect();
                for(let i1 in s)s[i1] ? n.push(`${i1}: ${s[i1]}`) : n.push(`${i1}`);
                ar(Qr(Dt()), n.join(`
`));
            }
            ar($adc7cb3c45508c7c$var$T(8), `FPS: ${te.fps()}`);
        }
        te.paused && Be(()=>{
            E(), Q(pe(), 0), Q(-8, 8);
            let e = 32;
            xe({
                width: e,
                height: e,
                anchor: "topright",
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                opacity: .8,
                radius: 4,
                fixed: !0
            });
            for(let n = 1; n <= 2; n++)xe({
                width: 4,
                height: e * .6,
                anchor: "center",
                pos: $adc7cb3c45508c7c$var$T(-e / 3 * n, e * .5),
                color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                radius: 2,
                fixed: !0
            });
            L();
        }), te.timeScale !== 1 && Be(()=>{
            E(), Q(pe(), we()), Q(-8, -8);
            let e = 8, n = je({
                text: te.timeScale.toFixed(1),
                font: $adc7cb3c45508c7c$var$zt,
                size: 16,
                color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                pos: $adc7cb3c45508c7c$var$T(-e),
                anchor: "botright",
                fixed: !0
            });
            xe({
                width: n.width + e * 2 + e * 4,
                height: n.height + e * 2,
                anchor: "botright",
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                opacity: .8,
                radius: 4,
                fixed: !0
            });
            for(let s = 0; s < 2; s++){
                let i1 = te.timeScale < 1;
                _n({
                    p1: $adc7cb3c45508c7c$var$T(-n.width - e * (i1 ? 2 : 3.5), -e),
                    p2: $adc7cb3c45508c7c$var$T(-n.width - e * (i1 ? 2 : 3.5), -e - n.height),
                    p3: $adc7cb3c45508c7c$var$T(-n.width - e * (i1 ? 3.5 : 2), -e - n.height / 2),
                    pos: $adc7cb3c45508c7c$var$T(-s * e * 1 + (i1 ? -e * .5 : 0), 0),
                    color: $adc7cb3c45508c7c$var$J(255, 255, 255),
                    fixed: !0
                });
            }
            Ne(n), L();
        }), te.curRecording && Be(()=>{
            E(), Q(0, we()), Q(24, -24), Xe({
                radius: 12,
                color: $adc7cb3c45508c7c$var$J(255, 0, 0),
                opacity: $adc7cb3c45508c7c$var$On(0, 1, U.time() * 4),
                fixed: !0
            }), L();
        }), te.showLog && A.logs.length > 0 && Be(()=>{
            E(), Q(0, we()), Q(8, -8);
            let e = 8, n = [];
            for (let i1 of A.logs){
                let a1 = "", c1 = i1.msg instanceof Error ? "error" : "info";
                a1 += `[time]${i1.time.toFixed(2)}[/time]`, a1 += " ", a1 += `[${c1}]${i1.msg?.toString ? i1.msg.toString() : i1.msg}[/${c1}]`, n.push(a1);
            }
            A.logs = A.logs.filter((i1)=>U.time() - i1.time < (r.logTime || $adc7cb3c45508c7c$var$Ti));
            let s = je({
                text: n.join(`
`),
                font: $adc7cb3c45508c7c$var$zt,
                pos: $adc7cb3c45508c7c$var$T(e, -e),
                anchor: "botleft",
                size: 16,
                width: pe() * .6,
                lineSpacing: e / 2,
                fixed: !0,
                styles: {
                    time: {
                        color: $adc7cb3c45508c7c$var$J(127, 127, 127)
                    },
                    info: {
                        color: $adc7cb3c45508c7c$var$J(255, 255, 255)
                    },
                    error: {
                        color: $adc7cb3c45508c7c$var$J(255, 0, 127)
                    }
                }
            });
            xe({
                width: s.width + e * 2,
                height: s.height + e * 2,
                anchor: "botleft",
                color: $adc7cb3c45508c7c$var$J(0, 0, 0),
                radius: 4,
                opacity: .8,
                fixed: !0
            }), Ne(s), L();
        });
    }
    $adc7cb3c45508c7c$var$o(si, "drawDebug"), r.debug !== !1 && Qn(), r.burp && Zn();
    function ii(e) {
        A.events.on("loading", e);
    }
    $adc7cb3c45508c7c$var$o(ii, "onLoading");
    function oi(e) {
        U.onResize(e);
    }
    $adc7cb3c45508c7c$var$o(oi, "onResize");
    function ai(e) {
        A.events.on("error", e);
    }
    $adc7cb3c45508c7c$var$o(ai, "onError");
    function xn(e) {
        re.ctx.suspend(), U.run(()=>{
            Be(()=>{
                let i1 = pe(), a1 = we(), c1 = {
                    size: 36,
                    width: i1 - 64,
                    letterSpacing: 4,
                    lineSpacing: 4,
                    font: $adc7cb3c45508c7c$var$zt,
                    fixed: !0
                };
                xe({
                    width: i1,
                    height: a1,
                    color: $adc7cb3c45508c7c$var$J(0, 0, 255),
                    fixed: !0
                });
                let f = je({
                    ...c1,
                    text: e.name,
                    pos: $adc7cb3c45508c7c$var$T(32),
                    color: $adc7cb3c45508c7c$var$J(255, 128, 0),
                    fixed: !0
                });
                Ne(f), Yn({
                    ...c1,
                    text: e.message,
                    pos: $adc7cb3c45508c7c$var$T(32, 32 + f.height + 16),
                    fixed: !0
                }), L(), A.events.trigger("error", e);
            });
        });
    }
    $adc7cb3c45508c7c$var$o(xn, "handleErr");
    function ui(e) {
        X.push(e);
    }
    $adc7cb3c45508c7c$var$o(ui, "onCleanup");
    function ci() {
        A.events.onOnce("frameEnd", ()=>{
            U.quit();
            for(let n in We)window.removeEventListener(n, We[n]);
            d.clear(d.COLOR_BUFFER_BIT | d.DEPTH_BUFFER_BIT | d.STENCIL_BUFFER_BIT);
            let e = d.getParameter(d.MAX_TEXTURE_IMAGE_UNITS);
            for(let n = 0; n < e; n++)d.activeTexture(d.TEXTURE0 + n), d.bindTexture(d.TEXTURE_2D, null), d.bindTexture(d.TEXTURE_CUBE_MAP, null);
            d.bindBuffer(d.ARRAY_BUFFER, null), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null), d.bindRenderbuffer(d.RENDERBUFFER, null), d.bindFramebuffer(d.FRAMEBUFFER, null), X.forEach((n)=>n()), d.deleteBuffer(v.vbuf), d.deleteBuffer(v.ibuf);
        });
    }
    $adc7cb3c45508c7c$var$o(ci, "quit");
    function Un(e, n, s, i1, a1 = $adc7cb3c45508c7c$var$tt.linear) {
        let c1 = 0, f = [], g1 = mn(()=>{
            c1 += Ue();
            let m1 = Math.min(c1 / s, 1);
            i1($adc7cb3c45508c7c$var$Se(e, n, a1(m1))), m1 === 1 && (g1.cancel(), i1(n), f.forEach((l1)=>l1()));
        });
        return {
            get paused () {
                return g1.paused;
            },
            set paused (m){
                g1.paused = m;
            },
            onEnd (m1) {
                f.push(m1);
            },
            then (m1) {
                return this.onEnd(m1), this;
            },
            cancel () {
                g1.cancel();
            },
            finish () {
                g1.cancel(), i1(n), f.forEach((m1)=>m1());
            }
        };
    }
    $adc7cb3c45508c7c$var$o(Un, "tween");
    let jt = !0;
    U.run(()=>{
        V.loaded || Ce() === 1 && !jt && (V.loaded = !0, A.events.trigger("load")), !V.loaded && r.loadingScreen !== !1 || jt ? (Ge(), ri(), at()) : (te.paused || or(), ti(), Ge(), ni(), r.debug !== !1 && si(), at()), jt && (jt = !1), A.events.trigger("frameEnd");
    });
    function ur() {
        let e = j, n = d.drawingBufferWidth / e, s = d.drawingBufferHeight / e;
        if (U.isFullscreen()) {
            let i1 = window.innerWidth, a1 = window.innerHeight, c1 = i1 / a1, f = n / s;
            if (c1 > f) {
                let g1 = window.innerHeight * f;
                v.viewport = {
                    x: (i1 - g1) / 2,
                    y: 0,
                    width: g1,
                    height: a1
                };
            } else {
                let g1 = window.innerWidth / f;
                v.viewport = {
                    x: 0,
                    y: (a1 - g1) / 2,
                    width: i1,
                    height: g1
                };
            }
            return;
        }
        if (r.letterbox) {
            if (!r.width || !r.height) throw new Error("Letterboxing requires width and height defined.");
            let i1 = n / s, a1 = r.width / r.height;
            if (i1 > a1) {
                let c1 = s * a1, f = (n - c1) / 2;
                v.viewport = {
                    x: f,
                    y: 0,
                    width: c1,
                    height: s
                };
            } else {
                let c1 = n / a1, f = (s - c1) / 2;
                v.viewport = {
                    x: 0,
                    y: f,
                    width: n,
                    height: c1
                };
            }
            return;
        }
        if (r.stretch && (!r.width || !r.height)) throw new Error("Stretching requires width and height defined.");
        v.viewport = {
            x: 0,
            y: 0,
            width: n,
            height: s
        };
    }
    $adc7cb3c45508c7c$var$o(ur, "updateViewport"), U.onHide(()=>{
        r.backgroundAudio || re.ctx.suspend();
    }), U.onShow(()=>{
        r.backgroundAudio || re.ctx.resume();
    }), U.onResize(()=>{
        if (U.isFullscreen()) return;
        let e = r.width && r.height;
        e && !r.stretch && !r.letterbox || (u.width = u.offsetWidth * j, u.height = u.offsetHeight * j, ur(), e || (v.frameBuffer.free(), v.frameBuffer = new De(d.drawingBufferWidth, d.drawingBufferHeight), v.width = d.drawingBufferWidth / j, v.height = d.drawingBufferHeight / j));
    }), ur();
    let ke = {
        VERSION: $adc7cb3c45508c7c$var$xi,
        loadRoot: Yt,
        loadProgress: Ce,
        loadSprite: Ie,
        loadSpriteAtlas: yt,
        loadSound: sn,
        loadBitmapFont: Zt,
        loadFont: Qt,
        loadShader: nn,
        loadShaderURL: rn,
        loadAseprite: tn,
        loadPedit: en,
        loadBean: on,
        loadJSON: Jt,
        load: rt,
        getSprite: Ut,
        getSound: Et,
        getFont: St,
        getBitmapFont: Ct,
        getShader: Tt,
        getAsset: an,
        Asset: ue,
        SpriteData: ce,
        SoundData: ge,
        width: pe,
        height: we,
        center: Vt,
        dt: Ue,
        time: U.time,
        screenshot: U.screenshot,
        record: Ks,
        isFocused: Ys,
        setCursor: U.setCursor,
        getCursor: U.getCursor,
        setCursorLocked: U.setCursorLocked,
        isCursorLocked: U.isCursorLocked,
        setFullscreen: U.setFullscreen,
        isFullscreen: U.isFullscreen,
        isTouchscreen: U.isTouchscreen,
        onLoad: vn,
        onLoading: ii,
        onResize: oi,
        onGamepadConnect: U.onGamepadConnect,
        onGamepadDisconnect: U.onGamepadDisconnect,
        onError: ai,
        onCleanup: ui,
        camPos: Zr,
        camScale: es,
        camRot: ts,
        shake: ns,
        toScreen: Xn,
        toWorld: Wn,
        setGravity: ds,
        getGravity: fs,
        setBackground: ms,
        getBackground: ps,
        getGamepads: U.getGamepads,
        add: ht,
        make: fn,
        destroy: Xs,
        destroyAll: Js,
        get: bn,
        readd: Ws,
        pos: Lt,
        scale: It,
        rotate: gs,
        color: ws,
        opacity: vs,
        anchor: gn,
        area: Ss,
        sprite: wn,
        text: Cs,
        rect: Ts,
        circle: Os,
        uvquad: As,
        outline: Ps,
        body: Ds,
        doubleJump: Gs,
        shader: Fs,
        timer: er,
        fixed: Bs,
        stay: tr,
        health: Ls,
        lifespan: Is,
        z: bs,
        move: xs,
        offscreen: Es,
        follow: ys,
        state: Vs,
        fadeIn: js,
        tile: sr,
        agent: zs,
        on: Le,
        onUpdate: mn,
        onDraw: rs,
        onAdd: pn,
        onDestroy: Jn,
        onClick: as,
        onCollide: ss,
        onCollideUpdate: is,
        onCollideEnd: os,
        onHover: us,
        onHoverUpdate: cs,
        onHoverEnd: ls,
        onKeyDown: U.onKeyDown,
        onKeyPress: U.onKeyPress,
        onKeyPressRepeat: U.onKeyPressRepeat,
        onKeyRelease: U.onKeyRelease,
        onMouseDown: U.onMouseDown,
        onMousePress: U.onMousePress,
        onMouseRelease: U.onMouseRelease,
        onMouseMove: U.onMouseMove,
        onCharInput: U.onCharInput,
        onTouchStart: U.onTouchStart,
        onTouchMove: U.onTouchMove,
        onTouchEnd: U.onTouchEnd,
        onScroll: U.onScroll,
        onHide: U.onHide,
        onShow: U.onShow,
        onGamepadButtonDown: U.onGamepadButtonDown,
        onGamepadButtonPress: U.onGamepadButtonPress,
        onGamepadButtonRelease: U.onGamepadButtonRelease,
        onGamepadStick: U.onGamepadStick,
        mousePos: Dt,
        mouseDeltaPos: U.mouseDeltaPos,
        isKeyDown: U.isKeyDown,
        isKeyPressed: U.isKeyPressed,
        isKeyPressedRepeat: U.isKeyPressedRepeat,
        isKeyReleased: U.isKeyReleased,
        isMouseDown: U.isMouseDown,
        isMousePressed: U.isMousePressed,
        isMouseReleased: U.isMouseReleased,
        isMouseMoved: U.isMouseMoved,
        isGamepadButtonPressed: U.isGamepadButtonPressed,
        isGamepadButtonDown: U.isGamepadButtonDown,
        isGamepadButtonReleased: U.isGamepadButtonReleased,
        charInputted: U.charInputted,
        loop: hs,
        wait: Bt,
        play: Pt,
        volume: Ot,
        burp: Mt,
        audioCtx: re.ctx,
        Timer: $adc7cb3c45508c7c$var$vt,
        Line: $adc7cb3c45508c7c$var$Oe,
        Rect: $adc7cb3c45508c7c$var$le,
        Circle: $adc7cb3c45508c7c$var$pt,
        Polygon: $adc7cb3c45508c7c$var$He,
        Vec2: $adc7cb3c45508c7c$var$y,
        Color: $adc7cb3c45508c7c$var$q,
        Mat4: $adc7cb3c45508c7c$var$be,
        Quad: $adc7cb3c45508c7c$var$ie,
        RNG: $adc7cb3c45508c7c$var$ft,
        rand: $adc7cb3c45508c7c$var$gt,
        randi: $adc7cb3c45508c7c$var$Pn,
        randSeed: $adc7cb3c45508c7c$var$fr,
        vec2: $adc7cb3c45508c7c$var$T,
        rgb: $adc7cb3c45508c7c$var$J,
        hsl2rgb: $adc7cb3c45508c7c$var$dr,
        quad: $adc7cb3c45508c7c$var$oe,
        choose: $adc7cb3c45508c7c$var$pr,
        chance: $adc7cb3c45508c7c$var$mr,
        lerp: $adc7cb3c45508c7c$var$Se,
        tween: Un,
        easings: $adc7cb3c45508c7c$var$tt,
        map: $adc7cb3c45508c7c$var$Nt,
        mapc: $adc7cb3c45508c7c$var$hr,
        wave: $adc7cb3c45508c7c$var$On,
        deg2rad: $adc7cb3c45508c7c$var$Ee,
        rad2deg: $adc7cb3c45508c7c$var$Ze,
        clamp: $adc7cb3c45508c7c$var$Pe,
        testLineLine: $adc7cb3c45508c7c$var$Qe,
        testRectRect: $adc7cb3c45508c7c$var$gr,
        testRectLine: $adc7cb3c45508c7c$var$wr,
        testRectPoint: $adc7cb3c45508c7c$var$mt,
        testCirclePolygon: $adc7cb3c45508c7c$var$yr,
        testLinePoint: $adc7cb3c45508c7c$var$vr,
        testLineCircle: $adc7cb3c45508c7c$var$Mn,
        drawSprite: Ye,
        drawText: Yn,
        formatText: je,
        drawRect: xe,
        drawLine: ut,
        drawLines: kn,
        drawTriangle: _n,
        drawCircle: Xe,
        drawEllipse: Hn,
        drawUVQuad: me,
        drawPolygon: Ve,
        drawFormattedText: Ne,
        drawMasked: Yr,
        drawSubtracted: Xr,
        pushTransform: E,
        popTransform: L,
        pushTranslate: Q,
        pushScale: h,
        pushRotate: x,
        pushMatrix: Rt,
        usePostEffect: Fe,
        debug: te,
        scene: Ns,
        go: ks,
        onSceneLeave: _s,
        addLevel: $s,
        getData: Hs,
        setData: nr,
        download: $adc7cb3c45508c7c$var$_t,
        downloadJSON: $adc7cb3c45508c7c$var$Er,
        downloadText: $adc7cb3c45508c7c$var$Gn,
        downloadBlob: $adc7cb3c45508c7c$var$Fn,
        plug: rr,
        ASCII_CHARS: $adc7cb3c45508c7c$var$Fr,
        canvas: U.canvas(),
        addKaboom: ei,
        LEFT: $adc7cb3c45508c7c$var$y.LEFT,
        RIGHT: $adc7cb3c45508c7c$var$y.RIGHT,
        UP: $adc7cb3c45508c7c$var$y.UP,
        DOWN: $adc7cb3c45508c7c$var$y.DOWN,
        RED: $adc7cb3c45508c7c$var$q.RED,
        GREEN: $adc7cb3c45508c7c$var$q.GREEN,
        BLUE: $adc7cb3c45508c7c$var$q.BLUE,
        YELLOW: $adc7cb3c45508c7c$var$q.YELLOW,
        MAGENTA: $adc7cb3c45508c7c$var$q.MAGENTA,
        CYAN: $adc7cb3c45508c7c$var$q.CYAN,
        WHITE: $adc7cb3c45508c7c$var$q.WHITE,
        BLACK: $adc7cb3c45508c7c$var$q.BLACK,
        quit: ci,
        Event: $adc7cb3c45508c7c$var$ve,
        EventHandler: $adc7cb3c45508c7c$var$Re,
        EventController: $adc7cb3c45508c7c$var$Me
    };
    if (r.plugins && r.plugins.forEach(rr), r.global !== !1) for(let e in ke)window[e] = ke[e];
    return U.canvas().focus(), ke;
}, "default");


const $32f88c4c091b663a$var$k = (0, $adc7cb3c45508c7c$export$2e2bcd8739ae039)({
    scale: 1,
    width: 320,
    height: 572,
    background: [
        0,
        0,
        0
    ],
    letterbox: true
});
var $32f88c4c091b663a$export$2e2bcd8739ae039 = $32f88c4c091b663a$var$k;



function $e0da60760dd83307$export$2e2bcd8739ae039() {
    // k.setGravity(500)
    const player = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).add([
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).sprite("tiles", {
            animSpeed: 0.5,
            frame: 0
        }),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos((0, $32f88c4c091b663a$export$2e2bcd8739ae039).width() * 0.5, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).height() * 0.5),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).scale(1)
    ]);
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyPress("left", ()=>{
        player.scale.x = -1;
        player.play("move");
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyPress("right", ()=>{
        player.scale.x = 1;
        player.play("move");
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyRelease("left", ()=>{
        player.play("idle");
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyRelease("right", ()=>{
        player.play("idle");
    });
// k.add([
//   k.pos(k.width() * 0.5, k.height() * 0.25),
//   k.text('Hello there!'),
//   k.anchor('center'),
//   k.area(),
//   k.body(),
// ])
// k.add([
//   k.rect(k.width(), 50),
//   k.color(255,255,55),
//   k.pos(0, k.height()),
//   k.area(),
//   k.body({ isStatic: true })
// ])
}



function $7b4f29de0a43978c$export$2e2bcd8739ae039() {
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).setGravity(500);
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).add([
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(32, 64, {
            radius: 5
        }),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos((0, $32f88c4c091b663a$export$2e2bcd8739ae039).width() * 0.5, 0),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body()
    ]);
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).add([
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos((0, $32f88c4c091b663a$export$2e2bcd8739ae039).width() * 0.5, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).height() * 0.25),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).text("Hello there!"),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body()
    ]);
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).add([
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect((0, $32f88c4c091b663a$export$2e2bcd8739ae039).width(), 50),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(255, 255, 55),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(0, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).height()),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body({
            isStatic: true
        })
    ]);
}



function $385bcc49ca6af789$export$2e2bcd8739ae039() {
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).add([
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos((0, $32f88c4c091b663a$export$2e2bcd8739ae039).width() * 0.5, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).height() * 0.5),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).text("Hello World!", {
            size: 55,
            align: "center"
        }),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(255, 255, 255),
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center")
    ]);
}



var $ff695783c7d42c0c$exports = {};
var $d9f195cb3938646c$exports = {};
var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


var $6d38303b9c8735ba$exports = {};
var $180b2bc3c0deaf6c$exports = {};
var $f84e62f9db5b9ccd$exports = {};
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$f84e62f9db5b9ccd$exports = $f84e62f9db5b9ccd$var$freeGlobal;


/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $f84e62f9db5b9ccd$exports || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
$180b2bc3c0deaf6c$exports = $180b2bc3c0deaf6c$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $180b2bc3c0deaf6c$exports.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;


var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, "") : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;



var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $180b2bc3c0deaf6c$exports.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($f9ff2e983beb6b86$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $f9ff2e983beb6b86$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;



/** Error message constants. */ var $ff695783c7d42c0c$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ff695783c7d42c0c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($ff695783c7d42c0c$var$FUNC_ERROR_TEXT);
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $d9f195cb3938646c$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$ff695783c7d42c0c$exports = $ff695783c7d42c0c$var$throttle;


function $b4cc08800d41730c$export$2e2bcd8739ae039() {
    let isDragging = false;
    let dragStartPos = null;
    const level = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).addLevel([
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------",
        "--------------------||--------------------"
    ], {
        tileWidth: 32,
        tileHeight: 16,
        // pos: k.vec2(k.width() / 4, k.height() / 4),
        tiles: {
            "-": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(32, 16),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).outline(0.5),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(0, 255, 150)
                ],
            "|": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(32, 16),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(192, 192, 192)
                ]
        }
    });
    function screenToWorld(screenPos) {
        const camSize = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).vec2((0, $32f88c4c091b663a$export$2e2bcd8739ae039).width(), (0, $32f88c4c091b663a$export$2e2bcd8739ae039).height()).scale(1 / (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camScale().x); // Assuming uniform scale
        const topLeftWorld = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos().sub(camSize.scale(0.5));
        return screenPos.scale(1 / (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camScale().x).add(topLeftWorld);
    }
    function zoomCamera(dir, screenPos) {
        console.log(dir);
        const worldPosBeforeZoom = screenToWorld(screenPos);
        const oldScale = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camScale().x; // Assuming uniform scale
        const scaleFactor = dir.y > 0 ? 1.2 : 0.8;
        const newScale = oldScale * scaleFactor;
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camScale((0, $32f88c4c091b663a$export$2e2bcd8739ae039).vec2(newScale));
        const worldPosAfterZoom = screenToWorld(screenPos);
        const diffX = worldPosAfterZoom.x - worldPosBeforeZoom.x;
        const diffY = worldPosAfterZoom.y - worldPosBeforeZoom.y;
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos((0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos().x - diffX, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos().y - diffY);
    }
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onScroll((0, (/*@__PURE__*/$parcel$interopDefault($ff695783c7d42c0c$exports)))((dir)=>{
        zoomCamera(dir, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).mousePos());
    }, 50));
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onMouseDown(()=>{
        isDragging = true;
        dragStartPos = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).mousePos().clone();
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onMouseMove(()=>{
        if (isDragging) {
            const dragCurrentPos = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).mousePos();
            const diff = dragStartPos.sub(dragCurrentPos).scale(1 / (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camScale().x); // Assuming uniform scaling
            (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos((0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos().add(diff));
            dragStartPos = dragCurrentPos; // Update starting position for next frame
        }
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onMouseRelease(()=>{
        isDragging = false;
    });
// k.onScroll((e) => {
//   const zoomFactor = e.y > 0 ? 1 - zoomSpeed : 1 + zoomSpeed;
//   const newScale = k.clamp(k.camScale().y * zoomFactor, minScale, maxScale);
//   // Calculate the position adjustment to maintain the center point
//   const oldCenter = k.camPos().scale(1 / k.camScale().y);
//   const newCenter = k.mousePos().scale(1 / newScale);
//   const deltaCenter = newCenter.sub(oldCenter);
//   // console.log(newScale)
//   // k.camScale(k.vec2(newScale));
//   // k.camPos(k.camPos().add(deltaCenter.scale(newScale)))
//   currentScale = newScale;
//   currentPos = currentPos.add(deltaCenter.scale(newScale));
//   k.camScale(k.vec2(currentScale));
//   k.camPos(currentPos);
// });
}



function $c026c14036fc47e6$export$2e2bcd8739ae039() {
    const level = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).addLevel([
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "                                          ",
        "=========================================="
    ], {
        tileWidth: 16,
        tileHeight: 16,
        tiles: {
            "=": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(16, 16),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(0, 255, 150)
                ]
        }
    });
}



var $4d2b8e2a6e96b56b$exports = {};

$4d2b8e2a6e96b56b$exports = new URL((parcelRequire("27Lyk")).resolve("2hk81"), import.meta.url).toString();


var $4fc2beb8d026bd76$exports = {};

$4fc2beb8d026bd76$exports = new URL((parcelRequire("27Lyk")).resolve("7CSHk"), import.meta.url).toString();


function $16324ab17d922d13$export$2e2bcd8739ae039() {
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).loadSprite("bean", (0, (/*@__PURE__*/$parcel$interopDefault($4d2b8e2a6e96b56b$exports))));
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).loadSprite("bean", (0, (/*@__PURE__*/$parcel$interopDefault($4d2b8e2a6e96b56b$exports))));
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).loadSpriteAtlas((0, (/*@__PURE__*/$parcel$interopDefault($4fc2beb8d026bd76$exports))), {
        pacman: {
            x: 0,
            y: 0,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                idle: {
                    from: 2,
                    to: 2
                },
                run: {
                    from: 0,
                    to: 2,
                    speed: 10,
                    loop: true
                }
            }
        },
        inky: {
            x: 0,
            y: 55,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                idle: {
                    from: 0,
                    to: 1,
                    loop: true,
                    speed: 5
                },
                run: {
                    from: 0,
                    to: 7,
                    speed: 5,
                    loop: true
                }
            }
        },
        blinky: {
            x: 0,
            y: 110,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                idle: {
                    from: 0,
                    to: 7,
                    loop: true,
                    speed: 5
                },
                run: {
                    from: 0,
                    to: 7,
                    speed: 5,
                    loop: true
                }
            }
        },
        pinky: {
            x: 0,
            y: 165,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                idle: {
                    from: 0,
                    to: 7,
                    loop: true,
                    speed: 5
                },
                run: {
                    from: 0,
                    to: 7,
                    speed: 5,
                    loop: true
                }
            }
        },
        clyde: {
            x: 0,
            y: 220,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                idle: {
                    from: 0,
                    to: 7,
                    loop: true,
                    speed: 5
                },
                run: {
                    from: 0,
                    to: 7,
                    speed: 5,
                    loop: true
                }
            }
        },
        cherry: {
            x: 0,
            y: 452,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                idle: {
                    from: 0,
                    to: 0
                }
            }
        },
        vulnerable: {
            x: 0,
            y: 387,
            width: 512,
            height: 512,
            sliceX: 9,
            sliceY: 9,
            anims: {
                move: {
                    from: 0,
                    to: 7,
                    loop: true,
                    speed: 8
                }
            }
        }
    });
    const TILE_WIDTH = 24;
    const TILE_HEIGHT = TILE_WIDTH;
    const addGhosts = (symbols, tags)=>{
        return tags.reduce((prev, tag, idx)=>({
                ...prev,
                [symbols[idx]]: ()=>[
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).sprite(tag, {
                            anim: "idle",
                            width: TILE_WIDTH,
                            height: TILE_HEIGHT
                        }),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_WIDTH / 2),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({}),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).z(1),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).agent({
                            speed: (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rand(50, 100),
                            allowDiagonals: true
                        }),
                        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).state("move", [
                            "move",
                            "vulnerable"
                        ]),
                        tag,
                        "ghost",
                        {
                            vulnerable: false
                        }
                    ]
            }), {});
    };
    const level = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).addLevel(// [
    //   "---------------------",
    //   "|.........|.........|",
    //   "|.||.||||.|.||||.||.|",
    //   "|...................|",
    //   "|.||.|.|||||||.|.||.|",
    //   "|....|...|$|...|....|",
    //   "||||.||| | | |||.||||",
    //   "   |.|         |.|   ",
    //   "||||.| |||+||| |.||||",
    //   "    .  |21 34|  .    ",
    //   "||||.| ||||||| |.||||",
    //   "   |.|         |.|   ",
    //   "||||.| ||||||| |.||||",
    //   "|.........|.........|",
    //   "|.||.|||||||||||.||.|",
    //   "|..|......@......|..|",
    //   "||.|.|.|||||||.|.|.||",
    //   "|....|....|....|....|",
    //   "|.|||||||.|.|||||||.|",
    //   "|...................|",
    //   "---------------------",
    // ],
    [
        "-----------------------",
        "|@...................||",
        "|.|||.|||.|||.|./.||..|",
        "|.|$..| |.|...|./.|1|.|",
        "|.|||.|||.|||.|./.|2+.|",
        "|...|.|...|...|...|3|.|",
        "|.|||.|./.|||.|||.||..|",
        "|......./............||",
        "-----------------------"
    ], {
        tileWidth: TILE_WIDTH,
        tileHeight: TILE_HEIGHT,
        // pos: k.vec2(0, 0),
        tiles: {
            "@": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).sprite("pacman", {
                        anim: "idle",
                        width: TILE_HEIGHT,
                        height: TILE_HEIGHT
                    }),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_WIDTH / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body(),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({}),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).z(1),
                    "player",
                    {
                        direction: (0, $32f88c4c091b663a$export$2e2bcd8739ae039).vec2(0, 0),
                        nextDirection: null
                    }
                ],
            ...addGhosts([
                1,
                2,
                3,
                4
            ], [
                "inky",
                "blinky",
                "pinky",
                "clyde"
            ]),
            $: ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).sprite("cherry", {
                        anim: "idle",
                        width: TILE_HEIGHT - 5,
                        height: TILE_HEIGHT - 5
                    }),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_HEIGHT / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({}),
                    "fruit"
                ],
            "-": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_WIDTH / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(TILE_WIDTH, TILE_HEIGHT),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(0, 0, 255),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body({
                        isStatic: true
                    }),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({
                        isObstacle: true
                    }),
                    "wall"
                ],
            "|": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_WIDTH / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(TILE_WIDTH, TILE_HEIGHT),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(0, 0, 255),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body({
                        isStatic: true
                    }),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({
                        isObstacle: true
                    }),
                    "wall"
                ],
            "/": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_WIDTH / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(TILE_WIDTH, TILE_HEIGHT),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).outline(1, (0, $32f88c4c091b663a$export$2e2bcd8739ae039).BLUE),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(0, 0, 0),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).body({
                        isStatic: true
                    }),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({
                        isObstacle: true
                    }),
                    "wall"
                ],
            "+": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).rect(TILE_WIDTH, TILE_HEIGHT),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(0, 100, 255),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).tile({})
                ],
            ".": ()=>[
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).anchor("center"),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_WIDTH / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).circle(3),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).pos(TILE_WIDTH / 2, TILE_HEIGHT / 2),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).color(155, 175, 50),
                    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).area(),
                    "pill"
                ]
        }
    });
    // const scoreLabel = level.add([
    //   k.text(0),
    //   k.pos(530, 12),
    //   {
    //     value: 0,
    //   },
    // ]);
    const player = level.get("player")[0];
    const walls = level.get("wall");
    const ghosts = level.get("ghost");
    const fruits = level.get("fruit");
    const SPEED = 60;
    const moveGhosts = async ()=>{
        await (0, $32f88c4c091b663a$export$2e2bcd8739ae039).wait(5);
        ghosts.forEach((ghost, idx)=>{
            (0, $32f88c4c091b663a$export$2e2bcd8739ae039).wait(idx * 6, ()=>{
                ghost.setTarget(player.pos);
            });
        });
        moveGhosts();
    };
    moveGhosts();
    // k.onUpdate('ghost', (ghost) => {
    //   if(ghost.vulnerable) {
    //     console.log('asdasd')
    //   }
    // })
    player.onPhysicsResolve(()=>{
        // Set the viewport center to player.pos
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos(player.worldPos());
    });
    player.onUpdate(()=>{
        (0, $32f88c4c091b663a$export$2e2bcd8739ae039).camPos(player.worldPos());
        if (player.nextDirection) {
            const nextPos = player.pos.add(player.nextDirection.scale(2));
            if (!hasCollision(nextPos)) {
                player.play("run");
                player.direction = player.nextDirection;
                player.nextDirection = null;
                updatePacmanRotation();
            } else player.play("idle");
        }
        player.pos = player.pos.add(player.direction.scale(2));
    });
    player.onCollide("pill", (e)=>{
        e.destroy();
    // scoreLabel.value += 1;
    // scoreLabel.text = scoreLabel.value;
    });
    player.onCollide("fruit", (e)=>{
        e.destroy();
        ghosts.forEach((ghost)=>{
            ghost.vulnerable = true;
            ghost.enterState("vulnerable");
        });
    });
    player.onCollide("ghost", (ghost)=>{
        if (!ghost.vulnerable) {
            (0, $32f88c4c091b663a$export$2e2bcd8739ae039).addKaboom(player.pos);
            player.pos = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).vec2(15, 15);
            player.direction = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).vec2(0, 0);
            player.nextDirection = null;
            player.play("idle");
            player.angle = 0;
        } else ghost.destroy();
    });
    ghosts.forEach((ghost)=>{
        ghost.onStateEnter("vulnerable", ()=>{
            // console.log('asdasd')
            ghost.use((0, $32f88c4c091b663a$export$2e2bcd8739ae039).sprite("vulnerable", {
                anim: "move",
                width: TILE_HEIGHT,
                height: TILE_HEIGHT
            }));
        });
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("a", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).LEFT;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("d", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).RIGHT;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("w", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).UP;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("s", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).DOWN;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("left", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).LEFT;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("right", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).RIGHT;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("up", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).UP;
    });
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).onKeyDown("down", ()=>{
        player.nextDirection = (0, $32f88c4c091b663a$export$2e2bcd8739ae039).DOWN;
    });
    // k.debug.inspect = true;
    function hasCollision(pos) {
        return walls.some((wall)=>rectRect(pos, wall.pos, player.width, player.height, wall.width, wall.height));
    }
    function rectRect(pos1, pos2, width1, height1, width2, height2) {
        return pos1.x < pos2.x + width2 && pos1.x + width1 > pos2.x && pos1.y < pos2.y + height2 && pos1.y + height1 > pos2.y;
    }
    function updatePacmanRotation() {
        if (player.direction.x > 0) player.angle = 0;
        else if (player.direction.x < 0) player.angle = 180;
        else if (player.direction.y > 0) player.angle = 90;
        else if (player.direction.y < 0) player.angle = -90;
    }
}



(0, $32f88c4c091b663a$export$2e2bcd8739ae039).loadSprite("tiles", (0, (/*@__PURE__*/$parcel$interopDefault($4fc2beb8d026bd76$exports))), {
    sliceX: 9,
    sliceY: 9,
    anims: {
        idle: {
            from: 0,
            to: 0
        },
        move: {
            from: 0,
            to: 2,
            loop: true
        }
    }
});
(0, $32f88c4c091b663a$export$2e2bcd8739ae039).scene("hello-world", (0, $385bcc49ca6af789$export$2e2bcd8739ae039));
(0, $32f88c4c091b663a$export$2e2bcd8739ae039).scene("collisions", (0, $7b4f29de0a43978c$export$2e2bcd8739ae039));
(0, $32f88c4c091b663a$export$2e2bcd8739ae039).scene("animations", (0, $e0da60760dd83307$export$2e2bcd8739ae039));
(0, $32f88c4c091b663a$export$2e2bcd8739ae039).scene("zooming-and-panning", (0, $b4cc08800d41730c$export$2e2bcd8739ae039));
(0, $32f88c4c091b663a$export$2e2bcd8739ae039).scene("level", (0, $c026c14036fc47e6$export$2e2bcd8739ae039));
(0, $32f88c4c091b663a$export$2e2bcd8739ae039).scene("pacman", (0, $16324ab17d922d13$export$2e2bcd8739ae039));
function $ad2bcec7a0192558$var$start() {
    (0, $32f88c4c091b663a$export$2e2bcd8739ae039).go("pacman");
}
$ad2bcec7a0192558$var$start();


//# sourceMappingURL=index.1421b97f.js.map
